import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';
import { BookedTrip, Flight, PassengerFlightInfo, PaymentMethod, Payment, Passenger } from '@ibe/models';
import { SidebarService, ModalService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { takeWhile, map, take, concatMapTo } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import * as UserActions from '@ibe/store/actions/user.actions';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import * as BookingStepsActions from '@ibe/store/actions/booking-steps.actions';
import * as PromoVoucherActions from '@ibe/store/actions/promo-vouchers.actions';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import { PaymentPageComponent } from './payment-page.component';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { BookingStep } from '@ibe/models/ui';
import { IfStmt } from '@angular/compiler';
import { INDRAPaymentPaybyrdModalComponent } from '@ibe.components/shared/payment-paybyrd-modal/payment-paybyrd-modal.component';

import * as _ from 'lodash';
import { DataUserPayment, INDRAPaymentMethodFees, INDRAPaymentMethodFops } from '@ibe.models/payment_method.model';
import { BrowserInfo } from '@ibe.models/payment_creditcard.model';
import { INDRABookedTripDetails } from '@ibe.models/booked-trip-details.indra.model.lib';
import { INDRAPax } from '@ibe.models/pax.indra.model.lib';
import { INDRAFlight } from '@ibe.models/flights.indra.model.lib';
import { INDRATotalFlightPrice, INDRAFlightPriceSummary } from '@ibe.models/flight-price.model.indra.lib';

import { INDRALoginModalComponent } from '@ibe.components/shared/login-modal/login-modal.indra.component';
import { INDRAPaymentComponent } from '@ibe.components/shared/payment/payment.indra.component';
import { INDRAPaymentAlertComponent } from '@ibe.components/shared/payment-alert/payment-alert.indra.component';
import { INDRACybersourceModalComponent } from '@ibe.components/shared/cybersource-modal/cybersource-modal.indra.component';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';
import { INDRABookingPaymentService } from '@ibe.services/booking-payment.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRAObservatoryService } from '@ibe.services/observatory.indra.service';
import { CybersourceModalService } from '@ibe.services/cybersource-modal.service';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';

import {
	SESSION_VAR_KEY_PAYMENT_SESSION_ID,
	SESSION_VAR_KEY_MARKET,
	COUNTRY_CODE_USA,
	PAYMENT_FLOW_BOOKING,
	PAYMENT_CC_TYPE_OCP,
	PAYMENT_CC_TYPE_STORE_FOR_OCP,
	URL_PAYMENT_PAYPAL_CAPTURE_ORDER_OCP,
	PAYPAL_PAYMENT_RESULT,
	PAYMENT_METHOD_PAYPAL,
	ANCILLARY_PRODUCT_SEAT,
	ANCILLARY_PRODUCT_MEAL,
	COOKIES_VAR_KEY_PASSENGER_DETAILS,
	COOKIES_VAR_KEY_PASSENGER_CONTACT_DETAILS,
	COUNTRY_CODE_UNITED_KINGDOM,
	PAX_TYPE_INFANT_CODE,
	PAX_TYPE_CHILD_CODE,
	TRIP_TYPE_MULTICITY_CODE,
	PAX_TYPE_YOUNG_ADULT_CODE,
	PRP_PAYMENT_RESULT,
	PAYMENT_RESULT,
	SESSION_VAR_KEY_CURRENCY,
	COUNTRY_CODE_BRAZIL,
	COUNTRY_CODE_EGYPT,
	COUNTRY_CODE_CHINA,
	COUNTRY_CODE_TURKEY,
	COUNTRY_CODE_CANADA,
	PAYPAL_CLIENT_ID,
	PAYPAL_FLOW_ID,
	PAYPAL_CODE_BLOCK_URL,
	PAYPAL_FNS_PARAMS,
	TAP_MILES_AND_GO_GOLD,
	TAP_MILES_AND_GO_SILVER,
	TAP_MILES_AND_GO_MILES,
	TAP_MILES_AND_GO_NAVIGATOR,
	DISCOUNT_AMOUNT_TYPE_FIXED,
	DISCOUNT_STATUS_ACTIVE,
	SESSION_VAR_KEY_LANGUAGE,
	DEFAULT_LANGUAGE,
	DEFAULT_MARKET,
	PAYMENT_NOTIFICATION_ERROR_CODE_MAX_PAYMENT_ATTEMPT,
	SPECIAL_CASE_MARKET_LANGUAGE_MAP,
	UPGRADE_ACCOUNT_SIDEBAR_SOURCE_SLIDER_AND_EXTRAS,
	COUNTRY_CODE_PORTUGAL,
	AWARD_FLOW_MARKETS,
	EMPTY_SPACE,
	PAX_TYPE_SPONSOR,
	PAX_TYPE_ADULT_CODE,
	DISCOUNT_AMOUNT_TYPE_PERCENTAGE,
	DISCOUNT_APPLY_TO_TOTAL,
	DISCOUNT_TYPE_PROMOCODE,
	DISCOUNT_TYPE_VOUCHER,
	DEFAULT_SESSION_EXTEND_INTERVAL_IN_SECONDS,
	PAYMENT_METHOD_CARDLESS,
	ANCILLARY_PRODUCT_PACKS,
	EXTRAS_ANCILLARY_CARBON_OFFSET,
    COUNTRY_CODE_IRELAND,
} from '@ibe.config';

import { INDRAMilesService } from '@ibe.services/miles.indra.service';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import { CookieService } from 'ngx-cookie-service';
import * as fromPassengerStore from '@ibe.components/shared/sidebar-views/passengers-details/_store';
import { RouteTrip } from '@ibe/store/states/mini-ibe.indra.state';
import { INDRABFMAvailablePassengerTypeRequestParam, INDRABFMAvailablePassengerTypeResponse } from '@ibe.models/passenger.model.indra.lib';
import { INDRAPassengerTypeService } from '@ibe.services/passenger-type.indra.service';
import * as moment from 'moment';
import * as OptionsBarActions from '@ibe/store/actions/options-bar.actions';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import { INDRAGoogleAnalyticsService, EVENT_BOOKING_CREATION_STEP_NO, EVENT_ACTION_PURCHASE } from '@ibe.services/google.analytics.indra.service';
import { INDRAPrice } from '@ibe.models/booking.fare.indra.model.lib';
import { INDRALanguageMarketService } from '@ibe.services/language-market-indra.service';
import * as MilesBarActions from '@ibe/store/actions/miles-bar.actions';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import * as PromoVouchersActions from '../../../../store/actions/promo-vouchers.actions';
import * as ModalActions from '../../../../store/actions/modal.actions';
//import { LoadingPaybyrdComponent } from '../../shared/loading/loadingPaybyrd.component.ts';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { TimeoutSvcService } from '@ibe.services/timeout-svc.service';
import { Location } from '@angular/common';
import { INDRADiscount } from '@ibe.models/promocode-vouchers.model.lib';
import { INDRADiscountService } from '@ibe.services/discount.indra.service';
import { FrequentFlyerIndraService } from '@ibe.services/frequent-flyer-indra.service';
import { BeneficiaryIndraService } from '@ibe.services/beneficiary-indra.service';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { INDRAMilesSliderControlComponent } from '../payment-miles/miles-slider-control/miles-slider-control.indra.component';
import { INDRAParallelService } from '@ibe.services/parallel.indra.service';
import { INDRAPaymentAdyenModalComponent } from '@ibe.components/shared/payment-adyen-modal/payment-adyen-modal.component';
import { INDRATotalAmountSummaryComponent } from '@ibe.components/shared/total-amount-summary/total-amount-summary.indra.component';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';

export class INDRACardIntent {
	constructor(public num_card: string, public intent: number) { }
}

@Component({
	selector: 'app-payment-page',
	templateUrl: './payment-page.indra.component.html',
	styleUrls: ['./payment-page.component.scss'],
	providers: [INDRACurrencyPipe]
})
export class INDRAPaymentPageComponent extends PaymentPageComponent
	implements OnInit, OnDestroy {

	// Host Listener for warning when leaving website	
	// @HostListener('window:beforeunload', ['$event'])
	// INDRA_unloadNotification(event: any): void {
	// 	if (!this.modalService.isOpen.getValue()) {
	// 		const confirmed = window.confirm();
	// 		if (!confirmed) {
	// 			event.returnValue = true;
	// 		}
	// 	}
	// }

	@ViewChild('passengersSection', { read: ElementRef }) $passengersSection: ElementRef;
	passengersInfo: any;

	@ViewChild(INDRAMilesSliderControlComponent) sliderComponent: INDRAMilesSliderControlComponent;

	@ViewChild(INDRATotalAmountSummaryComponent) amountSummary: INDRATotalAmountSummaryComponent;

	formRange: FormGroup = new FormGroup({
		sliderControl: new FormControl(0)
	});

	booked_trip: INDRABookedTripDetails;
	tripType: string;
	passengers: INDRAPax[];

	isAlive = true;
	hasStopover: boolean = false;

	flights: INDRAFlight[] = [];
	trip_pnr = '';
	isBookedTripLoaded = false;
	isBack: boolean;
	triedToPay: boolean = false;

	checkoutUrl = '';
	showFillFirstAlert = false;
	showFillFirstAlertTimeout;

	scrollToStepSettimeout;

	backVisible: boolean = true;

	extrasAdded: any = [];

	isDUPE: boolean = false;
	hasPartnerExtras = false;
	haveFlighPricesChanged: boolean = false; // should be set to true when flight prices have changed (i.e. when there is price change due to pax tier level)
	hasHotelRoom: boolean = false;

	isScreenMobile$: Observable<boolean> = this.store.select(fromStore.isScreenMobile);
	isScreenMobile: boolean;

	loading$: Observable<boolean> = this.store.select(fromStore.getAncillaryToPayWithMilesLoading);

	confirmModal$: Observable<string> = this.store.select(fromStore.getConfirmModalConfirm);
	confirmModal: string;

	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	bookedTrip: BookedTrip;

	market$: Observable<any> = this.store.select(fromStore.getUserMarket);
	market: string;

	userInfo$: Observable<any> = this.store.select(fromStore.getUserInfo);
	userInfo: any;
	userData: any;

	ancillaries$: Observable<Array<Object>> = this.store.select(fromStore.getAncillariesAddedToPayWithMiles);
	ancillaries = [];

	bookedTripDiscounts: Array<any> = [];
	hasMilesGoDiscount: boolean = false;
	applyMilesGoDiscount: boolean = false;
	hasDiscounts: boolean = false;

	isNavigating: boolean = false;

	promoCodesAndVoucher$: Observable<Array<any>> = this.store.select(fromStore.getSelectedPromoVouchers);
	promoCodesAndVoucher: Array<any> = [];
	completePromocodeAndVoucherList: Array<any> = [];

	formAdd: FormGroup = new FormGroup({
		promocode: new FormControl(null, Validators.required),
		promocodeemail: new FormControl(null, Validators.required),
		promocodepin: new FormControl(null, Validators.required),
		quantity: new FormControl(null, Validators.required)
	});

	
	INDRA_hasErrors: any = false;
	INDRA_hasPinErrors: any = false;
	INDRA_hasQErrors: any = false;
	INDRA_successMessage = '';
	showSuccessMessage = false;

	validatingVoucherPromocode = false;
	showFormAdd = true;

	discounts: INDRADiscount[] = [];
	discountList: INDRADiscount[] = [];

	promocodeSubscription: Subscription;
	voucherSubscription: Subscription;
	voucherCodeSubscription: Subscription;
	showError: boolean = false;
	loading: boolean = false;
	removePromocodeSubscription: Subscription;

	FIXED_DISCOUNT = DISCOUNT_AMOUNT_TYPE_FIXED;
	PERCENTAGE_DISCOUNT = DISCOUNT_AMOUNT_TYPE_PERCENTAGE;
  isAfterCreatePNR = false;

	public inputCode: string = '';
	public inputEmail: string = '';
	public isVoucher: boolean = false;
	public isPartialSelected: boolean = false;
	public isTotalAmountSelected: boolean = false;
	error_width = 0;
	isQuantityStage: boolean = false;
	newDiscountList: any;
	currentVoucherValue: any;
	currentVoucherCurrency: any;
	hasMilesDiscount: boolean = false;
	showCurrentVoucher: any;
	showDiscountButton: boolean = false;
	allowPartialBalance: boolean = false;
	showVoucherPin: boolean = false;

	weakFlightsDiscount$: Observable<number> = this.store.select(fromStore.getWeakFlightAmt);
	weakFlightsDiscount: any;

	bookAwardFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
	bookAwardFlights: boolean;

	starAllianceFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterStarAllianceFlights);
	hasStarAllianceFlights: boolean;

	bookedTripExtras$: Observable<Array<any>> = this.store.select(fromStore.getSelectedBookedTripExtras);
	bookedTripExtras: Array<any> = [];
	bookedTripExtrasCurrency: string;
	selectedHotels: Array<any> = [];

	selectedPassengers$: any = this.passengerStore.select(fromPassengerStore.getSelectedPassengers);
	selectedPassengers;

	bookAwardFlightChanges$: Observable<any> = combineLatest(
		this.bookedTrip$,
		this.bookAwardFlights$
	);

	bookingSteps$: Observable<Array<BookingStep>> = this.store.select(fromStore.getSelectedBookingSteps);
	bookingSteps: Array<BookingStep> = [];

	private isDesktop$: Observable<boolean> = this.store.select(fromStore.isScreenDesktop);
	isDesktop: boolean;
	screen: any;

	timeToThink_to_booking$: Observable<any> = this.store.select(fromStore.getSelectedBookedTripTTTCompletionDetails);
	isTTTBookingForCompletion: boolean = false;
	isDupeCompletion: boolean = false;

	booking_trip: any;
	confirmDialogService: any;
	confirmDialogIsOpen: boolean;
	isTimeToThinkLoaded: boolean;
	differentTTTMarket: boolean = false;

	extras = [];
	environment = environment;
	$elementBody = document.body;
	travelHazmat = false;
	visaToUSA = false;
	checkedMarket = false;
	chkboxCount = 0;
	showSignUp = false;

	marketPaymentMethods: Array<PaymentMethod> = null;
	disabledPaymentMethods: Array<PaymentMethod> = [];
	disabledTooltipMessage: string = null;

	private numberOfBeneficiaries: number;
	private paxSalutations: any[];
	private beneficiaryList: any[];
	private beneficiaryNames: any[] = [];
	beneficiaryListSubscription: Subscription;
	benListNewNames: INDRAPax[] = [];
	benListNewItems = false;
	beneficiaryFlag = false;

	confirmedPassengersAndContacts: boolean = false;
	arePaymentMethodsLoaded: boolean = false;
	loadingPaymentMethodsIcons: Array<string> = [
		'money_related--discount',
		'money_related--funds',
		'money_related--health_insurance_check',
		'money_related--payment',
		'loyalty--miles',
		'tickets_related--ticket',
		'ancillaries--lounge',
		'booking--plane-flying',
		'booking--shopping_cart',
		'check-in--check-in',
		'interface--language',
		'digital_universe--wifi',
		'plane_related--eco-friendly',
		'plane_related--world_tracker'
	];

	progressiveSteps = [
		{ step: 1, status: false, label: 'bookingPayment.text.yourAccount', label_active: 'bookingPayment.text.yourAccount' },
		{ step: 2, status: false, label: 'bookingPayment.text.passengerDetails', label_active: 'bookingPayment.text.addPassengerDetails' },
		{ step: 3, status: false, label: 'bookingPayment.text.contactDetails', label_active: 'bookingPayment.text.addContactDetails' },
		{ step: 4, status: false, label: 'bookingPayment.text.paymentDetails', label_active: 'bookingPayment.text.pay' }
	];

	formChooseLogin: FormGroup = new FormGroup({
		login: new FormControl('yes')
	});

	bookedFlightPointsTotal = 0;
	items_summary = [];
	isTTTPaymentPage: boolean = false;
	isBookingPaymentPage: boolean = false;
	isTTTpayment: boolean = false;
	isPaymentPageRedirect: boolean = false;
	priceChange: boolean = false;
	showVisaBox: boolean = false;
	showHazmatBox: boolean = false;
	userLoggedIn: boolean = false;
	hasPNRCreationError: boolean = false;
	hasPaymentStepError: boolean = false;
	canGo: boolean = true;
	isZeroCashPayment: boolean = false;

	isUSAFlight: boolean = false;
	isBrazilFlight: boolean = false;
	isEgyptFlight: boolean = false;
	isTurkeyFlight: boolean = false;
	isChinaFlight: boolean = false;
	isCanadaFlight: boolean = false;
	isUnitedKingdomFlight: boolean = false;

	currency: string;
	currencyUnit: string;

	selectedPaymentMethod: PaymentMethod;
	selectedPaymentMethodTranslationKey: string;
	selectedCardType: string;

	ancillaryList;
	ancillariesPayableWithMiles;

	allSubs: Subscription[] = [];
	sidebarServiceSubscription: Subscription;
	paymentMethodSubscription: Subscription;
	issueParamSubscription: Subscription;
	creditCardSubscription: Subscription;
	statusTransactionSubscription1: Subscription;
	statusTransactionSubscription2: Subscription;
	cyberSourceModalSubscription: Subscription;
	cyberSourceModalFraudTypeSubscription: Subscription;
	passengerSubscription: Subscription;
	paymentTrySubscription: Subscription;
	removeVoucherSubscription: Subscription;
	partialVoucherSubscription: Subscription;

	@ViewChild(INDRAPaymentComponent) paymentINDRA: INDRAPaymentComponent;
	@ViewChild('buttonHandlePay') buttonPayment: ElementRef;

	formIsValid: boolean = false;
	showPaymentForm: boolean = true;
	paymentLoading: boolean = false;
	paymentLoadingPaybyrd: boolean = false;
	paymentRefused: boolean = false;
	alertErrorPayment: boolean = false;
	paymentAuthorised: boolean = false;
	paymentRejected: boolean = false;
	alertErrorPaymentresultFCE: boolean = false;
	alertErrorPaymentresultCyberSourceReject: boolean = false;
	isFCECybersourceRejectedScenario: boolean = false;
	notificationCybersource: boolean = false;
	issueAuthorisedOK: boolean;
	issueAuthorisedKO: boolean;
	saveCardData: boolean = false;
	encodedJSON: string;
	threeDSMethodURL: string;
	encodedcReq: string;
	dataPay: any;
	threeDSMethodURLShopper: string;
	threeDSMethodRedirectShopperURL: string;
	dataPayment: any;
	termUrl: string;
	paReq: string;
	md: string;
	maxIntent = 2; // *3 attempts/countdown
	countdownPaymentRefused = this.maxIntent;
	numCard: string;
	cardIntentList: INDRACardIntent[] = [];
	indexCardIntent: number;
	paymentSessionID: string;
	paymentFees: INDRAPaymentMethodFees;
	creditCardEncrypted: string;
	urlSafe: SafeResourceUrl;
	redirectPnr;
	cardNumber: string;
	url;
	lastname: string;
	idOperation: any;

	userMiles;
	isUserMGPClient: boolean;
	hasAdjustedCashPrice: boolean = false;

	milesSpent$: Observable<number> = this.store.select(fromStore.getTotalMilesToSpend);
	milesSpent: number;
	previousMilesSpent: number;
	milesInFlightDiscount$: Observable<any> = this.store.select(fromStore.getMilesInFlightDiscount);
	milesInFlightDiscount: any;
	milesSpentChanges$: Observable<any> = combineLatest(
		this.milesSpent$,
		this.milesInFlightDiscount$,
	);

	mgpDiscount$: Observable<INDRAPrice> = this.store.select(fromStore.getMilesBarDiscountInformationMiles);
	mgpDiscount: number;
	convertedMgpDiscount: number;

	searchRoute$: Observable<Array<RouteTrip>> = this.store.select(fromStore.getMiniIBESearchRoutes);
	searchRoute;

	recover_insurance$: Observable<any> = this.store.select(fromStore.getSelectedBookedTripRecoverInsurance);
	recover_insurance: boolean = false;

	country$: Observable<number> = this.store.select(fromStore.getUserCountry);
	tttAmount: number = 0;
	flight_tickets: any = [];

	storedOCPPaypal;
	paypalNormalOCPSubscription: Subscription;
	normalOCPResponse;
	paypalPaymentResult: string;
	prpPaymentResult: string;
	genericPaymentResult: string;
	triggerCheckPaymentMethods: boolean;

	stopoverExtras: any = [];
	saveCookies: boolean = false;
	contactsInfo: any;
	hasCookies: boolean = false;

	isBrazilMarket: boolean = false;
	isUnitedKingdomMarket: boolean = false;
	cardlessEnabled: boolean = false;
	cardlessToken: string;
	noPassengerAPIResponse: boolean = false;
	passengerTypeRules: any;

	DUPEdata: any;
	DUPEFlights: any = [];
	dupe_booked_trip: any;
	dupeShoppingCart: any;

	hasUpdatedFlightPrices: boolean = false;
	checkedCA: boolean = false;
	checkedUK: boolean = false;
	checkedBR: boolean = false;
	checkedCN: boolean = false;
	checkedTR: boolean = false;
	checkedEG: boolean = false;
	trackindIDPaypal = '';
	paxTierListString = '';

	dupeMarket: string;
	dupeCurrency: string;

	hasCreateAncillariesError: boolean = false;
	adtInfExceedsCharLimit = [];
	passengerWarnings = [];

	hasFOPCountError: boolean = false;
	TOO_MANY_FOP_MSG = 'Too many Payment Methods';

	clientIPAddress = null;

	isWithAncillaryPayWithMiles: boolean = false;

	surcharge: number = 0;
	surchargeAmount: number = 0;
	isUpdateCCFeeAPIAllowed: boolean = true; // allow or prevent CC Fee API call to be made when exiting the page

	totalFlightPrice: INDRATotalFlightPrice;
	flightPriceBreakdownSummary: INDRAFlightPriceSummary;

	isPaymentPageRedirectLoaded = false;

	//REDEEM VOUCHER VARIABLES
	redeemVoucherSubscription: Subscription;
	hasVoucherErrorFlag1: boolean = false;
	hasVoucherErrorFlag2: boolean = false;
	redeemVoucherAttempt: number = 0;
	redeemVoucherAPICallFlag: boolean = true;

	// paybyrd
	isPaybyrdEnabled: boolean = false;
	adyenPopUpEnabled: boolean = false;
	isHPPRedFlagEnabled: boolean = false;
	acceptedTermsAndConditions: boolean = false;
	submitted: boolean = false;
	hasPaybyrdError: boolean = false;
	hasAdyenError: boolean = false;
	paybyrdErrorMsg = '';
	redeemVoucherDisabled: boolean = false;
	useMilesDisabled: boolean = false;

	// session extension
	sessionExtensionTimer;

	// for parallel calls
	private triggerCreatePassenger$: Observable<boolean> = this.parallelService.triggerCreatePassenger$;
	private triggerCreateContact$: Observable<boolean> = this.parallelService.triggerCreateContact$;

	triggerCreatePassenger: boolean = false;
	triggerCreateContact: boolean = false;

	private paymentMethodsRetreived: boolean = false;
	paymentFormLoading: boolean = false;

	isButtonPaymentDisableOverride: boolean = false;
	ancillariesRemoved: any;

	confirmModalCallback$: Observable<string> = this.store.select(fromStore.getConfirmModalConfirm);
	confirmModalCallback = '';
	goingBack: boolean = false;

	// Carbon Offset variables
	carbonBundle;
	carbonBundlecurrency: string;
	outboundCarriers: boolean;
	inboundCarriers: boolean;

	constructor(
		private store: Store<fromStore.State>,
		private router: Router,
		protected _http: HttpClient,
		private paymentService: PaymentService,
		private sidebarService: SidebarService,
		private route: ActivatedRoute,
		private modalService: ModalService,
		private currencyService: INDRACurrencyService,
		private indraPaymentService: INDRAPaymentService,
		private storage: INDRAStorageService,
		private bfmStorage: INDRABFMDataStorageService,
		private bookingSearchService: INDRABookingSearchService,
		private bookingService: INDRABookingService,
		private flightPriceService: INDRAFlightPriceService,
		private sanitizer: DomSanitizer,
		private bookingPaymentService: INDRABookingPaymentService,
		private ancillariesShoppingCartService: INDRAAncillariesShoppingCartService,
		private observatory: INDRAObservatoryService,
		private cybersourceModalService: CybersourceModalService,
		private milesService: INDRAMilesService,
		private cookieService: CookieService,
		private passengerStore: Store<fromPassengerStore.State>,
		private passengerTypeService: INDRAPassengerTypeService,
		private ancillariesService: INDRAAncillariesService,
		private googleAnalytics: INDRAGoogleAnalyticsService,
		private languageMarketService: INDRALanguageMarketService,
		private currencyPipe: INDRACurrencyPipe,
		private ibeAdminService: INDRAIbeAdminService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		private timeoutSvc: TimeoutSvcService,
		private location: Location,
		private discountService: INDRADiscountService,
		private frequentFlyerIndraService: FrequentFlyerIndraService,
		private beneficiaryService: BeneficiaryIndraService,
		private indraService: INDRAApiService,
		private parallelService: INDRAParallelService
	) {
		super();
		this.store.dispatch(new BookingStepsActions.PutCurrentPageAction('payment'));
		//this.INDRA_initializePaypalScripts();
		this.paymentService.resetPayment(true); // reset values for payment service except booking totals

		// get idOperation from session storage, if existing set payment service
		// this is done for scenarios where the user hits back button while on the adyen payment gateway
		const idOperationFromStorage = this.storage.get('idOperation');
		if (idOperationFromStorage) {
			this.paymentService.setPaymentOperationID(idOperationFromStorage);
		}

		// get IP address
		this.INDRA_getClientIPAddress();

		this.market = this.storage.get(SESSION_VAR_KEY_MARKET);
		this.isBrazilMarket = (this.market && this.market === COUNTRY_CODE_BRAZIL) ? true : false;

		// get surcharge (if applicable)
		this.paymentService.surcharge
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(surcharge => {
				this.surcharge = surcharge;
				this.INDRA_retrieveAndApplySurchargeAmount(this.surcharge);
			});

		// get surcharge amount (if applicable)
		this.paymentService.surchargeAmount
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(surchargeAmount => {
				this.surchargeAmount = surchargeAmount;
			});

		// get booking total cost
		this.paymentService.totalFlightPrice
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(totalFlightPrice => {
				this.totalFlightPrice = totalFlightPrice;
			});

		this.bookedTrip$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.bookedTrip = value;
				}
			});

		// Notification Redirect Shopper
		this.issueParamSubscription = this.route.queryParams.subscribe(async params => {
			const issue = params['issue'];
			if (issue === 'ISSUE_KO' && !this.isPaymentPageRedirectLoaded) {
				// get idOperation from URL
				const idOperation = params['idOperation'];
				if (idOperation) {
					this.paymentService.setPaymentOperationID(idOperation);
					this.storage.set('idOperation', idOperation);
				}

				// do setup for the page since this flow is a redirection back from an external URL
				this.trip_pnr = this.route.snapshot.paramMap.get('pnr');
				this.countdownPaymentRefused = this.storage.get('attempt');
				this.storage.set('bookingPnr', this.trip_pnr);
				this.progressiveSteps.forEach(step => { if (step.step < 4) step.status = true; });
				this.paymentRefused = true;
				this.INDRA_resetOtherErrors('refused');
				if (!this.paymentMethodsRetreived) {
					await this.INDRA_loadPaymentMethods();
				}
				this.confirmedPassengersAndContacts = true;

				// account for payment attempts
				this.INDRA_paymentAttempt();
				this.INDRA_checkPaymentTries();
				// note: this is to ensure this subscription is only triggered once (when payment page is loaded from a redirection from adyen)
				this.isPaymentPageRedirectLoaded = true;
			}
		});
		this.allSubs.push(this.issueParamSubscription);

		// get dummy PNR from session storage
		this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
		this.tripType = this.booked_trip.data.fare.tripType;
		this.hasStopover = this.bookingSearchService.INDRA_hasStopover(this.booked_trip);
		this.passengers = this.booked_trip.data.infoPax.listPax;
		this.INDRA_setFlights();

		this.bfmStorage.INDRA_setTravelDocumentationConfirm(false);
		this.bfmStorage.INDRA_setTravelHazmatBaggageRulesConfirm(false);

		this.isUSAFlight = this.bookingService.INDRA_isUSAFlight(this.booked_trip);
		if (this.isUSAFlight) {
			this.showVisaBox = true;
			this.showHazmatBox = true;
		}

		this.isBrazilFlight = this.INDRA_isBrazilFlight();
		this.isEgyptFlight = this.INDRA_isEgyptFlight();
		this.isTurkeyFlight = this.INDRA_isTurkeyFlight();
		this.isChinaFlight = this.INDRA_isChinaFlight();
		this.isCanadaFlight = this.INDRA_isCanadaFlight();
		this.isUnitedKingdomFlight = this.INDRA_isUnitedKingdomFlight();

		if (this.router.url.includes('/time-to-think/payment')) {
			this.isTTTPaymentPage = true;
			const timeToThink = this.bfmStorage.INDRA_getTimeToThink();
			if (timeToThink && timeToThink.totalFee) {
				this.tttAmount = timeToThink.totalFee;
			}
			this.observatory.setData('isTTT', true);
		}
		if (this.router.url.includes('/booking/payment')) {
			this.isBookingPaymentPage = true;
		}
		if (this.router.url.includes('redirect')) {
			this.isPaymentPageRedirect = true;
		}

		this.currency = this.currencyService.INDRA_getCurrencySymbol().name;
		this.currencyUnit = this.currencyService.INDRA_getCurrencySymbol().unit;

		// clear storage
		this.storage.remove('shoppingCartMiles');
		// this.storage.remove('idOperation');
		// this.storage.remove('bookingPnr');

		this.timeToThink_to_booking$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					if (value.status === 'active') {
						this.isTTTBookingForCompletion = true;
						this.trip_pnr = value.pnr;
						this.lastname = value.lastname;
						this.storage.set('bookingPnr', this.trip_pnr);
						this.storage.set('lastname', this.lastname);

						if (!this.userInfo) this.INDRA_showLoginForm();
						this.canGo = false;
					}
				}
			});

		this.bookAwardFlights$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.bookAwardFlights = value;
				// set pay with miles to local storage
				this.discounts = this.promoCodesAndVoucher.filter(discount => discount.status === DISCOUNT_STATUS_ACTIVE);
				this.INDRA_maintainInBrowserStorage('book_award_flight', value);
			});

		this.mgpDiscount$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.mgpDiscount = value.cash;
				this.convertedMgpDiscount = value.miles;
				if (this.mgpDiscount) {
					this.bookedTripDiscounts = [{ id: 'mile-go', value: this.mgpDiscount }];
					this.hasMilesGoDiscount = true;
				} else {
					this.bookedTripDiscounts = [];
					this.hasMilesGoDiscount = false;
				}
			});


		this.milesSpentChanges$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(([milesSpent, milesInFlightDiscount]) => {
				this.milesSpent = milesSpent;
				if ((this.milesSpent > 0 || (milesInFlightDiscount && milesInFlightDiscount.miles > 0)) && !this.bookAwardFlights) {
					this.hasAdjustedCashPrice = true;
				} else {
					this.hasAdjustedCashPrice = false;
				}
				if (milesInFlightDiscount) {
					this.milesInFlightDiscount = milesInFlightDiscount;
					this.applyMilesGoDiscount = milesInFlightDiscount.miles > 0 ? true : false;
				}

				// call API to check if FOP count is correct
				if (this.confirmedPassengersAndContacts) {
					if (milesSpent != this.previousMilesSpent) { // to ensure that statements below are called only during milesSpent changes
						//this.INDRA_checkPaymentMethodCount();
						this.previousMilesSpent = milesSpent;
					} else {
						this.INDRA_createPaymentItemList();
					}
				}
				this.INDRA_updateMarketPaymentMethods();
			});



		this.userInfo$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(async values => {
				this.userInfo = values;
				this.userData = this.storage.get('userData');

				if (this.userInfo) {
					this.canGo = true;
					if (this.isTTTBookingForCompletion)
						this.INDRA_confirmPassengersAndContacts();
				}

				this.INDRA_checkProgressiveSteps();
				if (this.userInfo && this.hasMilesGoDiscount && (this.milesInFlightDiscount && this.milesInFlightDiscount.miles > 0)) {
					this.applyMilesGoDiscount = true;
				} else {
					this.applyMilesGoDiscount = false;
				}

				this.isUserMGPClient = values && values['ffLevel'] ? true : false;
				this.userMiles = values && values['currentPoints'] ? values['currentPoints'] : 0;
				if (!this.bookAwardFlights && !this.promoCodesAndVoucher.length) {
					this.milesService.INDRA_getMilesConversionRates();
				}

				// invoke payment methods to update the payment method when the user logs in or logsout while in Payment Step 4
				if (this.confirmedPassengersAndContacts) {
					if (!this.paymentMethodsRetreived) {
						await this.INDRA_loadPaymentMethods();

					}
					this.INDRA_checkIfEligibleForDiscount();

					// only needed on step 4
					if (!this.userInfo && this.ancillaryList) {
						this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction(null));
						if (this.ancillaryList.itemsAdded.length != 0) {
							this.INDRA_updateShoppingCartContent();
						}
					}
				}

				this.INDRA_maintainInBrowserStorage('user_info', values);
			});

		this.promoCodesAndVoucher$
			.pipe(takeWhile(() => this.isAlive),map(value => value && value.filter(discount => discount.status === DISCOUNT_STATUS_ACTIVE)))
			.subscribe(discount => {
				if (discount && discount.length != 0) {
					this.hasDiscounts = true;
				} else {
					this.hasDiscounts = false;
				}
			});

		this.promoCodesAndVoucher$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.promoCodesAndVoucher = !value ? [] : value;
				if (this.promoCodesAndVoucher) {
					this.completePromocodeAndVoucherList = this.promoCodesAndVoucher;
					this.discounts = this.promoCodesAndVoucher.filter(discount => discount.status === DISCOUNT_STATUS_ACTIVE);
					
					if (this.discounts.length !== 0) {
						this.showFormAdd = false;
						this.isQuantityStage = true;
					}
				}

				if (this.confirmedPassengersAndContacts) {
					this.INDRA_checkPaymentMethodCount();
				}
			});
			

		if (this.discounts.length === 3) {
			this.showFormAdd = false;
		}

		this.milesInFlightDiscount$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(milesInFlightDiscount => {
				if (milesInFlightDiscount && milesInFlightDiscount.miles > 0 && this.userMiles > 0) {
					this.hasMilesDiscount = true;
					this.showFormAdd = false;
				} else {
					this.hasMilesDiscount = false;
					this.showFormAdd = true;
				}
			});

		this.weakFlightsDiscount$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value != null) {
					this.weakFlightsDiscount = value;
					this.hasDiscounts = true;
				} else {
					this.weakFlightsDiscount = [];
				}
			});

		this.starAllianceFlights$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.hasStarAllianceFlights = value;
				// set pay with miles to local storage
				this.INDRA_maintainInBrowserStorage('is_star_alliance_flight', value);
			});

		this.bookedTripExtras$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(extras => {
				if (extras) {
					this.bookedTripExtras = extras;
					const hotels = extras.find(extra => extra.type === 'hotel');
					this.selectedHotels = hotels ? hotels.data : [];
					if (this.selectedHotels.length > 0) {
						this.hasPartnerExtras = true;
						this.bookedTripExtrasCurrency = this.selectedHotels[0].hotel ? this.currencyService.INDRA_getCurrencySymbol(
							this.selectedHotels[0].hotel.hotelInfo.hotel_currency_code).unit : this.selectedHotels[0].currency;

						// update payment methods
						this.INDRA_updateMarketPaymentMethods();
					} else {
						this.hasPartnerExtras = false;
					}
					this.stopoverExtras = extras.filter(extra => extra.type != 'hotel');
				} else {
					this.hasPartnerExtras = false;
				}
			});

		this.recover_insurance$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(insurance => {
				if (insurance && insurance.length) {
					this.recover_insurance = true;
				} else {
					this.recover_insurance = false;
				}
			});

		this.paymentService.formIsValid
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(formIsValid => {
				if (formIsValid != undefined) {
					this.formIsValid = formIsValid;
				}
			});

		this.paymentService.selectedMethod
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(selectedPaymentMethod => {
				if (selectedPaymentMethod) {
					this.selectedPaymentMethod = selectedPaymentMethod;
				}
			});

		this.paymentService.selectedCardType
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(selectedCardType => {
				if (selectedCardType) {
					this.selectedCardType = selectedCardType;
				}
			});

		this.paymentService.saveCardData
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(saveCardData => {
				this.saveCardData = saveCardData;
			});

		this.paymentService.paypalPaymentResult
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(result => {
				if (result) {
					// workaround for paypal scenarios in which the paypal button is used instead of the generic payment button
					this.selectedPaymentMethodTranslationKey =
						this.bookingPaymentService.INDRA_getFOPLabelTranslationKey(this.selectedPaymentMethod);

					this.paypalPaymentResult = result;
					this.INDRA_handlePaypalPaymentResult();
					this.hasCreateAncillariesError = false;
				}
			});

		this.paymentService.prpPaymentResult
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(result => {
				if (result) {
					this.prpPaymentResult = result;
					this.INDRA_handlePRPPaymentResult();
					this.hasCreateAncillariesError = false;
				}
			});

		this.paymentService.genericPaymentResult
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(result => {
				if (result) {
					this.genericPaymentResult = result;
					this.INDRA_handleGenericPaymentResult();
					this.hasCreateAncillariesError = false;
				}
			});
		
		this.paymentService.triggerCheckPaymentMethods
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(result => {
				if (result) {
					this.triggerCheckPaymentMethods = result;
					if (this.triggerCheckPaymentMethods) {
						this.INDRA_checkPaymentMethodCount();
					}
				}
			});

		this.ancillaries$.pipe(takeWhile(() => this.isAlive))
			.subscribe(values => {
				this.ancillaries = values;
			});

		this.bookingSteps$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.bookingSteps = value;
				}
			});

		this.isScreenMobile$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => { this.isScreenMobile = value; });

		this.isDesktop$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => { this.isDesktop = value; });

		this.searchRoute$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((value): any => {
				this.searchRoute = value;
			});

		this.country$.
			pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value && this.dupe_booked_trip) {
					this.market = this.storage.get(SESSION_VAR_KEY_MARKET);
					this.INDRA_handleDUPE();
				}
			});

		this.confirmModalCallback$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.confirmModalCallback = value;
				}
			});

		// For Carbon Offset
		if (this.booked_trip['ancillaries-data']) {
			this.INDRA_setThirdPartyAncillaries(this.bfmStorage.INDRA_getThirdPartyAncillaries());
		}
		this.INDRA_setFlightTicketsAndFlights();
	}
	ngOnInit() {
		if (this.userData && this.INDRA_isAwardBooking()) {
			// Companion list service call
			if (this.userData != null) {
				this.INDRA_retrieveCompanionList();
			}
		} else {
			this.beneficiaryFlag = true;
		}

		const triggerCreatePassengerSubscription = this.triggerCreatePassenger$.subscribe(value => {
			this.triggerCreatePassenger = value;
		});
		this.allSubs.push(triggerCreatePassengerSubscription);

		const triggerCreateContactSubscription = this.triggerCreateContact$.subscribe(value => {
			this.triggerCreateContact = value;
		});
		this.allSubs.push(triggerCreateContactSubscription);

		this.sidebarServiceSubscription =
			this.sidebarService.sidebarClosed$.subscribe(value => {
				if (value) {
					// refresh with updated values from session storage
					const newPassenger = value['new-passenger'];
					const { contacts } = value;
					if (newPassenger) {
						this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
						this.passengers = this.booked_trip.data.infoPax.listPax;
						this.INDRA_checkProgressiveSteps();
					} else if (contacts) {
						this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
						this.INDRA_checkProgressiveSteps();
					}
				}
			});
		this.allSubs.push(this.sidebarServiceSubscription);

		this.cyberSourceModalSubscription =
			this.cybersourceModalService.getObject().subscribe(res => {
				if (res && this.INDRA_getStatusStep(3).status) {
					this.dataPay = res;
					this.dataPay['acceptValidation'] = true;
					this.INDRA_handlePay(this.dataPay, this.cardNumber);
				}
			});
		this.allSubs.push(this.cyberSourceModalSubscription);

		this.cyberSourceModalFraudTypeSubscription =
			this.cybersourceModalService.getFraudType().subscribe(res => {
				if (res && this.INDRA_getStatusStep(3).status) {
					this.observatory.setData('cybersourceValidationType', res);
				}
			});
		this.allSubs.push(this.cyberSourceModalFraudTypeSubscription);

		this.ancillaryList = this.storage.get('INDRAAncillariesShoppingCartService.shoppingCart');

		const passengerDetails = this.cookieService.check(COOKIES_VAR_KEY_PASSENGER_DETAILS);
		const contactDetails = this.cookieService.check(COOKIES_VAR_KEY_PASSENGER_CONTACT_DETAILS);
		if (passengerDetails && contactDetails) {
			this.hasCookies = true;
		}

		this.saveCookies = this.hasCookies;

		if (this.formChooseLogin.controls['login'].value == 'yes' && !this.userInfo) {
			this.googleAnalytics.IBE_GA_setAdditionalStepsPaymentPage('login');
		}
		this.storage.set('voucherError3rdAttemptFlag', false);

		// session extension
		const sessionExtendIntervalInSeconds = this.ibeAdminConfigService.getConfigurationValue('bookingSearch.sessionExtendIntervalInSeconds') || DEFAULT_SESSION_EXTEND_INTERVAL_IN_SECONDS;
		if (sessionExtendIntervalInSeconds) {
			this.timeoutSvc.INDRA_setSessionExtendIntervalInSeconds(Number(sessionExtendIntervalInSeconds));
		}
		clearInterval(this.sessionExtensionTimer);
		this.sessionExtensionTimer = setInterval(() => {
			this.indraService.INDRA_extendSession();
		}, this.timeoutSvc.INDRA_getSessionExtendIntervalInSeconds() * 1000);
	}

	ngOnDestroy(): void {
		this.isAlive = false;
		for (const sub of this.allSubs) {
			if (sub) sub.unsubscribe();
		}
		this.cybersourceModalService.reset();
		clearInterval(this.sessionExtensionTimer);

    // Reset passenger created, contact created and checkboxes completed
		this.parallelService.INDRA_reset();
	}

	INDRA_getClientIPAddress() {
		this.indraPaymentService.INDRA_getIpAddress().subscribe(res => {
			this.clientIPAddress = res && res.ip ? res.ip : '';
			this.paymentService.setClientIPAddress(this.clientIPAddress);
		}, err => {
			this.clientIPAddress = '';
			this.paymentService.setClientIPAddress(this.clientIPAddress);
		});
	}

	INDRA_isBrazilFlight() {
		const arrivalCountries = this.bookingService.INDRA_getArrivalCountry(this.booked_trip);
		return ((arrivalCountries && arrivalCountries.length > 0) ? ((arrivalCountries.filter(country => country == COUNTRY_CODE_BRAZIL)).length > 0) : (false));
	}

	INDRA_isUSAFlight() {
		const arrivalCountries = this.bookingService.INDRA_getArrivalCountry(this.booked_trip);
		return ((arrivalCountries && arrivalCountries.length > 0) ? ((arrivalCountries.filter(country => country == COUNTRY_CODE_USA)).length > 0) : (false));
	}

	INDRA_isEgyptFlight() {
		const arrivalCountries = this.bookingService.INDRA_getArrivalCountry(this.booked_trip);
		return ((arrivalCountries && arrivalCountries.length > 0) ? ((arrivalCountries.filter(country => country == COUNTRY_CODE_EGYPT)).length > 0) : (false));
	}

	INDRA_isTurkeyFlight() {
		const arrivalCountries = this.bookingService.INDRA_getArrivalCountry(this.booked_trip);
		return ((arrivalCountries && arrivalCountries.length > 0) ? ((arrivalCountries.filter(country => country == COUNTRY_CODE_TURKEY)).length > 0) : (false));
	}

	INDRA_isChinaFlight() {
		const arrivalCountries = this.bookingService.INDRA_getArrivalCountry(this.booked_trip);
		return ((arrivalCountries && arrivalCountries.length > 0) ? ((arrivalCountries.filter(country => country == COUNTRY_CODE_CHINA)).length > 0) : (false));
	}

	INDRA_isCanadaFlight() {
		const arrivalCountries = this.bookingService.INDRA_getArrivalCountry(this.booked_trip, true);
		return ((arrivalCountries && arrivalCountries.length > 0) ? ((arrivalCountries.filter(country => country == COUNTRY_CODE_CANADA)).length > 0) : (false));
	}

	// Great Britain(GB) + Ireland(IE)
	INDRA_isUnitedKingdomFlight() {
		const arrivalCountries = this.bookingService.INDRA_getArrivalCountry(this.booked_trip, true);
		return ((arrivalCountries && arrivalCountries.length > 0) ? ((arrivalCountries.filter(country => country == COUNTRY_CODE_UNITED_KINGDOM || country == COUNTRY_CODE_IRELAND)).length > 0) : (false));
	}

	/**
	 * Set flights
	 */
	INDRA_setFlights() {
		let key = 0;
		// outbound flights
		this.booked_trip.data.fare.listOutbound.forEach(outbound => {
			const outboundLength = outbound.listSegment.length;
			this.flights.push({
				type: 'flight',
				id: 'flight-' + key,
				item: {
					details: outbound,
					departureLocation: this.booked_trip.translate.locations[
						outbound.listSegment[0].departureAirport
					],
					arrivalLocation: this.booked_trip.translate.locations[
						outbound.listSegment[outboundLength - 1].arrivalAirport
					]
				}
			});
			key++;
		});
		// inbound flights
		if (this.booked_trip.data.fare.listInbound) {
			this.booked_trip.data.fare.listInbound.forEach(inbound => {
				const inboundLength = inbound.listSegment.length;
				this.flights.push({
					type: 'flight',
					id: 'flight-' + key,
					item: {
						details: inbound,
						departureLocation: this.booked_trip.translate.locations[
							inbound.listSegment[0].departureAirport
						],
						arrivalLocation: this.booked_trip.translate.locations[
							inbound.listSegment[inboundLength - 1].arrivalAirport
						]
					}
				});
				key++;
			});
		}
	}

	/**
	 * Handles a back event from the context menu
	 */
	INDRA_handleBack() {
		let inboundStopover = false;
		let outboundStopover = false;
		if (this.booked_trip && this.booked_trip.data.fare.listInbound.length > 0) {
			this.booked_trip.data.fare.listInbound.forEach(list => {
				if (list.listSegment.some(segment => segment.stopover === true || segment.stopTime > 1440)) {
					inboundStopover = true;
				}
			});
		}
		if (this.booked_trip && this.booked_trip.data.fare.listOutbound.length > 0) {
			this.booked_trip.data.fare.listOutbound.forEach(list => {
				if (list.listSegment.some(segment => segment.stopover === true || segment.stopTime > 1440)) {
					outboundStopover = true;
				}
			});
		}

		this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslation('priceBreakdown.text.backToSelection')));
		this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTranslation('priceBreakdown.text.ifYouContinue')));
		this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslation('priceBreakdown.text.dontLeavePage')));
		this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslation('priceBreakdown.text.chooseFlightsAgain')));
		this.modalService.assignComponent(INDRAConfirmModalComponent);
		this.modalService.open();

		this.modalService.isOpen
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (!value) {
					if (this.confirmModalCallback === 'ok') {
						this.goingBack = true;
						this.INDRA_resetSelectedFlights();
						this.store.dispatch(new AncillariesWithMilesActions.ResetAction());
						this.store.dispatch(new ConfirmModalActions.ResetAction);
						this.INDRA_clearThirdPartyExtras();
						if (inboundStopover || outboundStopover) {
							this.router.navigate(['/booking/flights-stopover']);
						} else {
							if (this.booked_trip) {
								if (this.booked_trip.data.fare.tripType === TRIP_TYPE_MULTICITY_CODE) {
									this.router.navigate(['/booking/flights-multicity']);
								} else {
									this.router.navigate(['/booking/flights']);
								}
							} else {
								this.router.navigate(['/booking']);
							}
						}
					} else {
						history.forward();
					}
				}
			});
	}

  INDRA_isTTT(): boolean {
		return this.router.url.includes('/time-to-think');
  }

	INDRA_getCurrentStep() {
		const currentStep = this.progressiveSteps.filter(cur => cur.status);
		return this.progressiveSteps[currentStep.length].step;
	}

	INDRA_getStatusStep(step: number = null) {
		if (step) {
			return this.progressiveSteps.find(cur => cur.step == step);
		} else {
			const currentStep = this.progressiveSteps.filter(cur => cur.status);
			return this.progressiveSteps[currentStep.length];
		}
	}

	INDRA_nextStep(step: number = null) {
		this.showFillFirstAlert = false;
		this.INDRA_setShowAlertTimer();

		if (step) {
			if (step === 2) {
				this.canGo = true;
				if (this.isTTTBookingForCompletion)
					this.INDRA_confirmPassengersAndContacts();
			} else if (step >= 4) {
				this.INDRA_validateCheckboxes();
			}
			for (const curStep of this.progressiveSteps) {
				if (curStep.step < step) {
					curStep.status = true;
				}
			}
		} else {
			const currentStep = this.progressiveSteps.filter(cur => cur.status);
			if (currentStep.length < this.progressiveSteps.length) {
				this.progressiveSteps[currentStep.length].status = true;
				step = this.progressiveSteps[currentStep.length + 1].step;
			}
		}

		clearTimeout(this.scrollToStepSettimeout);
		this.scrollToStepSettimeout = setTimeout(() => {
			this.INDRA_doScroll(`step-${step}`);
		}, 800);

		this.INDRA_changeStepURL(step);
	}

	INDRA_checkProgressiveSteps() {
		if (this.INDRA_getStatusStep().step == 1) {
			this.INDRA_nextStep(2);
			setTimeout(() => {
				if (this.userInfo) {
					this.INDRA_nextStep(2);
				}
				if (!this.isPaymentPageRedirect) {
					this.INDRA_callPassengerAPI();
				}
			}, 0);
		}

		if (this.passengers) {
			const passengerMissingInfo = (this.INDRA_checkMissingPassengerDetails(this.passengers).length > 0);

			// check if passengers has infant and name of adt-inf does not exceed 33 characters
			if (!passengerMissingInfo && this.passengers.some(pax => pax.typePax === PAX_TYPE_INFANT_CODE)) {
				this.adtInfExceedsCharLimit = this.INDRA_countCombinedNames(this.passengers);
				this.INDRA_checkForError(this.passengers);
			}

			if (!passengerMissingInfo && this.showVisaBox && this.visaToUSA === true && this.travelHazmat === true) {
				this.isBack = false;
				setTimeout(() => { this.INDRA_nextStep(3); }, 0);
			}

			if (!passengerMissingInfo) {
				const checkBoxCountries = [this.isBrazilFlight, this.isCanadaFlight, this.isChinaFlight, this.isEgyptFlight, this.isUSAFlight, this.isTurkeyFlight];
				const activeCountries = checkBoxCountries.filter(country => country === true);
				if (activeCountries.length === this.chkboxCount) {
					this.isBack = false;
					setTimeout(() => { this.INDRA_nextStep(3); }, 0);
				}
			}

			if (!passengerMissingInfo && !this.showVisaBox && !this.isBrazilFlight && !this.isEgyptFlight && !this.isChinaFlight && !this.isTurkeyFlight && !this.isCanadaFlight) {
				this.isBack = false;
				setTimeout(() => { this.INDRA_nextStep(3); }, 0);
			}

			const infoPax: any = this.booked_trip.data.infoPax;
			if (!passengerMissingInfo && (infoPax.phone && (infoPax.phoneCountryCode || infoPax.prefixPhone) && infoPax.email)) {
				setTimeout(() => {
					this.INDRA_nextStep(4);
				}, 0);
			}
		}

		if (this.INDRA_getCurrentStep() > 2) {
			this.backVisible = false;
		}
	}

	INDRA_setShowAlertTimer() {
		clearTimeout(this.showFillFirstAlertTimeout);
		this.showFillFirstAlertTimeout = setTimeout(() => {
			this.showFillFirstAlert = true;
		}, 1000);
	}

	INDRA_doScroll(classToScrollTo) {
		const el = document.getElementsByClassName(classToScrollTo);
		if (el.length == 0) {
			return;
		}
		const viewportOffset = el[0].getBoundingClientRect();
		const offsetTop = viewportOffset.top + window.pageYOffset;

		setTimeout(() => {
			this.doScrolling(offsetTop - 150, 400);
		}, 100);
	}

	INDRA_checkMissingPassengerDetails(passengers) {
		const result = [];
		passengers.forEach(pax => {
			/* // note: commenting out since emergency contact and personal documents are not required everytime
			if (!pax.emergencyData ||
				(!pax.emergencyData.declined && (!pax.emergencyData ||
				!pax.emergencyData.emName ||
				!pax.emergencyData.emCountry ||
				!pax.emergencyData.emPrefix ||
				!pax.emergencyData.emPhone))) {
				result.push('emergencyContact');
			}
			if (!pax.listTravelDoc || pax.listTravelDoc.length === 0) {
				result.push('personalDocuments');
			} else {
				const incompleteTravelDocs = pax.listTravelDoc.filter(doc =>
					(!doc || !doc.birthDate));
				if (incompleteTravelDocs.length > 0) {
					result.push('personalDocuments');
				}
			}
			*/

			// unsaved pax surname will always be a number
			if (pax.surname && !isNaN(pax.surname as any)) {
				result.push('unsavedPax');
			}
		});

		return result;
	}

	INDRA_showLoginForm() {
		this.formChooseLogin.controls['login'].setValue('yes');
		this.progressiveSteps[0].status = false;
	}

	INDRA_returnToUserInfoStep() {
		if (this.INDRA_isDUPE() || this.INDRA_haveFlighPricesChanged()) return false;
		clearTimeout(this.scrollToStepSettimeout);
		this.INDRA_doScroll(`step-1`);
		this.INDRA_showLoginForm();
	}

	// TODO implement this using actual API price
	INDRA_displayPrice(type) {
		switch (type) {
			case 'original':
				if (this.bookedTrip.flights.length) {
					return this.flightPriceService.INDRA_getBookingTotalCost(
						this.bookedTrip.flights, this.bookedTrip.booking_type, this.bookAwardFlights, true,
						this.promoCodesAndVoucher, this.bookedTripDiscounts, this.weakFlightsDiscount, this.ancillaryList, this.stopoverExtras, 0);
				} else {
					return this.bookAwardFlights ? '0 M + 0.00 ' + this.currencyUnit : '0.00 ' + this.currencyUnit;
				}
			case 'discounted':
				if (this.bookedTrip.flights.length) {
					return this.flightPriceService.INDRA_getBookingTotalCost(
						this.bookedTrip.flights, this.bookedTrip.booking_type, this.bookAwardFlights, false,
						this.promoCodesAndVoucher, this.bookedTripDiscounts, this.weakFlightsDiscount, this.ancillaryList, this.stopoverExtras, 0);
				} else {
					return this.bookAwardFlights ? '0 M + 0.00 ' + this.currencyUnit : '0.00 ' + this.currencyUnit;
				}
			case 'discount':
				return this.getMilesAndGoDiscount().toFixed(2) + ' ' + this.currencyUnit;
			default:
				return '0 ' + this.currencyUnit;
		}
	}

	private getMilesAndGoDiscount() {
		let discount = 0;
		if (this.bookedTripDiscounts.length != 0) {
			for (const i in this.bookedTripDiscounts) {
				discount = discount + parseFloat(this.bookedTripDiscounts[i].value);
			}
		}
		return discount;
	}

	INDRA_continueWithoutDiscount(continueWithoutDiscount) {
		this.applyMilesGoDiscount = !continueWithoutDiscount;
		this.INDRA_nextStep(2);
	}

	INDRA_priceChange(): boolean {
		if (!this.noPassengerAPIResponse && this.passengerTypeRules) {
			const passengerData = _.cloneDeep(this.passengers);
			let flag: boolean = false;
			let lastArrivalDate: any;

			if (this.booked_trip.data.fare.listInbound.length != 0) {
				lastArrivalDate = moment(this.booked_trip.data.fare.listInbound[this.booked_trip.data.fare.listInbound.length - 1].lastSegment.arrivalDate);
			} else {
				lastArrivalDate = moment(this.booked_trip.data.fare.listOutbound[this.booked_trip.data.fare.listOutbound.length - 1].lastSegment.arrivalDate);
			}

			for (const i in passengerData) {
				if (passengerData[i].listTravelDoc.length > 0) {
					const birthDate = moment(passengerData[i].listTravelDoc[0].birthDate);
					const yearDiff = lastArrivalDate.diff(birthDate, 'years');
					if (passengerData[i].typePax == PAX_TYPE_INFANT_CODE && this.passengerTypeRules['MAX_INF_AGE']) {
						if (yearDiff > parseInt(this.passengerTypeRules['MAX_INF_AGE'])) {
							flag = true;
						}
					} else if (passengerData[i].typePax == PAX_TYPE_CHILD_CODE && this.passengerTypeRules['MAX_CHD_AGE']) {
						if (yearDiff > parseInt(this.passengerTypeRules['MAX_CHD_AGE'])) {
							flag = true;
						}
					} else if (passengerData[i].typePax == PAX_TYPE_YOUNG_ADULT_CODE && this.passengerTypeRules['MAX_YTH_AGE']) {
						if (yearDiff > parseInt(this.passengerTypeRules['MAX_YTH_AGE'])) {
							flag = true;
						}
					}

					if (flag) {
						break;
					}
				}
			}
			this.priceChange = flag;
		}

		return this.priceChange;
	}

	INDRA_selectNewFlights() {

		if (this.isNavigating) return;
		this.isNavigating = true;

		//Clear Data
		this.INDRA_clearBookedTrip();
		this.store.dispatch(new AncillariesWithMilesActions.ResetAction());
		this.store.dispatch(new ConfirmModalActions.ResetAction);
		this.store.dispatch(new PromoVouchersActions.ResetAction());

		if (this.priceChange || this.hasPaymentStepError || this.hasPNRCreationError || this.isDUPE) {
			this.router.navigate(['/booking']);
			if(this.router.url !== '/booking'){
				//Force navigation as fallback
				window.location.href = '/booking';
			}
			this.isNavigating = false;
		} else {
			if (this.hasStopover) {
				this.router.navigate(['/booking/flights-stopover']);
				this.isNavigating = false;

			} else {
				if (this.tripType == TRIP_TYPE_MULTICITY_CODE) {
					this.router.navigate(['/booking/flights-multicity']);
					this.isNavigating = false;
				} else {
					this.router.navigate(['/booking/flights']);
					this.isNavigating = false;
				}
			}
		}


		// TODO add whatever needs to be cleared here
	}

	INDRA_printTotalPrice() {
		return (this.totalFlightPrice && this.totalFlightPrice.cash) ?
			(this.totalFlightPrice.cash.toFixed(2) + this.currencyService.INDRA_getCurrencySymbol(this.totalFlightPrice.currency).unit) :
			('0.00 ' + this.currencyUnit);
	}

	INDRA_handleVoucherOrPromocode() {
		this.sidebarService.openSidebar(['voucher-or-promocode']);
	}

	INDRA_visatoUSA() {
		this.visaToUSA = !this.visaToUSA;
		this.bfmStorage.INDRA_setTravelDocumentationConfirm(this.visaToUSA);
		this.bfmStorage.INDRA_setTravelHazmatBaggageRulesConfirm(this.travelHazmat);
		this.INDRA_checkProgressiveSteps();
		this.INDRA_validateCheckboxes();
	}

	INDRA_checkedMarket(country) {
		if (country === COUNTRY_CODE_CANADA) {
			this.checkedCA = !this.checkedCA;
			if (this.checkedCA) {
				this.chkboxCount = this.chkboxCount + 1;
			} else {
				this.chkboxCount = this.chkboxCount - 1;
			}
		} else if (country === COUNTRY_CODE_UNITED_KINGDOM) {
			this.checkedUK = !this.checkedUK;
			if (this.checkedUK) {
				this.chkboxCount = this.chkboxCount + 1;
			} else {
				this.chkboxCount = this.chkboxCount - 1;
			}
		} else if (country === COUNTRY_CODE_BRAZIL) {
			this.checkedBR = !this.checkedBR;
			if (this.checkedBR) {
				this.chkboxCount = this.chkboxCount + 1;
			} else {
				this.chkboxCount = this.chkboxCount - 1;
			}
		} else if (country === COUNTRY_CODE_CHINA) {
			this.checkedCN = !this.checkedCN;
			if (this.checkedCN) {
				this.chkboxCount = this.chkboxCount + 1;
			} else {
				this.chkboxCount = this.chkboxCount - 1;
			}
		} else if (country === COUNTRY_CODE_TURKEY) {
			this.checkedTR = !this.checkedTR;
			if (this.checkedTR) {
				this.chkboxCount = this.chkboxCount + 1;
			} else {
				this.chkboxCount = this.chkboxCount - 1;
			}
		} else if (country === COUNTRY_CODE_EGYPT) {
			this.checkedEG = !this.checkedEG;
			if (this.checkedEG) {
				this.chkboxCount = this.chkboxCount + 1;
			} else {
				this.chkboxCount = this.chkboxCount - 1;
			}
		}
		this.INDRA_checkProgressiveSteps();
		this.INDRA_validateCheckboxes();
	}

	INDRA_travelHazmat() {
		this.travelHazmat = !this.travelHazmat;
		this.bfmStorage.INDRA_setTravelHazmatBaggageRulesConfirm(this.travelHazmat);
		this.INDRA_checkProgressiveSteps();
		this.INDRA_validateCheckboxes();
	}

	INDRA_validateCheckboxes() {
		this.parallelService.INDRA_setAreCheckboxesCompleted(false);
		let validateCheckboxes = true;
		if (this.showVisaBox && !this.visaToUSA) {
			validateCheckboxes = false;
		}
		if (this.showHazmatBox && !this.travelHazmat) {
			validateCheckboxes = false;
		}
		if (this.isBrazilFlight && !this.checkedBR) {
			validateCheckboxes = false;
		}
		if (this.isEgyptFlight && !this.checkedEG) {
			validateCheckboxes = false;
		}
		if (this.isTurkeyFlight && !this.checkedTR) {
			validateCheckboxes = false;
		}
		if (this.isChinaFlight && !this.checkedCN) {
			validateCheckboxes = false;
		}
		if (this.isCanadaFlight && !this.checkedCA) {
			validateCheckboxes = false;
		}
		if (this.isUnitedKingdomFlight && !this.checkedUK) {
			validateCheckboxes = false;
		}

		if (validateCheckboxes) {
			this.parallelService.INDRA_setAreCheckboxesCompleted(true);
		}
	}

	INDRA_hazmatClick() {
		this.sidebarService.openSidebar(['hazmat']);
	}

	doScrolling(elementY, duration) {
		const startingY = window.pageYOffset;
		const diff = elementY - startingY;
		let start;

		window.requestAnimationFrame(function step(timestamp) {
			start = (!start) ? timestamp : start;
			const time = timestamp - start;
			const percent = Math.min(time / duration, 1);
			window.scrollTo(0, startingY + diff * percent);
			if (time < duration) {
				window.requestAnimationFrame(step);
			}
		});
	}

	/**
	 * Handles creation of booking/PNR to be paid
	 */
	INDRA_createBooking() {
		this.timeoutSvc.skipRenewSession$.next(true);

		return new Promise(resolve => {
			let isBookingCreated = false;
			const createSubscription = this.bookingSearchService.INDRA_createBooking().subscribe((response: any) => {
				if (response && response.status === '200' && response.data) {
          this.isAfterCreatePNR = true;
					this.trip_pnr = response.data.pnrNumber;
					sessionStorage.setItem('bookingPnr', response.data.pnrNumber);
					this.storage.set('lastname', this.passengers[0].surname);
					isBookingCreated = true;

					this.booked_trip.data.pnr = this.trip_pnr;
					this.bfmStorage.INDRA_setActiveBookedTrip(this.booked_trip);
					this.INDRA_updateShoppingCartPNR(this.trip_pnr);
					this.trackindIDPaypal = response.data && response.data.trackindIDPaypal ? response.data.trackindIDPaypal : '';
					const createAncillariesError = response.data && response.data.createAncillariesError ? response.data.createAncillariesError : null;
					if (createAncillariesError) {
						this.hasCreateAncillariesError = true;
						// remove  ancillaries due ancillaries creation error in backend
						this.ancillariesShoppingCartService.INDRA_emptyAncillariesShoppingCart(false);
					} else {
						this.hasCreateAncillariesError = false;
						// get tierBenefits of pax and update booked_trip
						const tierBenefits = response.data && response.data.ancillariesBenefitByPaxBeanList ? response.data.ancillariesBenefitByPaxBeanList : [];
						this.bfmStorage.INDRA_setPassengerTierBenefitInfo(tierBenefits);
						this.ancillariesRemoved = tierBenefits ? [].concat(...tierBenefits.map(item => (item.ancillaryCodesToRemove || []))) : [];
					}

					this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();

					this.INDRA_loadPaypalTrackindID();
					this.paxTierListString = this.INDRA_getPaxTierList();

					// clear idOperation so that it cant be used on newly created PNRs
					this.storage.remove('idOperation');
					this.paymentService.setPaymentOperationID(null);
					if (this.dataPayment && this.dataPayment.data && this.dataPayment.data.idOperation) {
						this.dataPayment.data.idOperation = null;
					}

					if (response.data['paymentTimeLimitMX']) {
						sessionStorage.setItem('paymentTimeLimit', response.data['paymentTimeLimitMX']);
					}

				} else if (response && response.status === '409' && response.data) {
					const hasBeenIssued = response.data.hasBeenIssued;
					const statusBook = response.data.conversationDupe.data.statusBook;
					this.trip_pnr = response.data.conversationDupe.data.pnr;
					sessionStorage.setItem('bookingPnr', this.trip_pnr);
					this.storage.set('lastname', this.passengers[0].surname);
					this.lastname = this.storage.get('lastname');
					this.dupeCurrency = response.data.conversationDupe.data.fare.currency;

					// TODO - consider payment status for async payments
					if (hasBeenIssued) {
						// if booking is already paid, redirect to booking view page
						const queryParams: any = { isDupe: true };
						if (statusBook === 'PENDING') queryParams.issue = 'PENDING';
						if (statusBook === 'OK') queryParams.issue = 'ISSUE_OK';
						this.router.navigate(['/my-bookings/view', this.trip_pnr, this.lastname], { queryParams: queryParams });

					} else {
						// else give option to user to continue previous/original booking
						this.dupe_booked_trip = new INDRABookedTripDetails(response.data.conversationDupe);
						this.dupe_booked_trip.data['externalReservations'] = response.data.conversationDupe.externalReservations;
						this.dupe_booked_trip.translate = _.cloneDeep(this.booked_trip.translate);
						this.DUPEdata = response.data;
						this.isDUPE = true;

						if (response.data.conversationDupe.data.market) {
							this.dupeMarket = response.data.conversationDupe.data.market;
						}

						if (response.data['paymentTimeLimitMX']) {
							sessionStorage.setItem('paymentTimeLimit', response.data['paymentTimeLimitMX']);
						}
					}

					isBookingCreated = true;
				}
				resolve(isBookingCreated);
			}, error => {
				resolve(isBookingCreated);
			});

			this.allSubs.push(createSubscription);
		});
	}

	INDRA_updateShoppingCartPNR(updatedPNR) {
		let shoppingCart = this.storage.get("INDRAAncillariesShoppingCartService.shoppingCart");
		if (shoppingCart) {
			const newShoppingCart = _.cloneDeep(shoppingCart);
			newShoppingCart['pnr'] = updatedPNR;
			this.storage.set("INDRAAncillariesShoppingCartService.shoppingCart", newShoppingCart);
		}
	}

	INDRA_createPaymentItemList() {
		this.items_summary = [];

		if (this.isBookingPaymentPage) {
			if (this.flightPriceBreakdownSummary) {
				// tickets
				if (this.flightPriceBreakdownSummary.flightCost) {
					const currency = this.currencyService.INDRA_getCurrencySymbol(this.flightPriceBreakdownSummary.flightCost.currency).unit;
					const miles = this.flightPriceBreakdownSummary.flightCost.miles && this.flightPriceBreakdownSummary.flightCost.miles > 0 ?
						this.flightPriceBreakdownSummary.flightCost.miles + ' M' : '';
					const cash = this.flightPriceBreakdownSummary.flightCost.price ?
						this.flightPriceBreakdownSummary.flightCost.price.toFixed(2) + ' ' + currency : '0.00 ' + currency;

					this.items_summary.push({
						label: 'bookingPayment.text.flights',
						type: 'flight',
						value: miles ? miles + ' + ' + cash : cash
					});
				}

				// TAP ancillaries
				if (this.flightPriceBreakdownSummary.ancillaries && this.flightPriceBreakdownSummary.ancillaries.length > 0) {
					this.isWithAncillaryPayWithMiles = this.flightPriceBreakdownSummary.ancillaries.filter(a => a.payWithMiles).length > 0;
					this.flightPriceBreakdownSummary.ancillaries.forEach(ancillary => {
						const ancillaryDetail = this.ancillariesService.INDRA_getAncillaryConfig(ancillary.type);
						const currency = this.currencyService.INDRA_getCurrencySymbol(ancillary.currency).unit;

						let label = 'bookingView.totalSummary.label.' + ancillaryDetail.id;
						const includedAncillaries = [];
						if (
							ANCILLARY_PRODUCT_PACKS.includes(ancillary.type)
						) {
							label = 'bookingView.totalSummary.label.pack';
							const packs = this.bfmStorage.INDRA_getAncillariesPacks();
							const pack = packs.find(p => p.name === 'BUNDLE_' + ancillary.type);
							
							if (pack) {
								const packFeatures = pack.ancillaryList[0].catalog[0].passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription;
								if (packFeatures && packFeatures.length > 0) {
									packFeatures.forEach((packFeature) => {
										includedAncillaries.push(packFeature.type);
									});
								}
							}
						}

						this.items_summary.push({
							label: label,
							type: 'ancillaries',
							value: ancillary.price + currency,
							miles: ancillary.miles,
							oldValue: ancillary.oldPrice + currency,
							payWithMiles: ancillary.payWithMiles,
							discounted: ancillary.discounted,
							includedAncillaries: includedAncillaries,
						});
					});
				}

				// Third Party Ancillaries
				if (this.flightPriceBreakdownSummary.thirdPartyExtras && this.flightPriceBreakdownSummary.thirdPartyExtras.length > 0) {
					this.flightPriceBreakdownSummary.thirdPartyExtras.forEach(extras => {
						let label;
						switch (extras.type) {
							case 'CARTRAWLER': label = 'bookingView.totalSummary.label.carRental'; break;
							case 'CHUBB': label = 'bookingView.totalSummary.label.insurance'; break;
							case 'CARBON_OFFSET': label = 'bookingView.totalSummary.label.carbonOffset'; break;
							case 'HOTEL': label = 'bookingView.totalSummary.label.hotel'; break;
							case 'DANISH_FUND': label = 'bookingView.totalSummary.label.danishFund'; break;
							default: break;
						}
						const currency = this.currencyService.INDRA_getCurrencySymbol(extras.currency).unit;
						this.items_summary.push({
							label: label,
							type: 'ancillaries',
							value: extras.price.toFixed(2) + currency
						});
					});
				}

				if (this.flightPriceBreakdownSummary.bookingTotal && this.flightPriceBreakdownSummary.bookingTotal.adminFee &&
					this.flightPriceBreakdownSummary.bookingTotal.adminFee > 0) {
					const currency = this.currencyService.INDRA_getCurrencySymbol(this.flightPriceBreakdownSummary.bookingTotal.currency).unit;
					this.items_summary.push({
						label: 'bookingView.totalSummary.label.adminFee',
						type: 'admin',
						value: this.flightPriceBreakdownSummary.bookingTotal.adminFee.toFixed(2) + ' ' + currency
					});
				}

				// Discounts
				if (this.hasDiscounts && this.flightPriceBreakdownSummary.totalDiscount) {
					const currency = this.currencyService.INDRA_getCurrencySymbol(this.flightPriceBreakdownSummary.totalDiscount.currency).unit;
					const miles = this.flightPriceBreakdownSummary.totalDiscount.miles && this.flightPriceBreakdownSummary.totalDiscount.miles > 0 ?
						this.flightPriceBreakdownSummary.totalDiscount.miles + ' M' : '';
					const cash = this.flightPriceBreakdownSummary.totalDiscount.amount ?
						this.flightPriceBreakdownSummary.totalDiscount.amount.toFixed(2) + ' ' + currency : '';
					this.items_summary.push({
						label: 'bookingPayment.text.discounts',
						type: 'discount',
						value: miles.length > 0 ? miles + ' + ' + cash : cash
					});
				}
			}
		} else if (this.isTTTPaymentPage) {
			this.items_summary.push({
				label: 'bookingPayment.text.timeToThink',
				value: this.tttAmount + this.currencyUnit
			});
		}
	}

	INDRA_checkForUpdatedPrices() {
		this.hasUpdatedFlightPrices = false;
		if (this.booked_trip.data.passengerTierBenefitInfo && this.booked_trip.data.passengerTierBenefitInfo.length) {
			const tierBenefits = this.booked_trip.data.passengerTierBenefitInfo;
			const shoppingCart = this.storage.get('INDRAAncillariesShoppingCartService.shoppingCart');
			if (shoppingCart && shoppingCart.itemsAdded && shoppingCart.itemsAdded.length) {
				const itemsAdded = shoppingCart.itemsAdded;
				itemsAdded.forEach(item => {
					const isItemFree = tierBenefits.find(tier => tier.paxId == item.paxId && tier.ancillaryCodes.includes(item.code));
					if (isItemFree && item.price) {
						item.discounted = true;
						item.oldPoints = item.points;
						item.oldPrice = item.price;
						item.points = 0;
						item.price = 0;
						this.hasUpdatedFlightPrices = true;
					}
				});

				if (this.hasUpdatedFlightPrices) {
					shoppingCart.itemsAdded = itemsAdded;
					this.storage.set('INDRAAncillariesShoppingCartService.shoppingCart', shoppingCart);
					this.ancillariesShoppingCartService.INDRA_updateAddedAncillariesPrices(shoppingCart);
					this.INDRA_createPaymentItemList();
				}
			}
		}
	}

	// remove mgp discount on step 4 if user is not logged in or not miles&go member
	async INDRA_checkIfEligibleForDiscount() {
		if (!this.userInfo || !this.isUserMGPClient) {
			await this.milesService.INDRA_updateMiles(0);
			this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction({ miles: 0, cash: 0 }));
			this.store.dispatch(new MilesBarActions.SetDiscount(0));
			const newArray = this.bookedTripDiscounts.filter(discounts => discounts.id !== 'mile-go');
			this.store.dispatch(new BookedTripActions.PutBookedTripDiscountsAction(newArray));
			this.applyMilesGoDiscount = false;
			this.hasMilesGoDiscount = false;
		}
	}

	INDRA_updateMiles() {
		return new Promise(resolve => {
			this.milesService.INDRA_updateMiles(0).subscribe(res => {
				resolve(true);
			}, err => {
				resolve(true);
			});
		});
	}

	INDRA_handlePriceBreakDown() {
		this.amountSummary.INDRA_handlePriceBreakdown();
		// const isPNRAlreadyCreated = this.trip_pnr && this.trip_pnr.length == 6 ? true : false;
		// if (isPNRAlreadyCreated) {
		// 	let params = {
		// 		isBookingCreated: true
		// 	};
		// 	this.sidebarService.openSidebar(['booking-price-breakdown', params]);
		// } else {
		// 	this.sidebarService.openSidebar(['booking-price-breakdown']);
		// }
	}


	// ***************** Payment flow ***************** //


	INDRA_loadPaymentMethods() {
		this.showPaymentForm = false;

		// get correct market to use in payment method API call
		this.market = this.storage.get(SESSION_VAR_KEY_MARKET);
		let bookingMarket = this.market;
		if (this.bookAwardFlights && !AWARD_FLOW_MARKETS.includes(bookingMarket)) {
			bookingMarket = COUNTRY_CODE_PORTUGAL;
		}

		this.parallelService.INDRA_setIsPaymentMethodLoading(true);
		return new Promise(resolve => {
      this.milesService.INDRA_setTriggerUseMiles(false);
			this.paymentMethodSubscription =
				this.indraPaymentService.INDRA_retrievePaymentMethods(bookingMarket).subscribe(res => {
					if (res.data) {
						this.paymentMethodsRetreived = true;
						this.bfmStorage.INDRA_setPaymentMethod(res);
						this.paymentSessionID = res.paymentSessionID;
						this.storage.set('paymentSessionID', this.paymentSessionID);
						this.url = `https://h.online-metrix.net/fp/tags.js?org_id=1snn5n9w&session_id=tap_dm${this.paymentSessionID}`;
						this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
							this.url
						);

						this.INDRA_updateMarketPaymentMethods();
						this.storedOCPPaypal = this.userInfo ? res.data.storedOCPPaypal : false;

						const cardlessObj: INDRAPaymentMethodFops = res.data.fops.find(fop => fop.fopCode === PAYMENT_METHOD_CARDLESS);
						if (cardlessObj && cardlessObj.enable) {
							this.cardlessEnabled = true;
							this.cardlessToken = res.data.tokenCardLess;
						}

						this.showPaymentForm = true;
						this.arePaymentMethodsLoaded = true;
						this.parallelService.INDRA_setIsPaymentMethodLoading(false);
					} else {
						this.showPaymentForm = false;
						this.arePaymentMethodsLoaded = false;
					}

          this.milesService.INDRA_setTriggerUseMiles(true);
          resolve(true);
				},
					err => {
						this.showPaymentForm = true;
						this.arePaymentMethodsLoaded = true;
						this.parallelService.INDRA_setIsPaymentMethodLoading(false);

						resolve(true);
					});

			this.allSubs.push(this.paymentMethodSubscription);
		});
	}

	INDRA_updateMarketPaymentMethods() {
		this.marketPaymentMethods = [];
		this.disabledPaymentMethods = [];
		const enabledPaymentMethods = [];
		const paymentMethodResponse = this.bfmStorage.INDRA_getPaymentMethod();
		if (paymentMethodResponse && paymentMethodResponse.data &&
			paymentMethodResponse.data.fops && paymentMethodResponse.data.fops.length > 0) {
			paymentMethodResponse.data.fops.forEach(fop => {
				// get all payment methods
				let paymentMethod = this.bookingPaymentService.INDRA_getPaymentMethodIconName(fop.paymentMethodCode, fop.fopCode);
				if (paymentMethod) {
					paymentMethod = Array.isArray(paymentMethod) ? paymentMethod : [paymentMethod];
					if (paymentMethod.length) {
						paymentMethod.forEach(fopIconName => {
							if (this.marketPaymentMethods.indexOf(fopIconName) < 0) {
								this.marketPaymentMethods.push(fopIconName);
							}

							const index = this.disabledPaymentMethods.indexOf(fopIconName);

							// check if payment method should be disabled or not based on contents of the booking
							const isFOPEnabled = this.INDRA_isFOPEnabledPerBookingScenario(fopIconName);

							/*
							 * Note: If this.hasFOPCountError = true, it means there is an FOP count error from the backend thus all FOPs
							 * must be disabled. If isFOPEnabled = false, it means that the specific FOP is not allowed for the
							 * current booking scenario thus the FOP must be disabled.
							 */
							if (this.hasFOPCountError || !isFOPEnabled) {
								if (index < 0) this.disabledPaymentMethods.push(fopIconName);
							} else {
								// normal case
								if (fop.enable) {
									enabledPaymentMethods.push(fopIconName);
									// enable payment method if other fop (but same payment method) is enabled
									if (index > -1) this.disabledPaymentMethods.splice(index, 1);
								} else if (index < 0 && !fop.enable && !enabledPaymentMethods.includes(fopIconName)) {
									this.disabledPaymentMethods.push(fopIconName);
								}
							}
						})
					}
				}
			});
			this.marketPaymentMethods.sort();
			const marketPaymentMethodsWithCards = this.marketPaymentMethods.filter(fop => fop === 'credit_card' || fop === 'debit_card');
			const marketPaymentMethodsWithoutCards = this.marketPaymentMethods.filter(fop => fop !== 'credit_card' && fop !== 'debit_card');
			this.marketPaymentMethods = marketPaymentMethodsWithCards.concat(marketPaymentMethodsWithoutCards);
		}

		// set disabled tooltip (if applicable)
		if (this.disabledPaymentMethods.length > 0) {
			this.disabledTooltipMessage = this.INDRA_getDisabledFOPToolTip();
		}
	}

	INDRA_isFOPEnabledPerBookingScenario(fopIconName: string) {
		let enabled = true;
		switch (fopIconName) {
			case this.paymentService.paymentMethods.pickup.id:
			case this.paymentService.paymentMethods.bank_transfer.id:
				if (this.hasStopover || this.bookAwardFlights || this.hasAdjustedCashPrice || this.promoCodesAndVoucher.length > 0 ||
					this.isWithAncillaryPayWithMiles || this.booked_trip.insurance || this.booked_trip.rented_car.length != 0 ||
					this.booked_trip.carbon_offset || this.booked_trip.danish_fund || this.selectedHotels.length > 0) {
					enabled = false;
				}
				break;
			default:
				break;
		}
		return enabled;
	}

	INDRA_getDisabledFOPToolTip() {
		let isDisabledToolTip = '';
		if (this.hasFOPCountError) {
			isDisabledToolTip = this.INDRA_getTranslation('bookingPayment.text.removePaymentMethod');
		} /* else if (this.hasPartnerExtras) {
			isDisabledToolTip = this.INDRA_getTranslation('bookingPayment.text.paymentMethodNotAvailableExtras');
		} else if (this.recover_insurance) {
			isDisabledToolTip = this.INDRA_getTranslation('bookingPayment.text.paymentMethodNotAvailableInsurance');
		} */
		else {
			isDisabledToolTip = this.INDRA_getTranslation('bookingPayment.text.paymentMethodNotAvailable');
		}

		return isDisabledToolTip;
	}

	INDRA_handleBackPayment() {
		this.isUpdateCCFeeAPIAllowed = false;
		let purchasedSeat = sessionStorage.getItem('hasPurchasedSeat');
		if (purchasedSeat) {
			purchasedSeat = JSON.parse(purchasedSeat);
			purchasedSeat['paymentSuccessful'] = true;
			sessionStorage.setItem('hasPurchasedSeat', JSON.stringify(purchasedSeat));
		}
		this.paymentService.setFormIsValid(false);
		this.lastname = this.storage.get('lastname');
		this.bfmStorage.INDRA_setDeletedPreviouslyPurchasedSeats([]);

		if (this.isFCECybersourceRejectedScenario) { // this is CC Fraud scenario of either cybersource or FCE (no repayment will be offered)
			this.router.navigate(['/my-bookings/view', this.trip_pnr, this.lastname], { queryParams: { issue: 'PURCHASE_ERROR' } });
		} else if (this.selectedPaymentMethod == this.paymentService.paymentMethods.mb_way.id ||
			this.selectedPaymentMethod == this.paymentService.paymentMethods.multibanco.id ||
			this.selectedPaymentMethod == this.paymentService.paymentMethods.multicaixa.id ||
			this.selectedPaymentMethod == this.paymentService.paymentMethods.pickup.id ||
			this.selectedPaymentMethod == this.paymentService.paymentMethods.bank_transfer.id) {
			this.observatory.setData('prpPaymentInfo', this.paymentService.getPaymentInfo());
			this.INDRA_registerGAPurchase(true); // generate GA purchase object and fire event
			this.router.navigate(['/my-bookings/view', this.trip_pnr, this.lastname], { queryParams: { issue: 'PENDING' } });
		} else {
			this.INDRA_registerGAPurchase(true); // generate GA purchase object and fire event
			this.router.navigate(['/my-bookings/view', this.trip_pnr, this.lastname]);
		}
	}


	INDRA_createDataPay() {
		// Build object for Payment Card
		this.dataPay = this.INDRA_getPaymentCard();
		if (this.dataPay.creditCardEncrypted) {
			this.INDRA_handlePay(this.dataPay, this.paymentINDRA.INDRA_FormValue(this.selectedPaymentMethod).number);
		}
	}

	public INDRA_handlePay(dataPay, card_number) {
		this.alertErrorPayment = false;
		this.notificationCybersource = false;
		this.alertErrorPaymentresultFCE = false;
		this.paymentRefused = false;
		this.alertErrorPaymentresultCyberSourceReject = false;
		this.hasVoucherErrorFlag1 = false;
		this.hasVoucherErrorFlag2 = false;
		this.paymentLoading = true;

		if (this.countdownPaymentRefused >= 0) {
			// this.buttonPayment.nativeElement.disabled =  true;
			this.isButtonPaymentDisableOverride = true;
			// Call payment/credit/card
			this.creditCardSubscription = this.indraPaymentService.INDRA_paymentCreditCard(dataPay).subscribe(
				(response: any) => {
					this.dataPayment = response;
					console.log('Payment response: ' + JSON.stringify(this.dataPayment));
					this.hasCreateAncillariesError = false;

					if (this.dataPayment && this.dataPayment.data && this.dataPayment.data.idOperation) {
						this.paymentService.setPaymentOperationID(this.dataPayment.data.idOperation);
						this.storage.set('idOperation', this.dataPayment.data.idOperation);
					}

					if (this.dataPayment.status !== '400' /* && this.dataPayment.status !== '300' */ && this.dataPayment.status !== '301' && this.dataPayment.status !== '500' && this.dataPayment.status !== 'ERROR') {
						if (response.data && response.data.paymentResultAdyen) {
							this.paymentLoading = true;
							switch (response.data.paymentResultAdyen.resultCode) {
								case 'Authorised':
									const issueOk = response.data.statusBook === 'ISSUE_OK';
									if (issueOk) {
										if (response.data.pnr) {
											this.redirectPnr = response.data.pnr;
										}
										if (response.data.surname) {
											this.storage.set('lastname', response.data.surname);
										}
									}
									this.INDRA_authorised(response.data.statusBook);
									break;
								case 'Refused': {
									this.paymentService.setClearPaymentForm(true);
									this.INDRA_refused();
								} break;
								case 'IdentifyShopper': {
									// Build iframe Identify Shopper
									this.INDRA_buildIFrameIdentifyShopper();
									// Submit Identify Shopper
									setTimeout(() => { this.INDRA_submitIdentifyShopper(); }, 500);
									// Call status iframe identify shopper
									this.INDRA_getStatusIdentifyShopper();
								} break;
								case 'RedirectShopper': {
									// Build iframe Redirect Shopper
									this.INDRA_buildIFrameRedirectShopper();
									this.termUrl = response.data.urlResponse;
									this.termUrl = response.data.urlResponse;
									this.paReq = response.data.paymentResultAdyen.paRequest;
									this.md = response.data.paymentResultAdyen.md;
									setTimeout(() => { this.INDRA_submitRedirectShopper(); }, 500);
								} break;
								default: {
									this.paymentService.setClearPaymentForm(true);
									this.INDRA_refused();
								} break;
							}
						} else if (this.dataPayment.data.resultCyberSource === 'REJECT') {
							// this.buttonPayment.nativeElement.disabled = false;
							this.isButtonPaymentDisableOverride = false;
							this.isFCECybersourceRejectedScenario = true;
							this.isUpdateCCFeeAPIAllowed = false;
							this.INDRA_resetOtherErrors('reject');
							this.paymentService.setClearPaymentForm(true);
							this.INDRA_handleBackPayment();

						} else if (this.dataPayment.data.resultCyberSource === 'REVIEW' || this.dataPayment.data.resultFCE === 'REVIEW') {
							// this.buttonPayment.nativeElement.disabled = false;
							this.isButtonPaymentDisableOverride = false;
							this.INDRA_modalCybersource();
							this.paymentLoading = false;

						} else if (this.dataPayment.data.resultFCE === 'REJECT A' || this.dataPayment.data.resultFCE === 'REJECT') {
							// this.buttonPayment.nativeElement.disabled = false;
							this.isButtonPaymentDisableOverride = false;
							this.isFCECybersourceRejectedScenario = true;
							this.isUpdateCCFeeAPIAllowed = false;
							this.INDRA_resetOtherErrors('fce');
							this.paymentService.setClearPaymentForm(true);
							this.INDRA_handleBackPayment();

						} else { /*if (this.INDRA_zeroTotal()) { */
							const issueOk = response.data.statusBook === 'ISSUE_OK';
							if (issueOk) {
								if (response.data.pnr) {
									this.redirectPnr = response.data.pnr;
								}
								if (response.data.surname) {
									this.storage.set('lastname', response.data.surname);
								}
							}
							this.INDRA_authorised(response.data.statusBook);
						}

						// Handler for Paid PNR due to multiple payment attempts by user
						// } else if (this.dataPayment.status === '400' && this.dataPayment.errors[0].code === '34' &&
						// this.dataPayment.errors[0].desc === 'Error PNR paid IBE') {
						// 	const issueOk = response.data.statusBook === 'ISSUE_OK';
						// 	if (issueOk) {
						// 		if (response.data.pnr ) {
						// 			this.redirectPnr = response.data.pnr;
						// 		}
						// 		if (response.data.surname ) {
						// 			this.storage.set('lastname', response.data.surname);
						// 		}
						// 	}
						// 	this.INDRA_authorised(response.data.statusBook);
					} else if ((response.status === '400' && response.errors && response.errors.length && response.errors.some(err => err.code === '34' &&
						err.desc === "Error PNR paid IBE")) || response.status === 'ERROR') {
						this.INDRA_repaymentErrorRedirect();
					} else {
						this.paymentService.setClearPaymentForm(true);
						this.INDRA_errorPayment();
						this.INDRA_paymentAttempt();
						if (this.countdownPaymentRefused >= 0) this.INDRA_checkPaymentMethodCount(false);
						this.INDRA_checkPaymentTries();
					}
				},
				(err) => {
					console.log('error', err);
					// handle http error, do not allow subsequent payment attempts
					if (err instanceof HttpErrorResponse) {
						this.paymentLoading = false;
						this.confirmedPassengersAndContacts = false;
						this.hasPaymentStepError = true;
					} else {
						this.paymentService.setClearPaymentForm(true);
						this.INDRA_errorPayment();
						this.hasCreateAncillariesError = false;
					}
				}
			);
			// this.INDRA_redeemVoucher(dataPay);
		} else {
			this.INDRA_repaymentTriesLimitErrorRedirect();
		}
		this.allSubs.push(this.creditCardSubscription);

	}


	async INDRA_redeemVoucher(callback = () => {}) {
		this.paymentLoading = true;
		if (this.promoCodesAndVoucher && this.promoCodesAndVoucher.length > 0) {
			let redeemVoucherSuccessFlag: boolean = false;
			let redeemVoucherResults: any = [];

			if (this.redeemVoucherAPICallFlag) {
				this.redeemVoucherAPICallFlag = false;
				try {
					const response = await this.awaitableObservable(this.indraPaymentService.INDRA_redeemVoucher());
					this.redeemVoucherAPICallFlag = true;
					if (response && response.status == '200') {
						if (response.data) {
							const vouchers = response.data.vouchers;
							if (vouchers && vouchers.length > 0) {
								vouchers.map(data => {
									if (data.status === 'KO') {
										redeemVoucherResults.push(data);
									}
								});

								if (redeemVoucherResults && redeemVoucherResults.length > 0) {
									//CASE: THERE IS AN ERROR WITH ONE OF THE VOUCHERS
									//METHOD: DISPLAY THE WARNING MESSAGE TO THE PAYMENT PAGE REGARDING THE VOUCHER ISSUE
									redeemVoucherSuccessFlag = false;
								} else {
									//CASE: ALL VOUCHERS ARE OK
									redeemVoucherSuccessFlag = true;
								}
							} else {
								//CASE: THERE ARE NO VOUCHERS
								redeemVoucherSuccessFlag = true;
							}
						} else {
							redeemVoucherSuccessFlag = true;
						}

					} else {
						//CASE: RESPONSE HAS ERROR STATUS
						redeemVoucherSuccessFlag = false;
					}
				} catch (err) {
					this.redeemVoucherAPICallFlag = true;

					//CASE: ERROR WITH THE INDRA_redeemVoucher RESPONSE
					console.log('error', err);
					await this.INDRA_errorRedeemVoucher(redeemVoucherResults);
					await callback();
				}

				if (redeemVoucherSuccessFlag) {
					await callback();
					if (this.isZeroCashPayment) {
						//CASE: PROCEED WITH THE ZERO CONFIRMATION OF PAYMENT
						this.INDRA_proceedConfirmZeroPayment();
					} else {
						//CASE: PROCEED WITH THE CONFIRMATION OF PAYMENT
						this.INDRA_proceedConfirmPayment();
					}
				} else {
					await this.INDRA_errorRedeemVoucher(redeemVoucherResults);
					await callback();
				}
			}

		} else {
			await callback();
			if (this.isZeroCashPayment) {
				//CASE: PROCEED WITH THE ZERO CONFIRMATION OF PAYMENT
				this.INDRA_proceedConfirmZeroPayment();
			} else {
				//CASE: PROCEED WITH THE CONFIRMATION OF PAYMENT
				this.INDRA_proceedConfirmPayment();
			}
		}
	}

	INDRA_proceedConfirmZeroPayment() {
		this.dataPay = this.INDRA_getDummyPaymentCard();
		if (this.dataPay.creditCardEncrypted) {
			this.INDRA_handlePay(this.dataPay, this.cardNumber);
		}
	}

	INDRA_proceedConfirmPayment() {
		// generate GA purchase object and save to session storage so that this can be sent to GA once the user is in the confirmation page
		this.INDRA_registerGAPurchase(false);

		// set miles used for GA data layer use
		this.storage.set('shoppingCartMiles',
			(this.totalFlightPrice && this.totalFlightPrice.miles ? this.totalFlightPrice.miles : 0));

		this.selectedPaymentMethodTranslationKey = this.bookingPaymentService.INDRA_getFOPLabelTranslationKey(this.selectedPaymentMethod);
		switch (this.selectedPaymentMethod) {
			case this.paymentService.paymentMethods.credit_card.id:
				switch (this.selectedCardType) {
					case 'available':
						this.INDRA_CreditCardOCPSubmit(); break;
					case 'other':
						this.INDRA_createDataPay(); break;
					case 'expired':
						console.log('no handler yet for expired cards'); break;
				}
				break;

			case this.paymentService.paymentMethods.debit_card.id:
				switch (this.selectedCardType) {
					case 'available':
						this.INDRA_CreditCardOCPSubmit(); break;
					case 'other':
						this.INDRA_createDataPay(); break;
					case 'expired':
						console.log('no handler yet for expired cards'); break;
				}
				break;

			case this.paymentService.paymentMethods.bancontact.id:
				this.INDRA_createDataPay(); break;

			case this.paymentService.paymentMethods.paypal.id:
				this.INDRA_paypalNormalButton(); break; // TODO handle this using submitPayment method

			case this.paymentService.paymentMethods.mb_way.id:
			case this.paymentService.paymentMethods.multibanco.id:
			case this.paymentService.paymentMethods.alipay.id:
			case this.paymentService.paymentMethods.klarna_pay_now.id:
			case this.paymentService.paymentMethods.klarna_pay_later.id:
			case this.paymentService.paymentMethods.poli.id:
			case this.paymentService.paymentMethods.ideal.id:
			case this.paymentService.paymentMethods.multicaixa.id:
			case this.paymentService.paymentMethods.pickup.id:
			case this.paymentService.paymentMethods.bank_transfer.id:
			case this.paymentService.paymentMethods.caixa_loterias.id:
			case this.paymentService.paymentMethods.bank_transfer_br.id:
				
				this.isButtonPaymentDisableOverride = true;
				// if (this.buttonPayment) {
				// 	this.buttonPayment.nativeElement.disabled = true;
				// }
				this.paymentService.submitPayment();
				break;

			default:
				console.log('No handler yet for payment method');
				break;
		}
	}

	INDRA_resetOtherErrors(activeError) {
		this.alertErrorPayment = false;
		this.alertErrorPaymentresultCyberSourceReject = false;
		this.alertErrorPaymentresultFCE = false;
		this.notificationCybersource = false;
		this.paymentRefused = false;
		this.hasVoucherErrorFlag1 = false;
		this.hasVoucherErrorFlag2 = false;

		switch (activeError) {
			case 'error': this.alertErrorPayment = true; break;
			case 'fce':
			case 'reject': this.alertErrorPaymentresultFCE = true; break;
			case 'notification': this.notificationCybersource = true; break;
			case 'refused': this.paymentRefused = true; break;
			case 'voucher-error1': this.hasVoucherErrorFlag1 = true; break;
			case 'voucher-error2': this.hasVoucherErrorFlag2 = true;
				break;
			default: break;
		}
	}

	INDRA_getStatusIdentifyShopper() {
		const dataIdOperation = {
			'idOperation': this.dataPayment.data.idOperation
		};

		this.statusTransactionSubscription1 =
			this.indraPaymentService.INDRA_getStatusTransaction(dataIdOperation).subscribe((response) => {
				switch (response.data.paymentResultAdyen.resultCode) {
					case 'Authorised': this.INDRA_authorised(response.data.statusBook); break;
					case 'Refused':
						this.paymentService.setClearPaymentForm(true);
						this.INDRA_refused();
						break;
					case 'ChallengeShopper': {
						// Build iframe ChallangeShopper
						this.INDRA_buildIFrameChallangeShopper(response.data.paymentResultAdyen.additionalData);
						// Submit Challange Shopper
						setTimeout(() => { this.INDRA_submitChallengeShopper(); }, 500);
						// Call getStatusTransaction ChallangeShopper
						this.INDRA_getStatusChallangeShopper(dataIdOperation);
					} break;
					case 'IdentifyShopper': {
						this.paymentService.setClearPaymentForm(true);
						this.INDRA_refused();
					} break;
					default: this.INDRA_errorPayment(); break;
				}
			});
		this.allSubs.push(this.statusTransactionSubscription1);
	}

	INDRA_getStatusChallangeShopper(dataIdOperation: any) {
		this.statusTransactionSubscription2 =
			this.indraPaymentService.INDRA_getStatusTransaction(dataIdOperation).subscribe((response) => {
				if (response.data.paymentResultAdyen.resultCode === 'Refused') {
					this.paymentService.setClearPaymentForm(true);
					this.INDRA_refused();
				} else if (response.data.paymentResultAdyen.resultCode === 'Authorised') {
					this.INDRA_authorised(response.data.statusBook);
				} else if (response.data.paymentResultAdyen.resultCode === 'TimeOut') {
					this.INDRA_errorPayment();
				} else {
					this.INDRA_errorPayment();
				}
			});
		this.allSubs.push(this.statusTransactionSubscription2);
	}

	INDRA_buildIFrameRedirectShopper() {
		this.threeDSMethodRedirectShopperURL = this.dataPayment.data.paymentResultAdyen.issuerUrl;
	}

	INDRA_buildIFrameIdentifyShopper() {
		const dataObj = {
			'threeDSServerTransID': this.dataPayment.data.paymentResultAdyen.additionalData['threeds2.threeDSServerTransID'],
			'threeDSMethodNotificationURL': this.dataPayment.data.urlResponse
		};
		this.threeDSMethodURL = this.dataPayment.data.paymentResultAdyen.additionalData['threeds2.threeDSMethodURL'];
		const stringifiedDataObject = JSON.stringify(dataObj);
		this.encodedJSON = btoa(stringifiedDataObject);
	}

	INDRA_buildIFrameChallangeShopper(additionalData: any) {
		const cReqData = {
			'threeDSServerTransID': additionalData['threeds2.threeDSServerTransID'],
			'acsTransID': additionalData['threeds2.threeDS2ResponseData.acsTransID'],
			'messageVersion': additionalData['threeds2.threeDS2ResponseData.messageVersion'],
			'challengeWindowSize': '05',
			'messageType': 'CReq'
		};
		this.threeDSMethodURLShopper = additionalData['threeds2.threeDS2ResponseData.acsURL'];
		const stringifiedDataObjectShopper = JSON.stringify(cReqData);
		this.encodedcReq = btoa(stringifiedDataObjectShopper);
	}

	INDRA_getInfoUSer(): DataUserPayment {
		const dataUserPayment: DataUserPayment = this.paymentINDRA.INDRA_FormValue(this.selectedPaymentMethod);
		return dataUserPayment;
	}

	INDRA_getPaymentCard(): any {
		this.lastname = this.storage.get('lastname');
		const dataUserPayment: DataUserPayment = this.INDRA_getInfoUSer();
		const encrypted = JSON.stringify(dataUserPayment);
		this.creditCardEncrypted = btoa(encrypted);

		const paymentBaseURL = this.isBookingPaymentPage ? 'booking/payment' : 'booking/time-to-think/payment';
		const cashAmountToPay = this.flightPriceService.INDRA_convertToCorrectDecimalPlace(this.totalFlightPrice.cash.toString());
		const currency = this.totalFlightPrice.currency;

		const dataPay = {
			'browserInfo': new BrowserInfo(),
			'deviceChannel': 'browser',
			'deviceFingerPrintId': this.paymentSessionID,
			'merchantAccount': dataUserPayment.merchantAccount,
			'sessionId': this.storage.get('token'),
			'urlNavegationOk': `my-bookings/view/${this.trip_pnr}/${this.lastname}?issue=`,
			'urlNavegationKo': `${paymentBaseURL}/redirect/${this.trip_pnr}?issue=`,
			'currency': currency,
			'amount': cashAmountToPay,
			'pnr': this.trip_pnr,
			'creditCardEncrypted': this.creditCardEncrypted,
			'flyTapId': null
		};

		// set surcharge %
		if (this.surcharge > 0) {
			dataPay['fee'] = this.surcharge.toFixed(2);
		}

		// is save card data is checked
		if (this.saveCardData) {
			dataPay['typePaymentCreditCard'] = PAYMENT_CC_TYPE_STORE_FOR_OCP;
		}

		if (this.isBookingPaymentPage) {
			if (this.totalFlightPrice && this.totalFlightPrice.miles) {
				dataPay['points'] = this.totalFlightPrice.miles.toString();
			}
		}

		if (this.userInfo) {
			dataPay['flyTapId'] = this.userInfo.airlineID;
		}

		if (this.dataPayment && this.dataPayment.data && this.dataPayment.data.idOperation) {
			dataPay['idOperation'] = this.dataPayment.data.idOperation;
		}

		const idOperation = this.paymentService.getPaymentOperationID();
		if (!dataPay['idOperation'] && idOperation) {
			dataPay['idOperation'] = idOperation;
		}

		this.cardNumber = dataUserPayment.number;

		// fix to bookingFlow request with "typePaymentCreditCard": "OCPSTORE" but no flyTapId
		if (dataPay && dataPay['typePaymentCreditCard'] && !dataPay['flyTapId']) {
			delete dataPay['typePaymentCreditCard'];
		}

		return dataPay;
	}

	public INDRA_authorised(issuePnr) {
		// this.buttonPayment.nativeElement.disabled = false;
		this.isButtonPaymentDisableOverride = false;
		if (issuePnr === 'ISSUE_OK') {
			this.observatory.setData('issueAuthorisedOK', true);
		} else if (issuePnr === 'ISSUE_KO') {
			this.observatory.setData('issueAuthorisedKO', true);
		}
		this.INDRA_clearStorage();
		this.INDRA_handleBackPayment();
	}

	INDRA_modalCybersource() {
		this.modalService.assignComponent(
			INDRACybersourceModalComponent,
			this.dataPay,
			this.dataPayment.data.idOperation,
			this.dataPayment.data.fraudMessage,
			this.cardNumber,
			PAYMENT_FLOW_BOOKING);
		this.modalService.open();
		this.store.dispatch(new ModalActions.PutShowCloseAction(false));
	}

	INDRA_refused() {
		// this.buttonPayment.nativeElement.disabled = false;
		this.isButtonPaymentDisableOverride = false;
		this.paymentRejected = false;
		this.paymentRefused = true;
		this.INDRA_resetOtherErrors('refused');
		this.INDRA_paymentAttempt();
		// this.showPaymentForm = true;
		this.paymentLoading = false;
		this.INDRA_doScroll(`payment-method-section`);
		this.INDRA_checkPaymentTries();
	}

	INDRA_errorPayment() {
		this.isButtonPaymentDisableOverride = false;
		// if (this.buttonPayment) {
		// 	this.buttonPayment.nativeElement.disabled = false;
		// }
		this.alertErrorPayment = true;
		this.INDRA_resetOtherErrors('error');
		// this.showPaymentForm = true;
		this.paymentLoading = false;
		this.INDRA_doScroll(`payment-method-section`);
	}

	INDRA_paymentRejected() {
		this.isButtonPaymentDisableOverride = false;
		// if (this.buttonPayment) {
		// 	this.buttonPayment.nativeElement.disabled = false;
			
		// }
		this.INDRA_resetOtherErrors('reject');
		this.paymentLoading = false;
		this.INDRA_doScroll(`payment-method-section`);
		this.INDRA_paymentAttempt();
	}


	async INDRA_errorRedeemVoucher(redeemVoucherResults) {
		this.redeemVoucherAttempt++;

		//REMOVE VOUCHERS WITH ERROR FROM THE STORE
		if (redeemVoucherResults && redeemVoucherResults.length > 0) {
			const voucherCodesWithErrors = []
			for (const voucherErrorRef of redeemVoucherResults) {
				voucherCodesWithErrors.push(voucherErrorRef.identifier)
			}
			const promoCodesAndVoucherLocal = [...this.promoCodesAndVoucher]
			for (let i = 0; i < promoCodesAndVoucherLocal.length; i++) {
				const voucher = promoCodesAndVoucherLocal[i];
				if (voucher.type === 'voucher' && voucherCodesWithErrors.indexOf(voucher.code) !== -1) {
					promoCodesAndVoucherLocal.splice(i, 1);
					await this.INDRA_removePromocode(voucher);
					this.INDRA_removeDiscount(voucher);
				}
			}
			this.promoCodesAndVoucher = [...promoCodesAndVoucherLocal]
		}

		if (this.redeemVoucherAttempt > 2) {
			this.INDRA_repaymentTriesLimitErrorRedirect();
			this.storage.set('voucherError3rdAttemptFlag', true);
		}
		else if (this.redeemVoucherAttempt == 2) {
			this.INDRA_resetOtherErrors('voucher-error2')

			if (!this.isZeroCashPayment) {
				if (this.promoCodesAndVoucher && this.promoCodesAndVoucher.length > 0) {
					// this.buttonPayment.nativeElement.disabled = false;
					this.isButtonPaymentDisableOverride = false;
				} else {
					// this.buttonPayment.nativeElement.disabled = true;
					this.isButtonPaymentDisableOverride = true;
				}
			}
		} else {
			this.INDRA_resetOtherErrors('voucher-error1')

			// if (this.buttonPayment) {
				if (this.promoCodesAndVoucher && this.promoCodesAndVoucher.length > 0) {
					// this.buttonPayment.nativeElement.disabled = false;
					this.isButtonPaymentDisableOverride = false;
				} else {
					// this.buttonPayment.nativeElement.disabled = true;
					this.isButtonPaymentDisableOverride = true;
				}
			// }
		}

		if (!this.isZeroCashPayment) {
			this.INDRA_doScroll(`payment-method-section`);
		}

		this.paymentService.setClearPaymentForm(true);
		this.paymentLoading = false;
	}
	async INDRA_removePromocode(discount) {
		this.paymentLoading = true;

		const voucher = await this.awaitableObservable(this.discountService.INDRA_removeVoucherInSession(discount.code));
		if (voucher.status === '200' || voucher.status === '406') {
			this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(this.promoCodesAndVoucher));
			this.INDRA_triggerBookingTotalsUpdate();
		}
		this.paymentLoading = false;
	}

	INDRA_triggerBookingTotalsUpdate() {
		if (this.router.url.includes('review-your-trip') || this.router.url.includes('extras-to-your-trip') || (this.router.url.includes('payment'))) {
			this.paymentService.setUpdateBookingTotals(true);
		}
	}

	INDRA_errorRedeemVoucherPaypal(redeemVoucherResults) {
		if (redeemVoucherResults) {
			this.INDRA_errorRedeemVoucher(redeemVoucherResults);
		}
	}


	INDRA_notificationCyberSource() {
		// this.buttonPayment.nativeElement.disabled = false;
		this.isButtonPaymentDisableOverride = false;
		this.notificationCybersource = true;
		this.INDRA_resetOtherErrors('notification');
		// this.showPaymentForm = true;
		this.paymentLoading = false;
	}

	INDRA_submitIdentifyShopper() {
		let theForm = document.forms['3dform'];
		if (!theForm) {
			theForm = document.getElementsByName('3dform');
		}
		theForm.submit();
	}

	INDRA_submitChallengeShopper() {

		let theForm = document.forms['3dschallenge'];
		if (!theForm) {
			theForm = document.getElementsByName('3dschallenge');
		}
		theForm.submit();
	}

	INDRA_submitRedirectShopper() {
		let theForm = document.forms['3dformRedirect'];
		if (!theForm) {
			theForm = document.getElementsByName('3dformRedirect');
		}
		theForm.submit();
	}

	private windowScroll() {
		setTimeout(() => {
			window.scroll(0, 0);
		}, 50);
	}

	INDRA_clearStorage() {
		// TODO check items which should be cleared
	}

	INDRA_CreditCardOCPSubmit() {
		// simplified payment API call and handling for POC purposes
		this.lastname = this.storage.get('lastname');
		const dataUserPaymentObj = this.paymentINDRA.INDRA_FormValue(PAYMENT_CC_TYPE_OCP);
		const dataUserPayment = dataUserPaymentObj['dataUserPayment'];
		const encrypted = JSON.stringify(dataUserPayment);
		const creditCardEncrypted = btoa(encrypted);
		const paymentBaseURL = this.isBookingPaymentPage ? 'booking/payment' : 'booking/time-to-think/payment';

		const cashAmountToPay = this.flightPriceService.INDRA_convertToCorrectDecimalPlace(this.totalFlightPrice.cash.toString());
		const currency = this.totalFlightPrice.currency;

		this.dataPay = {
			browserInfo: new BrowserInfo(),
			deviceChannel: 'browser',
			deviceFingerPrintId: sessionStorage.getItem(SESSION_VAR_KEY_PAYMENT_SESSION_ID),
			merchantAccount: dataUserPayment.merchantAccount,
			sessionId: this.storage.get('token'),
			urlNavegationOk: `my-bookings/view/${this.trip_pnr}/${this.lastname}?issue=`,
			urlNavegationKo: `${paymentBaseURL}/redirect/${this.trip_pnr}?issue=`,
			currency: currency,
			amount: cashAmountToPay,
			pnr: this.trip_pnr,
			creditCardEncrypted: creditCardEncrypted,
			typePaymentCreditCard: PAYMENT_CC_TYPE_OCP,
			flyTapId: dataUserPaymentObj['shopperReference'],
			selectedRecurringDetailReference: dataUserPaymentObj['recurringDetailReference']
		};

		if (this.isBookingPaymentPage) {
			if (this.totalFlightPrice && this.totalFlightPrice.miles) {
				this.dataPay['points'] = this.totalFlightPrice.miles.toString();
			}
		}

		// set surcharge %
		if (this.surcharge > 0) {
			this.dataPay['fee'] = this.surcharge.toFixed(2);
		}

		if (this.dataPayment && this.dataPayment.data && this.dataPayment.data.idOperation) {
			this.dataPay['idOperation'] = this.dataPayment.data.idOperation;
		}

		const idOperation = this.paymentService.getPaymentOperationID();
		if (!this.dataPay['idOperation'] && idOperation) {
			this.dataPay['idOperation'] = idOperation;
		}

		// remove these two objects if recurringDetailsReference is empty.
		if (this.dataPay && this.dataPay['typePaymentCreditCard'] && !this.dataPay['selectedRecurringDetailReference']){
			delete this.dataPay['typePaymentCreditCard'];
			delete this.dataPay['selectedRecurringDetailReference'];
		}

		// fix to bookingFlow request with "typePaymentCreditCard": "OCPSTORE" but no flyTapId
		if (this.dataPay && this.dataPay['typePaymentCreditCard'] && !this.dataPay['flyTapId']) {
			delete this.dataPay['typePaymentCreditCard'];
		}

		this.INDRA_handlePay(this.dataPay, dataUserPayment.number);
	}

	/**
	 * Handles Payment confirmation and redirect to Booking confirmation/details page
	 */
	async INDRA_confirmPayment() {
		try {
			if(!this.formIsValid) {
				this.INDRA_doScroll('payment-option__conditions-wrapper');
				return
			}
			this.INDRA_redeemVoucher();
		} catch(error) {
			const errorString = error instanceof Error ? error.message : String(error);
			this.INDRA_reportToKibana(errorString);
		}
	}

	INDRA_checkPaymentMethodCount(updatePaymentMarketMethods = true) {
		return new Promise(resolve => {
			this.indraPaymentService.INDRA_checkPaymentMethods().subscribe((response: INDRAFlightPriceSummary) => {
				if (response && response.errors && response.errors.length > 0 &&
					response.errors.filter(err => err.desc && err.desc.includes(this.TOO_MANY_FOP_MSG)).length > 0) {
					this.hasFOPCountError = true;
				} else if (response && response.status == '400') {
					this.confirmedPassengersAndContacts = false;
					this.hasPaymentStepError = true;
					this.hasFOPCountError = false;
				} else {
					this.hasFOPCountError = false;
					this.flightPriceBreakdownSummary = response;
					this.INDRA_createPaymentItemList();
				}

				if (response && response.status == '405') {
					this.differentTTTMarket = true; 
				} else {
					this.differentTTTMarket = false;
				}

				// get total price to pay from API (new payment flow)
				if (response && response.bookingTotal) {
					const totalPrice: INDRATotalFlightPrice = {
						cash: response.bookingTotal.amount,
						miles: response.bookingTotal.miles,
						currency: response.bookingTotal.currency
					}
					this.paymentService.setTotalFlightPrice(totalPrice);
					this.paymentService.totalFlightPrice.next(totalPrice);
					this.isZeroCashPayment = totalPrice.cash == 0 ? true : false;

					// do only for brazil market (surcharge/cc fee and installment is not applicable for other markets)
					if (this.isBrazilMarket) {
						if (response.bookingTotal.surcharge != null && response.bookingTotal.surcharge != undefined) {
							this.paymentService.setSurchargeAmount(response.bookingTotal.surcharge);
						}
						this.paymentService.setInstallmentAmount(totalPrice.cash);
					}

					if (response && response.pointsUsed) {
						this.useMilesDisabled = true; 
					} else {
						this.useMilesDisabled = false;
					}

				}

				if (updatePaymentMarketMethods) this.INDRA_updateMarketPaymentMethods();
        		//this.milesService.INDRA_setTriggerUseMiles(true);
				resolve(true);
			}, error => {
				this.hasFOPCountError = false;
				this.confirmedPassengersAndContacts = false;
				this.hasPaymentStepError = true;
				if (updatePaymentMarketMethods) this.INDRA_updateMarketPaymentMethods();
				resolve(true);
			});
			this.paymentService.setTriggerCheckPaymentMethods(false);
		});

	}

	INDRA_isDUPE() {
		if (this.INDRA_getCurrentStep() === 4 && this.isDUPE)
			return true;

		return false;
	}

	INDRA_haveFlighPricesChanged() {
		if (this.INDRA_getCurrentStep() === 4 && this.haveFlighPricesChanged)
			return true;

		return false;
	}


	INDRA_newSearch() {
		this.store.dispatch(new MiniIBEActions.Reset());
		this.router.navigate(['/booking']);
		this.store.dispatch(new BookingStepsActions.ResetAction());
	}

	INDRA_handleDUPE() {
		if (this.dupeMarket && this.market !== this.dupeMarket) {
			this.storage.set('dupeMarket', this.dupeMarket);
			this.store.dispatch(new UserActions.PutMarketAction(this.dupeMarket));
		} else {
			// update currency with dupe currency
			this.currency = this.currencyService.INDRA_getCurrencySymbol().name;
			this.currencyUnit = this.currencyService.INDRA_getCurrencySymbol().unit;

			this.isDupeCompletion = true;
			this.isDUPE = false;
			this.bfmStorage.INDRA_setDupeBookedTrip(null);

			this.INDRA_handleDUPEUpdateStore();

			clearTimeout(this.scrollToStepSettimeout);
			this.scrollToStepSettimeout = setTimeout(() => {
				this.INDRA_doScroll(`step-payment`);
			}, 800);

			this.INDRA_confirmPassengersAndContacts(); // create booking
		}

	}

	INDRA_handleDUPEUpdateStore() {
		this.storage.set('INDRAAncillariesShoppingCartService.shoppingCart', this.dupeShoppingCart);
		this.store.dispatch(new BookedTripActions.RemoveBookedTripExtraAction('hotel'));
		this.store.dispatch(new BookedTripActions.RemoveBookedTripExtraAction('airport-transfers'));
		this.store.dispatch(new BookedTripActions.RemoveBookedTripExtraAction('lisboa-card'));
		this.store.dispatch(new BookedTripActions.RemoveBookedTripExtraAction('sightseeing-tours'));

		if (this.dupe_booked_trip.data.externalReservations.DANISH_FUND) this.dupe_booked_trip.danish_fund = this.dupe_booked_trip.data.externalReservations.DANISH_FUND;
		if (this.dupe_booked_trip.data.externalReservations.CARBON_OFFSET) this.dupe_booked_trip.carbon_offset = this.dupe_booked_trip.data.externalReservations.CARBON_OFFSET;
		if (this.dupe_booked_trip.data.externalReservations.CHUBB) this.dupe_booked_trip.insurance = this.dupe_booked_trip.data.externalReservations.CHUBB;
		if (this.dupe_booked_trip.data.externalReservations.BOOKING) {
			const data = this.dupe_booked_trip.data.externalReservations.BOOKING.map(selectedHotel => {
				return {
					...selectedHotel,
					value: selectedHotel.amount,
					routeParam: { city: selectedHotel.extraInfo ? this.bookingService.INDRA_getLocation(selectedHotel.extraInfo.city).city : '' },
				};
			});
			this.store.dispatch(new BookedTripActions.PutBookedTripExtrasAction({ type: 'hotel', data: data }));
		}

		if (this.dupe_booked_trip.data.externalReservations.CARTRAWLER) {
			const data = this.dupe_booked_trip.data.externalReservations.CARTRAWLER.map(selectedCar => {
				const payload = {
					product: {
						id: selectedCar.idReservation,
						name: selectedCar.description,
						price: { total: { amount: selectedCar.amount } },
						search: { pickup: { location: { code: selectedCar.extraInfo.city } } }
					}
				};
				return { ...selectedCar, payload };
			});

			this.dupe_booked_trip.rented_car = data;
		}

		if (this.dupe_booked_trip.data.externalReservations.SO_AIRPORT_TRANSFER) {
			const res = this.dupe_booked_trip.data.externalReservations.SO_AIRPORT_TRANSFER[0];
			const airportTransfer = {
				data: { value: res.extraInfo.type },
				value: res.stopOverInfo.SO_AIRPORT_TRANSFER.amount,
				currency: res.stopOverInfo.SO_AIRPORT_TRANSFER.currency,
				stopoverCity: res.idReservation,
				type: 'airport-transfers',
				selectedExtra: [{ externalReservation: res, readOnly: true }]
			};
			this.store.dispatch(new BookedTripActions.PutBookedTripExtrasAction(airportTransfer));
		}

		if (this.dupe_booked_trip.data.externalReservations.SO_LISBON_DISCOUNT) {
			const res = this.dupe_booked_trip.data.externalReservations.SO_LISBON_DISCOUNT[0];
			const lisbonDiscount = {
				value: res.stopOverInfo.SO_LISBON_DISCOUNT.amount,
				currency: res.stopOverInfo.SO_LISBON_DISCOUNT.currency,
				stopoverCity: res.idReservation,
				type: 'lisboa-card',
				selectedExtra: [{ externalReservation: res, readOnly: true }]
			};
			this.store.dispatch(new BookedTripActions.PutBookedTripExtrasAction(lisbonDiscount));
		}

		if (this.dupe_booked_trip.data.externalReservations.SO_SIGHTSEEING_TOUR) {
			const res = this.dupe_booked_trip.data.externalReservations.SO_SIGHTSEEING_TOUR[0];
			let total = 0;
			let currency = '';
			for (const i in res.stopOverInfo) {
				total += res.stopOverInfo[i].amount;
				if (!currency) currency = res.stopOverInfo[i].currency;
			}

			const sightSeeingTour = {
				data: [],
				value: total,
				currency: currency,
				stopoverCity: res.idReservation,
				type: 'sightseeing-tours',
				selectedExtra: [{ externalReservation: res, readOnly: true }]
			};

			this.store.dispatch(new BookedTripActions.PutBookedTripExtrasAction(sightSeeingTour));
		}

		if (this.dupe_booked_trip.discounts && this.dupe_booked_trip.discounts.list.length) {
			this.store.dispatch(new PromoVouchersActions.PutPromoVouchersAction(this.dupe_booked_trip.discounts.list));
		}

		const ancillariesPoints = this.dupe_booked_trip.data.ancillaryBasket ? this.dupe_booked_trip.data.ancillaryBasket.totalPoints : 0;
		if (ancillariesPoints) this.store.dispatch(new AncillariesWithMilesActions.PutProcessAncillary(ancillariesPoints));

		this.booked_trip = this.dupe_booked_trip;

		this.bfmStorage.INDRA_setActiveBookedTrip(this.booked_trip);
		const hasSliderDiscount = this.dupe_booked_trip.data.fare.hasSliderDiscount;

		// update flights in store
		const updatedBookedTrip = _.cloneDeep(this.bookedTrip);
		const updatedOutboundFlight = _.cloneDeep(this.bookedTrip.flights[0]);
		let updatedInboundFlight;

		updatedOutboundFlight.options.currency = this.tripType === TRIP_TYPE_MULTICITY_CODE || this.hasStopover ? this.booked_trip.data.fare.currency : this.currencyService.INDRA_getCurrencySymbol(this.booked_trip.data.fare.currency).unit;
		updatedOutboundFlight.options.price = this.booked_trip.data.fare.listOutbound[0].totalPrice.price;
		updatedOutboundFlight.options.tax = this.booked_trip.data.fare.listOutbound[0].totalPrice.tax


		if (this.tripType !== TRIP_TYPE_MULTICITY_CODE && !this.hasStopover) {
			updatedOutboundFlight.options.brand['offer'].outbound.totalPrice = this.booked_trip.data.fare.listOutbound[0].totalPrice;

			// check if routeType is Round Trip
			if (this.booked_trip.data.fare.listInbound.length) {
				updatedInboundFlight = _.cloneDeep(this.bookedTrip.flights[1]);
				updatedInboundFlight.options.currency = this.currencyService.INDRA_getCurrencySymbol(this.booked_trip.data.fare.currency).unit;
				updatedInboundFlight.options.price = this.booked_trip.data.fare.listInbound[0].totalPrice.price;
				updatedInboundFlight.options.tax = this.booked_trip.data.fare.listInbound[0].totalPrice.tax
				updatedInboundFlight.options.brand['offer'].inbound.totalPrice = this.booked_trip.data.fare.listInbound[0].totalPrice;

				updatedBookedTrip.flights[1] = updatedInboundFlight;
			}
		}

		// if bookAwards update price, taxes and obFee in bookedTrip store
		if (this.bookAwardFlights) {
			if (this.tripType !== TRIP_TYPE_MULTICITY_CODE && !this.hasStopover) {
				if (this.booked_trip.data.fare.listOutbound[0].totalPoints && this.booked_trip.data.fare.listOutbound[0].totalPrice) {
					updatedOutboundFlight.options.brand.offer.outbound.totalPoints.price = this.booked_trip.data.fare.listOutbound[0].totalPoints.price;
					updatedOutboundFlight.options.brand.offer.outbound.totalPrice.tax = this.booked_trip.data.fare.listOutbound[0].totalPrice.tax;
					updatedOutboundFlight.options.brand.offer.outbound.totalPrice.obFee = this.booked_trip.data.fare.listOutbound[0].totalPrice.obFee;
				}

				// sets inbound prices, taxes and obFee if is round trip
				if (this.booked_trip.data.fare.listInbound.length && this.booked_trip.data.fare.listInbound[0].totalPoints
					&& this.booked_trip.data.fare.listInbound[0].totalPrice) {
					updatedInboundFlight.options.brand.offer.inbound.totalPoints.price = this.booked_trip.data.fare.listInbound[0].totalPoints.price;
					updatedInboundFlight.options.brand.offer.inbound.totalPrice.tax = this.booked_trip.data.fare.listInbound[0].totalPrice.tax;
					updatedInboundFlight.options.brand.offer.inbound.totalPrice.obFee = this.booked_trip.data.fare.listInbound[0].totalPrice.obFee;
				}
			} else {
				// update obFee of multicity/stopover to get tax and obFee sum if bookAwards
				if (this.booked_trip.data.fare.listOutbound[0].totalPrice) {
					updatedOutboundFlight.options.obFee = this.booked_trip.data.fare.listOutbound[0].totalPrice.obFee;
				}
			}
		}

		updatedBookedTrip.flights[0] = updatedOutboundFlight;


		// update bookedTrip in store with data from dupe flight
		this.store.dispatch(new BookedTripActions.PutBookedTripAction(updatedBookedTrip));

		// sliderDiscount applies to miles&Go, check if conversationDupe returned 'hasSliderDiscount'
		// if not, reset the current miles&Go discount to avoid reflecting on dupe booking

		if (hasSliderDiscount) {
			const cash = this.dupe_booked_trip.data.fare.flightPrice.totalPrice.sliderDiscount ? this.dupe_booked_trip.data.fare.flightPrice.totalPrice.sliderDiscount : 0;
			const miles = this.dupe_booked_trip.data.fare.flightPrice.totalPoints ? this.dupe_booked_trip.data.fare.flightPrice.totalPoints.price : 0;
			this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction({ cash: cash, miles: miles }));
		} else {
			this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction({ miles: 0, cash: 0 }));
		}

	}

	INDRA_openLearnMoreMiles() {
		this.sidebarService.openSidebar(['use-miles-info']);
	}

	INDRA_milesBalance() {
		return this.userMiles - this.milesSpent;
	}

	INDRA_openUpgradeAccount() {
		this.sidebarService.openSidebar(['upgrade-miles-and-go'], [{ source: UPGRADE_ACCOUNT_SIDEBAR_SOURCE_SLIDER_AND_EXTRAS }]);
	}

	INDRA_userMiles() {
		return this.userMiles;
	}

	// call this normal button if storedOCP is true and paypal is selected
	// note:  dont use operationID that may came from other payment methods, and also dont let the operationID from this paypal transaction
	// be used on other payment method payment attempts
	INDRA_paypalNormalButton() {
		// const operationID = this.paymentService.getPaymentOperationID();
		const userData = this.storage.get('userData');

		const cashPriceStr = this.flightPriceService.INDRA_convertToCorrectDecimalPlace(this.totalFlightPrice.cash.toString());
		const currency = this.totalFlightPrice.currency;

		const createOrderBody = {
			deviceChannel: 'browser',
			sessionId: this.storage.get('token'),
			currency: currency,
			amount: +(cashPriceStr),
			pnr: this.storage.get('bookingPnr'),
			paymentMethodCode: PAYMENT_METHOD_PAYPAL,
			paymentMethod: 'paypal',
			// idOperation: operationID,
			storeOCP: 'false',
			idPaypal: null
		};

		if (userData) {
			createOrderBody['flyTapId'] = userData.airlineID;
		}

		if (this.isBookingPaymentPage) {
			if (this.totalFlightPrice && this.totalFlightPrice.miles) {
				createOrderBody['points'] = this.totalFlightPrice.miles.toString();
			}
		}

		this.paymentLoading = true;

		this.paypalNormalOCPSubscription =
			this._http.post<any>(URL_PAYMENT_PAYPAL_CAPTURE_ORDER_OCP, createOrderBody).subscribe((data) => {
				console.log(JSON.stringify(data));
				// successful if 200 or 211
				if (data && data.status === '200' || data.status === '211') {
					if (data.data && data.data.statusBook) {
						switch (data.data.statusBook) {
							case 'ISSUE_OK':
								this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.SUCCESS_ISSUE_OK);
								break;
							case 'ISSUE_KO':
								this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.SUCCESS_ISSUE_KO);
								break;
							case 'ISSUE_ERROR':
								this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.SUCCESS_ISSUE_ERROR);
								break;
							default:
								this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
								break;
						}
					} else if (data && data.data && data.data.resultFCE === 'REJECT') {
						this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.REJECTED);
					} else {
						this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
					}
				} else if (data && (data.status == '300' || data.status == '301')) {
					this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
				} else {
					this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
				}

				/*
				if (data && data.data) {
					this.storage.set('idOperation', data.data.idOperation);
					this.paymentService.setPaymentOperationID(data.data.idOperation);
				}
				*/
			}, error => {
				this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
			});

		this.allSubs.push(this.paypalNormalOCPSubscription);
	}

	INDRA_handlePaypalPaymentResult() {
		if (this.paypalPaymentResult === PAYPAL_PAYMENT_RESULT.SUCCESS_ISSUE_OK) {
			this.observatory.setData('issueAuthorisedOK', true);
			this.INDRA_handleBackPayment();
		}
		else if (this.paypalPaymentResult === PAYPAL_PAYMENT_RESULT.SUCCESS_ISSUE_KO ||
			this.paypalPaymentResult === PAYPAL_PAYMENT_RESULT.SUCCESS_ISSUE_ERROR) {
			this.observatory.setData('issueAuthorisedKO', true);
			this.INDRA_handleBackPayment();
		} else if (this.paypalPaymentResult === PAYPAL_PAYMENT_RESULT.REJECTED) {
			this.paymentService.setPaymentFormSubmitted(null);
			this.INDRA_paymentRejected();
		} else if (this.paypalPaymentResult === PAYPAL_PAYMENT_RESULT.ERROR) {
			this.paymentService.setPaymentFormSubmitted(null);
			this.INDRA_paymentAttempt();
			if (this.countdownPaymentRefused >= 0) this.INDRA_checkPaymentMethodCount(false);
			this.INDRA_errorPayment();
		} else if (this.paypalPaymentResult === PAYPAL_PAYMENT_RESULT.TECHNICAL_ERROR) {
			this.paymentLoading = false;
			this.confirmedPassengersAndContacts = false;
			this.hasPaymentStepError = true;
		} else if (this.paypalPaymentResult === PAYPAL_PAYMENT_RESULT.PAID_ERROR) {
			this.INDRA_repaymentErrorRedirect();
		}

		if (this.paypalPaymentResult !== PAYPAL_PAYMENT_RESULT.TECHNICAL_ERROR &&
			this.paypalPaymentResult !== PAYPAL_PAYMENT_RESULT.PAID_ERROR) {
			this.INDRA_checkPaymentTries();
		}
	}

	INDRA_handlePRPPaymentResult() {
		if (this.prpPaymentResult === PRP_PAYMENT_RESULT.SUCCESS) {
			this.INDRA_handleBackPayment();
		} else if (this.prpPaymentResult === PRP_PAYMENT_RESULT.REJECTED ||
			this.prpPaymentResult === PRP_PAYMENT_RESULT.ERROR) {
			this.paymentService.setPaymentFormSubmitted(null);
			this.INDRA_errorPayment();
			this.INDRA_paymentAttempt();
			if (this.countdownPaymentRefused >= 0) this.INDRA_checkPaymentMethodCount(false);
			this.INDRA_checkPaymentTries();
		} else if (this.prpPaymentResult === PRP_PAYMENT_RESULT.TECHNICAL_ERROR) {
			this.paymentLoading = false;
			this.confirmedPassengersAndContacts = false;
			this.hasPaymentStepError = true;
		} else if (this.prpPaymentResult === PRP_PAYMENT_RESULT.PAID_ERROR) {
			this.INDRA_repaymentErrorRedirect();
		}
	}

	INDRA_handleGenericPaymentResult() {
		if (this.genericPaymentResult === PAYMENT_RESULT.SUCCESS) {
			// this.INDRA_handleBackPayment(); // not applicable for redirect
		} else if (this.genericPaymentResult === PAYMENT_RESULT.REJECTED ||
			this.genericPaymentResult === PAYMENT_RESULT.ERROR) {
			this.paymentService.setPaymentFormSubmitted(null);
			this.INDRA_errorPayment();
			this.INDRA_paymentAttempt();
			if (this.countdownPaymentRefused >= 0) this.INDRA_checkPaymentMethodCount(false);
			this.INDRA_checkPaymentTries();
		} else if (this.genericPaymentResult === PAYMENT_RESULT.TECHNICAL_ERROR) {
			this.paymentLoading = false;
			this.confirmedPassengersAndContacts = false;
			this.hasPaymentStepError = true;
		} else if (this.genericPaymentResult === PAYMENT_RESULT.PAID_ERROR) {
			this.INDRA_repaymentErrorRedirect();
		}
	}

	INDRA_hasAncillaries() {
		if (this.ancillaryList && this.ancillaryList.itemsAdded.length != 0) {
			return true;
		}
		return false;
	}

	INDRA_getAncillariesPayableByMiles() {
		this.ancillaryList = this.storage.get('INDRAAncillariesShoppingCartService.shoppingCart');
		if (this.ancillaryList != null) {
			if (this.ancillaryList.length != 0) {
				const ancillaryArr = [];
				for (const i in this.ancillaryList.itemsAdded) {
					if (this.INDRA_isPayableWithMiles(this.ancillaryList.itemsAdded[i])) {
						let found = false;
						if (ancillaryArr.length == 0) {
							ancillaryArr.push(Object.assign({}, this.ancillaryList.itemsAdded[i], { count: 1 }));
							found = true;
						} else {
							for (const x in ancillaryArr) {
								if (ancillaryArr[x].type == this.ancillaryList.itemsAdded[i].type) {
									ancillaryArr[x].count = ancillaryArr[x].count + 1;
									ancillaryArr[x].points = ancillaryArr[x].points + this.ancillaryList.itemsAdded[i].points;
									ancillaryArr[x].price = parseFloat(ancillaryArr[x].price) + parseFloat(this.ancillaryList.itemsAdded[i].price);

									const oldPrice = this.ancillaryList.itemsAdded[i].oldPrice ? this.ancillaryList.itemsAdded[i].oldPrice : 0;
									const oldPoints = this.ancillaryList.itemsAdded[i].oldPoints ? this.ancillaryList.itemsAdded[i].oldPoints : 0;
									ancillaryArr[x].oldPrice = ancillaryArr[x].oldPrice ? +ancillaryArr[x].oldPrice + +oldPrice : +oldPrice;
									ancillaryArr[x].oldPoints = ancillaryArr[x].oldPoints ? ancillaryArr[x].oldPoints + oldPoints : oldPoints;
									ancillaryArr[x].discounted = ancillaryArr[x].discounted || this.ancillaryList.itemsAdded[i].discounted ? true : false;
									found = true;
									break;
								}
							}
						}

						if (!found) {
							ancillaryArr.push(Object.assign({}, this.ancillaryList.itemsAdded[i], { count: 1 }));
						}
					}
				}
				return ancillaryArr;
			}
		}

		return [];
	}

	INDRA_getOtherAncillaries(ancillaryType) {
		this.ancillaryList = this.storage.get('INDRAAncillariesShoppingCartService.shoppingCart');
		if (this.ancillaryList && this.ancillaryList.itemsAdded && this.ancillaryList.itemsAdded.length > 0) {
			const ancillaries = this.ancillaryList.itemsAdded.filter(addedItem => addedItem.type === ancillaryType);
			if (ancillaries.length > 0) {
				let price = 0;
				let oldPrice = 0;
				let discounted = false;
				ancillaries.forEach(ancillary => {
					price += parseFloat(ancillary.price);
					oldPrice = ancillary.oldPrice ? oldPrice + ancillary.oldPrice : oldPrice;
					discounted = ancillary.discounted ? true : false;
				});
				return { type: ancillaryType, price: price, oldPrice: oldPrice, discounted: discounted };
			}
		}
		return;
	}

	INDRA_isTapOperated() {
		let isTAPOperated = false;
		const flightTickets = this.bfmStorage.INDRA_getFlightTickets();
		const filteredFlightTicket = flightTickets.filter(flightTicket => flightTicket.type !== 'stopover');
		for (const ticket of filteredFlightTicket) {
			const flightId = ticket.item.details.assignedFlightId ? ticket.item.details.assignedFlightId : 0;
			if (flightId) {
				const flight = this.bookingService.INDRA_getBookedFlightWithSegmentsOperatedByInterlineFlightsOnly(flightId.toString());
				if (flight.listSegment && flight.listSegment.length) {
					isTAPOperated = true;
					break;
				}
			}
		}

		return isTAPOperated;
	}

	INDRA_isFlightApplicableForMGP() {
		return !this.bookAwardFlights && !this.promoCodesAndVoucher.length && this.milesService.conversionRates.length;
	}

	INDRA_isPayableWithMiles(ancillary) {
		if (parseInt(ancillary.price) < 0) {
			return false;
		} else if (ancillary.type == ANCILLARY_PRODUCT_MEAL) {
			return false;
		}

		return true;
	}

	INDRA_updateShoppingCartContent() {
		for (const i in this.ancillaryList.itemsAdded) {
			this.ancillaryList.itemsAdded[i].payWithMiles = false;
		}

		this.storage.set('INDRAAncillariesShoppingCartService.shoppingCart', this.ancillaryList);
		this.store.dispatch(new AncillariesWithMilesActions.PutProcessAncillary(0));
	}

	// TODO revisit the purpose
	INDRA_getWarningRow(index) {
		return (this.isDesktop) ? Math.ceil(index / 3) : Math.ceil(index / 2);
	}

	// TODO revisit the purpose
	INDRA_printWarningGaps(index) {
		if (this.isScreenMobile || !this.passengersInfo || !this.passengersInfo.length) return null;
		for (let i = 0; i < this.passengersInfo.length; i++) {
			if (this.passengersInfo[i].warnings && this.INDRA_getWarningRow(i + 1) === this.INDRA_getWarningRow(index + 1) && index != i) {
				const gap = (this.$passengersSection.nativeElement.querySelector('.details-block__warning')) ? this.$passengersSection.nativeElement.querySelector('.details-block__warning').offsetHeight : 0;

				return { paddingTop: gap + 'px' };
			}
		}

	}

	// TODO revisit the purpose
	INDRA_hasWarning(index) {
		if (!this.passengersInfo || !this.passengersInfo.length) return false;
		for (let i = 0; i < this.passengersInfo.length; i++) {
			if (this.passengersInfo[i].warnings && i === index) return true;
		}
	}

	INDRA_clearBookedTrip() {
		// TODO clear passengers also (?)
		const passengers = [];
		const auxArray: Array<BookingStep> = [];
		if (this.bookedTrip.passengers_info && this.bookedTrip.passengers_info.length) {
			this.bookedTrip.passengers_info.forEach(passenger =>
				passengers.push(Object.assign(new Passenger(), passenger, { warnings: null, autofill: true })));
		}
		this.bookedTrip = Object.assign(new BookedTrip(null, null, null), this.bookedTrip, { passengers_info: passengers });
		this.bookingSteps.forEach(step => { auxArray.push(Object.assign(new BookingStep(null, null), step, { flight_selected: false })); });

		const booked_trips = Object.assign(new BookedTrip([], this.bookedTrip.pnr, this.bookedTrip.booking_type), this.bookedTrip);
		booked_trips.emptyFlights();

		this.store.dispatch(new BookedTripActions.PutBookedTripAction(booked_trips));
		this.store.dispatch(new BookingStepsActions.PutStepsAction(auxArray));
		this.store.dispatch(new BookingStepsActions.PutCurrentStepAction(0));

		this.paymentService.resetPayment();
	}

	INDRA_openLogin() {
		this.modalService.assignComponent(INDRALoginModalComponent);
		this.modalService.open();
	}

	INDRA_signUp() {
		this.sidebarService.openSidebar(['sign-up']);
	}

	/**
	 *	Handles click action of confirm button to proceed with PNR creation and Payment Step 4
	 */
	async INDRA_confirmPassengersAndContacts() {
		this.paymentFormLoading = true;
		this.parallelService.INDRA_setAreCheckboxesCompleted(false);
		if (this.showVisaBox && !this.visaToUSA) {
			this.INDRA_doScroll(`checkbox-usa`);
			this.triedToPay = true;
			return false;
		}
		if (this.showHazmatBox && !this.travelHazmat) {
			this.INDRA_doScroll(`checkbox-hazmat`);
			this.triedToPay = true;
			return false;
		}
		if (this.isBrazilFlight && !this.checkedBR) {
			this.INDRA_doScroll(`checkbox-br`);
			this.triedToPay = true;
			return false;
		}
		if (this.isEgyptFlight && !this.checkedEG) {
			this.INDRA_doScroll(`checkbox-eg`);
			this.triedToPay = true;
			return false;
		}
		if (this.isTurkeyFlight && !this.checkedTR) {
			this.INDRA_doScroll(`checkbox-tr`);
			this.triedToPay = true;
			return false;
		}
		if (this.isChinaFlight && !this.checkedCN) {
			this.INDRA_doScroll(`checkbox-cn`);
			this.triedToPay = true;
			return false;
		}
		if (this.isCanadaFlight && !this.checkedCA) {
			this.INDRA_doScroll(`checkbox-ca`);
			this.triedToPay = true;
			return false;
		}
		if (this.isUnitedKingdomFlight && !this.checkedUK) {
			this.INDRA_doScroll(`checkbox-uk`);
			this.triedToPay = true;
			return false;
		}
		this.parallelService.INDRA_setAreCheckboxesCompleted(true);

		this.hasPNRCreationError = false;
		this.hasPaymentStepError = false;
		this.confirmedPassengersAndContacts = true;
		if (this.saveCookies) {
			this.INDRA_saveCookies();
		}

    setTimeout(() => {
      this.INDRA_doScroll('background-icons-animation__wrapper');
    }, 500)

		const isPNRCreated = !this.isTTTBookingForCompletion && !this.isDupeCompletion ? <boolean>await this.INDRA_createBooking() : true;
		if (isPNRCreated) {
			if (this.isDUPE) {
				this.INDRA_createFlightTickets();
				this.INDRA_getDupeFlightAncillaries();
				this.INDRA_getDupeFlighExternalAncillaries();
				this.INDRA_getDupeFlightDiscounts();
				this.INDRA_getDupeFlightPrice();

				this.bfmStorage.INDRA_setDupeBookedTrip(this.dupe_booked_trip);
			}

			if (!this.paymentMethodsRetreived) {
				await this.INDRA_loadPaymentMethods();

				// Scroll to step 4
				if(this.arePaymentMethodsLoaded) {
					setTimeout(() => {
						this.INDRA_doScroll(`payment-method-section`);
					}, 500);
				}
			}
			await this.INDRA_checkPaymentMethodCount(); // call API to check if FOP count is correct

			if (this.marketPaymentMethods && this.marketPaymentMethods.length > 0) {
				this.INDRA_checkForUpdatedPrices();
				this.INDRA_checkIfEligibleForDiscount();
				this.INDRA_registerGACheckoutFlight();
			} else {
				this.arePaymentMethodsLoaded = this.isZeroCashPayment ? true : false;
				this.hasPaymentStepError = this.isZeroCashPayment ? false : true;
				this.confirmedPassengersAndContacts = this.isZeroCashPayment ? true : false;
			}
			this.googleAnalytics.IBE_GA_setAdditionalStepsPaymentPage('payment');

			const paymentMethod = this.bfmStorage.INDRA_getPaymentMethod();
			this.isPaybyrdEnabled = paymentMethod.data.paybyrdEnabled;
			this.adyenPopUpEnabled = paymentMethod.data.adyenPopUpEnabled;
			if(!this.adyenPopUpEnabled) {
				this.INDRA_initializePaypalScripts();
			}

			this.paymentFormLoading = false;
		} else {
			this.hasPNRCreationError = true;
			this.confirmedPassengersAndContacts = false;
		}
	}

	INDRA_showVoucherNotification() {
		// note: change this logic if and when there can be other reasons why zero cash payment will be possible
		return (this.isZeroCashPayment && this.promoCodesAndVoucher && this.promoCodesAndVoucher.length > 0);
	}

	INDRA_confirmZeroPayment() {
		try {
			if(!this.formIsValid) {
				this.INDRA_doScroll('payment-option__conditions-wrapper');
				return
			}
			this.INDRA_redeemVoucher();
		} catch(error) {
			const errorString = error instanceof Error ? error.message : String(error);
			this.INDRA_reportToKibana(errorString);
		}
	}

	// create a dummy payment card object for zero cash payment scenarios
	INDRA_getDummyPaymentCard(): any {
		this.lastname = this.storage.get('lastname');
		const dataUserPayment: DataUserPayment = new DataUserPayment();
		dataUserPayment.number = '';
		dataUserPayment.isCCHolderTravel = 'NO';
		dataUserPayment.ipAddress = this.clientIPAddress;
		const encrypted = JSON.stringify(dataUserPayment);
		this.creditCardEncrypted = btoa(encrypted);

		const paymentBaseURL = this.isBookingPaymentPage ? 'booking/payment' : 'booking/time-to-think/payment';
		const dataPay = {
			'browserInfo': new BrowserInfo(),
			'deviceChannel': 'browser',
			'deviceFingerPrintId': this.paymentSessionID,
			'merchantAccount': '000000',
			'sessionId': this.storage.get('token'),
			'urlNavegationOk': `my-bookings/view/${this.trip_pnr}/${this.lastname}?issue=`,
			'urlNavegationKo': `${paymentBaseURL}/redirect/${this.trip_pnr}?issue=`,
			'currency': this.currency,
			'amount': '0',
			'pnr': this.trip_pnr,
			'creditCardEncrypted': this.creditCardEncrypted,
			'flyTapId': null
		};

		if (this.isBookingPaymentPage) {
			if (this.totalFlightPrice && this.totalFlightPrice.miles) {
				dataPay['points'] = this.totalFlightPrice.miles.toString();
				this.storage.set('shoppingCartMiles', this.totalFlightPrice.miles); // for GA's use
			}
		}
		if (this.userInfo) {
			dataPay['flyTapId'] = this.userInfo.airlineID;
		}
		if (this.dataPayment && this.dataPayment.data) {
			dataPay['idOperation'] = this.dataPayment.data.idOperation;
		}

		const idOperation = this.paymentService.getPaymentOperationID();
		if (!dataPay['idOperation'] && idOperation) {
			dataPay['idOperation'] = idOperation;
		}

		this.cardNumber = '0000 0000 0000 0000';

		return dataPay;
	}

	INDRA_savePassengerContactDetails(event) {
		this.saveCookies = event.target.checked;
	}

	INDRA_saveCookies() {
		this.selectedPassengers$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.selectedPassengers = value;
				}
			});

		this.contactsInfo = this.bfmStorage.INDRA_getActiveBookInfoPax();

		this.cookieService.delete(COOKIES_VAR_KEY_PASSENGER_DETAILS, '/booking', window.location.hostname);
		this.cookieService.delete(COOKIES_VAR_KEY_PASSENGER_CONTACT_DETAILS, '/booking', window.location.hostname);

		const passengerData: any = [];
		const contactsData = {
			email: this.contactsInfo.email,
			phone: this.contactsInfo.phone,
			phoneCountryCode: this.contactsInfo.phoneCountryCode,
			phoneType: this.contactsInfo.phoneType,
			prefixPhone: this.contactsInfo.prefixPhone,
			secondaryTelephones: this.contactsInfo.secondaryTelephones
		};

		for (const i in this.selectedPassengers) {
			// Only 3 passenger data should be saved in the cookie to avoid exceeding the size limit
			if (passengerData.length <= 3) {
				const tempData = {
					FFid: this.selectedPassengers[i].FFid,
					FFnum: this.selectedPassengers[i].FFnum,
					email: this.selectedPassengers[i].email,
					emergencyData: this.selectedPassengers[i].emergencyData,
					idPax: this.selectedPassengers[i].idPax,
					listTravelDoc: this.selectedPassengers[i].listTravelDoc,
					name: this.selectedPassengers[i].name,
					phone: this.selectedPassengers[i].phone,
					phoneCountryCode: this.selectedPassengers[i].phoneCountryCode,
					phoneType: this.selectedPassengers[i].phoneType,
					residentDocNumber: this.selectedPassengers[i].residentDocNumber,
					residentfiscalNumber: this.selectedPassengers[i].residentfiscalNumber,
					studentDocNumber: this.selectedPassengers[i].studentDocNumber,
					studentfiscalNumber: this.selectedPassengers[i].studentfiscalNumber,
					surname: this.selectedPassengers[i].surname,
					tapCorporateNumber: this.selectedPassengers[i].tapCorporateNumber,
					title: this.selectedPassengers[i].title,
					travelInsurance: this.selectedPassengers[i].travelInsurance,
					typePax: this.selectedPassengers[i].typePax,
					unaccompaniedMinor: this.selectedPassengers[i].unaccompaniedMinor,
					workTrip: this.selectedPassengers[i].workTrip
				};

				passengerData.push(tempData);
			} else {
				break;
			}
		}

		this.cookieService.set(COOKIES_VAR_KEY_PASSENGER_DETAILS, btoa(JSON.stringify(passengerData)), 30, '/booking', window.location.hostname, false, 'Strict');
		this.cookieService.set(COOKIES_VAR_KEY_PASSENGER_CONTACT_DETAILS, btoa(JSON.stringify(contactsData)), 30, '/booking', window.location.hostname, false, 'Strict');
	}

	INDRA_callPassengerAPI() {
		this.INDRA_checkIfUKMarket();
		// append multiple destinations as a parameter for the API call
		let appendedJourneyList = '=';
		if (this.tripType === TRIP_TYPE_MULTICITY_CODE) {
			for (let i = 0; i < this.searchRoute.length; i++) {
				if (this.searchRoute[i]['departure'] != null && this.searchRoute[i]['arrival'] != null) {
					if (i == 0) {
						appendedJourneyList += this.searchRoute[i]['departure']['code'] + '&journeyList=' + this.searchRoute[i]['arrival']['code'];
					} else if (this.searchRoute[i]['departure'] && this.searchRoute[i]['arrival']) {
						appendedJourneyList += '&journeyList=' + this.searchRoute[i]['departure']['code'] + '&journeyList=' + this.searchRoute[i]['arrival']['code'];
					}
				}
			}
		} else {
			// if RT/OW and has more than one searchRoute from multicity then use only index 0
			appendedJourneyList += this.searchRoute[0]['departure']['code'] + '&journeyList=' + this.searchRoute[0]['arrival']['code'];
		}

		const param: INDRABFMAvailablePassengerTypeRequestParam = {
			market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET),
			journeyList: appendedJourneyList,
			tripType: this.tripType,
			isUnitedKingdomMarket: this.isUnitedKingdomMarket
		};

		this.passengerSubscription =
			this.passengerTypeService.getAvailablePassengerTypes(param)
				.subscribe((response: INDRABFMAvailablePassengerTypeResponse) => {
					if (response && response.data && response.status === '200') {
						if (response.data.businessRules != null) {
							this.passengerTypeRules = response.data.businessRules;
							this.passengerTypeService.passengerTypeRules = this.passengerTypeRules;
						} else {
							this.noPassengerAPIResponse = true;
						}
					} else {
						this.noPassengerAPIResponse = true;
					}
				}, error => {
					this.noPassengerAPIResponse = true;
				});

		this.allSubs.push(this.passengerSubscription);
	}

	INDRA_checkIfUKMarket() {
		if (this.tripType !== TRIP_TYPE_MULTICITY_CODE) {
			const searchRouteHasUK = this.searchRoute[0]['departure']['location'].countryName == COUNTRY_CODE_UNITED_KINGDOM ||
				this.searchRoute[0]['arrival']['location'].countryName == COUNTRY_CODE_UNITED_KINGDOM;

			if (searchRouteHasUK) {
				this.isUnitedKingdomMarket = true;
			} else {
				this.isUnitedKingdomMarket = false;
			}

		} else {
			let currentRoutesHasUK;

			for (let i = 0; i < this.searchRoute.length; i++) {
				if (this.searchRoute[i]['departure'] && this.searchRoute[i]['arrival']) {
					if (this.searchRoute[i]['departure']['location'].countryName === COUNTRY_CODE_UNITED_KINGDOM ||
						this.searchRoute[i]['arrival']['location'].countryName === COUNTRY_CODE_UNITED_KINGDOM) {
						currentRoutesHasUK = true;
					}
				}
			}

			if (currentRoutesHasUK) {
				this.isUnitedKingdomMarket = true;
			} else {
				this.isUnitedKingdomMarket = false;
			}
		}

		this.languageMarketService.isUnitedKingdomMarket = this.isUnitedKingdomMarket;
	}

	INDRA_getPriceDisplayInfoText() {
		const originalPrice = this.currencyPipe.transform(this.INDRA_displayPrice('original'));
		if (this.mgpDiscount) {
			const discountedPrice = this.currencyPipe.transform(this.INDRA_displayPrice('discounted'));
			return `${this.INDRA_getTranslation('bookingPayment.text.totalPrice')} <div class=\'price\'><span class=\'original-price\'>${originalPrice}</span> ${discountedPrice}<div>`;
		} else {
			return `${this.INDRA_getTranslation('bookingPayment.text.totalPrice')} <div class=\'price\'>${originalPrice}<div>`;
		}
	}

	INDRA_getOriginalPrice() {
		return this.currencyPipe.transform(this.INDRA_displayPrice('original'));
	}

	INDRA_getDiscountedPrice() {
		return this.currencyPipe.transform(this.INDRA_displayPrice('discounted'));
	}

	INDRA_getSignUpCardTitle() {
		return this.mgpDiscount ? `${this.INDRA_getTranslation('bookingPayment.text.youCanStillSave')} ${this.mgpDiscount} ${this.currencyUnit} ${this.INDRA_getTranslation('bookingPayment.text.inThisBooking2')}` : '';
	}

	INDRA_maintainInBrowserStorage(key: string, value: any) {
		if (value) {
			this.storage.set(key, value);
		} else {
			this.storage.remove(key);
		}
	}

	INDRA_registerGACheckoutFlight() {
		const isEcommerce = true;
		if (this.isTTTPaymentPage) {
			const timeToThink = this.bfmStorage.INDRA_getTimeToThink();
			const origin = this.googleAnalytics.IBE_getOriginAirport(null, isEcommerce);
			const dest = this.googleAnalytics.IBE_getDestinationAirport(null, null, isEcommerce);
			const flightCode = `${origin}-${dest}`;
			const flightName = `${origin}-${dest}`;
			const price = timeToThink.totalFee;
			const eventDataLayerObject = this.googleAnalytics.IBE_createGA_FlightProducts(flightCode, flightName, undefined, undefined, price);
			eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(undefined, EVENT_BOOKING_CREATION_STEP_NO);
			this.googleAnalytics.INDRA_GA_checkout(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
		} else {
			/** create product for TAP ancillaries and third party ancillaries **/

			const ancillaries = this.googleAnalytics.IBE_groupAncillaries(_.cloneDeep(this.ancillaryList));
			const eventDataLayerObject = this.googleAnalytics.IBE_createGA_AncillariesProducts(ancillaries);
			const activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip();
			activeBooking.hotel = this.selectedHotels[0];
			const extras = this.googleAnalytics.IBE_createGA_ExtrasProducts(activeBooking);
			eventDataLayerObject.products = eventDataLayerObject.products.concat(extras.products);
			const thirdPartyAncillaries = this.googleAnalytics.IBE_createGA_ExternalAncillaryProducts(activeBooking);
			eventDataLayerObject.products = eventDataLayerObject.products.concat(thirdPartyAncillaries.products);

			/** create flight product **/
			const cashPrice = this.flightPriceBreakdownSummary && this.flightPriceBreakdownSummary.flightCost && this.flightPriceBreakdownSummary.flightCost.price ?
				this.flightPriceBreakdownSummary.flightCost.price.toFixed(2) : "0";
			const milesFlightPrice = this.flightPriceBreakdownSummary && this.flightPriceBreakdownSummary.flightCost && this.flightPriceBreakdownSummary.flightCost.miles ?
				this.flightPriceBreakdownSummary.flightCost.miles : undefined;

			const origin = this.googleAnalytics.IBE_getOriginAirport(null, isEcommerce);
			const dest = this.googleAnalytics.IBE_getDestinationAirport(null, null, isEcommerce);
			const flightCode = `${origin}-${dest}`;
			const flightName = `${origin}-${dest}`;
			const flightProduct = this.googleAnalytics.IBE_createGA_FlightProducts(flightCode, flightName, undefined, undefined, cashPrice, undefined, milesFlightPrice);
			eventDataLayerObject.products = eventDataLayerObject.products.concat(flightProduct.products);

			/** create GA checkout event **/
			eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(undefined, EVENT_BOOKING_CREATION_STEP_NO);
			this.googleAnalytics.INDRA_GA_checkout(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
		}
	}

	INDRA_isZeroCashPayment() {
		// When other forms of payment (voucher, promocodes, miles) cover the total price
		return this.isZeroCashPayment && !this.hasFOPCountError;
	}

	/**
	 * When registerPurchaseAndSendtoGA = true, the purchase event is triggered immediately and sent to GA. This is
	 * used on scenario where there is no redirection to payment gateway, and the payment was successful.
	 * When registerPurchaseAndSendtoGA = false, the purchase event is generated and saved on session storage
	 * and will only be sent to GA on the confirmation page upon successful payment. This is used when the payment flow
	 * has a possible payment gateway redirection
	 */
	INDRA_registerGAPurchase(registerPurchaseAndSendtoGA: boolean) {
		const currency = this.INDRA_checkCurrency();

		this.storage.remove('gaPurchaseEventObj'); // clear the object in session storage
		const isEcommerce = true;
		if (this.isTTTPaymentPage) {
			const timeToThink = this.bfmStorage.INDRA_getTimeToThink();
			const origin = this.googleAnalytics.IBE_getOriginAirport(null, isEcommerce);
			const dest = this.googleAnalytics.IBE_getDestinationAirport(null, null, isEcommerce);
			const flightCode = `${origin}-${dest}`;
			const flightName = `${origin}-${dest}`;
			const price = timeToThink.totalFee;
			const eventDataLayerObject = this.googleAnalytics.IBE_createGA_FlightProducts(flightCode, flightName, undefined, undefined, price);

			eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(undefined, EVENT_ACTION_PURCHASE, this.trip_pnr, price, undefined, undefined);
			if (registerPurchaseAndSendtoGA) {
				this.googleAnalytics.IBE_GA_purchase(
					currency, eventDataLayerObject, undefined, this.selectedPaymentMethod);
			} else {
				const gaPurchaseEventObj = this.googleAnalytics.IBE_create_GA_purchaseEvent_object(
					currency, eventDataLayerObject, undefined, this.selectedPaymentMethod);
				this.storage.set('gaPurchaseEventObj', gaPurchaseEventObj); // save in session storage
			}
		} else {
			/** create product for TAP ancillaries and third party ancillaries **/

			const ancillaries = this.googleAnalytics.IBE_groupAncillaries(_.cloneDeep(this.ancillaryList));
			const eventDataLayerObject = this.googleAnalytics.IBE_createGA_AncillariesProducts(ancillaries, undefined, this.selectedPaymentMethod);
			const activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip();
			activeBooking.hotel = this.selectedHotels[0];
			const extras = this.googleAnalytics.IBE_createGA_ExtrasProducts(activeBooking, undefined, undefined, this.selectedPaymentMethod);
			eventDataLayerObject.products = eventDataLayerObject.products.concat(extras.products);
			const thirdPartyAncillaries = this.googleAnalytics.IBE_createGA_ExternalAncillaryProducts(activeBooking, undefined, undefined, this.selectedPaymentMethod);
			eventDataLayerObject.products = eventDataLayerObject.products.concat(thirdPartyAncillaries.products);

			/** create flight product **/

			const origin = this.googleAnalytics.IBE_getOriginAirport(null, isEcommerce);
			const dest = this.googleAnalytics.IBE_getDestinationAirport(null, null, isEcommerce);
			const flightCode = `${origin}-${dest}`;
			const flightName = `${origin}-${dest}`;

			const tax = this.flightPriceService.computeSelectedFlightsTotalTax(this.bookedTrip.flights, this.bookedTrip.booking_type, this.bookAwardFlights);
			const finalFlightPrice = this.flightPriceBreakdownSummary && this.flightPriceBreakdownSummary.flightCost && this.flightPriceBreakdownSummary.flightCost.price ?
				this.flightPriceBreakdownSummary.flightCost.price.toFixed(2) : "0";
			const milesFlightPrice = this.flightPriceBreakdownSummary && this.flightPriceBreakdownSummary.flightCost && this.flightPriceBreakdownSummary.flightCost.miles ?
				this.flightPriceBreakdownSummary.flightCost.miles : undefined;

			const flightProduct = this.googleAnalytics.IBE_createGA_FlightProducts(flightCode, flightName, undefined, undefined, finalFlightPrice, undefined, milesFlightPrice, this.selectedPaymentMethod);
			eventDataLayerObject.products = eventDataLayerObject.products.concat(flightProduct.products);

			/** create GA purchase event **/
			const bookingTotalCash = this.flightPriceBreakdownSummary && this.flightPriceBreakdownSummary.bookingTotal && this.flightPriceBreakdownSummary.bookingTotal.amount ?
				this.flightPriceBreakdownSummary.bookingTotal.amount.toFixed(2) : "0";
			const promocodesVouchers = this.promoCodesAndVoucher && this.promoCodesAndVoucher.length ? this.promoCodesAndVoucher.map(promo => promo.code).join(', ') : undefined;

			eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(undefined, EVENT_ACTION_PURCHASE, this.trip_pnr, bookingTotalCash, tax.toString(), promocodesVouchers);
			if (registerPurchaseAndSendtoGA) {
				this.googleAnalytics.IBE_GA_purchase(currency, eventDataLayerObject, undefined, this.selectedPaymentMethod);
			} else {
				const gaPurchaseEventObj = this.googleAnalytics.IBE_create_GA_purchaseEvent_object(currency, eventDataLayerObject, undefined, this.selectedPaymentMethod);
				this.storage.set('gaPurchaseEventObj', gaPurchaseEventObj); // save in session storage
			}
		}
	}

	INDRA_createFlightTickets() {
		let key = 0;
		// outbound flights
		let outboundIndex = 0;
		this.dupe_booked_trip.data.fare.listOutbound.forEach(outbound => {

			const outboundLength = outbound.listSegment.length;
			this.flight_tickets.push({
				type: 'flight',
				id: 'flight-' + key,
				item: {
					details: outbound,
					departureLocation: this.dupe_booked_trip.translate.locations[
						outbound.listSegment[0].departureAirport
					],
					arrivalLocation: this.dupe_booked_trip.translate.locations[
						this.bookingService.INDRA_getLastSegmentFlightIgnoringTrain(outbound.listSegment)['arrivalAirport']
					],
					airLinesTranslation: this.dupe_booked_trip.translate.airlines,
					extras: [] // this.INDRA_filterExtras(outbound.idFlight, outbound.assignedFlightId, outboundSegments)
				},
			});

			outboundIndex++;
			key++;
		});

		// inbound flights
		if (this.dupe_booked_trip.data.fare.listInbound) {
			this.dupe_booked_trip.data.fare.listInbound.forEach(inbound => {
				const inboundLength = inbound.listSegment.length;
				this.flight_tickets.push({
					type: 'flight',
					id: 'flight-' + key,
					item: {
						details: inbound,
						departureLocation: this.dupe_booked_trip.translate.locations[
							inbound.listSegment[0].departureAirport
						],
						arrivalLocation: this.dupe_booked_trip.translate.locations[
							inbound.listSegment[inboundLength - 1].arrivalAirport
						]
					}
				});
				key++;
			});
		}
	}

	INDRA_getDupeFlightPrice() {
		if (this.dupe_booked_trip.data.pnr) {
			const totalDiscounts = this.dupe_booked_trip.discounts ? this.dupe_booked_trip.discounts.total : 0;
			const flightPrice = this.dupe_booked_trip.data.fare.flightPrice.totalPrice ? this.dupe_booked_trip.data.fare.flightPrice.totalPrice.price + totalDiscounts : 0;
			const flightPoints = this.dupe_booked_trip.data.fare.flightPrice.totalPoints ? this.dupe_booked_trip.data.fare.flightPrice.totalPoints.price : 0;
			const ancillariesPrice = this.dupe_booked_trip.data.ancillaryBasket ? this.dupe_booked_trip.data.ancillaryBasket.totalPrice : 0;
			const ancillariesPoints = this.dupe_booked_trip.data.ancillaryBasket ? this.dupe_booked_trip.data.ancillaryBasket.totalPoints : 0;
			const extrasPrice = this.dupe_booked_trip.data.externalReservations ? this.dupe_booked_trip.data.externalReservations.totalPrice : 0;
			const taxAndObfee = this.dupe_booked_trip.data.fare.flightPrice.totalPrice ? this.dupe_booked_trip.data.fare.flightPrice.totalPrice.tax + this.dupe_booked_trip.data.fare.flightPrice.totalPrice.obFee : 0;
			this.dupe_booked_trip.data.fare.flightPrice.totalPrice.price = flightPrice;

			const hasSliderDiscount = !this.bookingService.INDRA_isAward(this.dupe_booked_trip) && (this.dupe_booked_trip.data.fare.flightPrice.totalPrice.sliderDiscount || flightPoints) ? true : false;
			const cash = (flightPrice + ancillariesPrice + extrasPrice) - totalDiscounts;
			const miles = flightPoints + ancillariesPoints;
			let dupeCurrencyUnit;
			if (this.dupeCurrency) {
				dupeCurrencyUnit = this.currencyService.INDRA_getCurrencySymbol(this.dupeCurrency).unit;
			}

			// check first if hasSliderDiscount && totalDiscounts to avoid showing the same slashed price and finalPrice
			this.dupe_booked_trip.data.fare.totalPrice = hasSliderDiscount && totalDiscounts ? `${miles} M + ${cash} ${dupeCurrencyUnit ? dupeCurrencyUnit : this.currencyUnit}` : `${cash} ${dupeCurrencyUnit ? dupeCurrencyUnit : this.currencyUnit}`;
			this.dupe_booked_trip.data.fare.hasSliderDiscount = hasSliderDiscount;

			if (this.tripType == TRIP_TYPE_MULTICITY_CODE && this.bookAwardFlights) {
				this.dupe_booked_trip.data.fare.totalPoints = `${miles} M + ${taxAndObfee} ${dupeCurrencyUnit ? dupeCurrencyUnit : this.currencyUnit}`
			} else {
				this.dupe_booked_trip.data.fare.totalPoints = `${miles} M + ${taxAndObfee + cash} ${dupeCurrencyUnit ? dupeCurrencyUnit : this.currencyUnit}`
			}

			const originalPnrUpdated = _.cloneDeep(this.bfmStorage.originalPNRDetailsResponse);

			// check if dupe flight has adminFee then update OriginalPNRDetailsResponse in session
			// else remove adminFee to avoid reflecting in price breakdown
			if (this.dupe_booked_trip.data.fare.originalFlightPrice.totalPrice.adminFee && this.dupe_booked_trip.data.fare.originalFlightPrice.totalPrice.adminFee.amount) {
				originalPnrUpdated.data.fare.originalFlightPrice.totalPrice.adminFee = this.dupe_booked_trip.data.fare.originalFlightPrice.totalPrice.adminFee;
			} else {
				delete originalPnrUpdated.data.fare.originalFlightPrice.totalPrice.adminFee
			}
			this.bfmStorage.INDRA_setOriginalPNRDetailsResponse(originalPnrUpdated);
		}
	}

	INDRA_getDupeFlightAncillaries() {
		this.dupeShoppingCart = {};
		const itemsAdded = [];
		const selectedAncillaries = this.dupe_booked_trip.data.ancillaryBasket ? this.dupe_booked_trip.data.ancillaryBasket.selectedAncillaries : undefined;
		if (selectedAncillaries) {
			const ancillaries = [];
			Object.keys(selectedAncillaries).forEach(type => {
				const items: [] = selectedAncillaries[type].length > 0 ? selectedAncillaries[type] : [selectedAncillaries[type]];
				items.forEach((item: any) => {
					let ancillary: any = {};
					ancillary.type = item.ancillaryType;
					if (item.journey && item.journey.length) {
						const journey = item.journey.sort((a, b) => (+a.segmentId > +b.segmentId) ? 1 : -1);
						journey.forEach((flight: any) => {
							const details: any = {
								flightId: flight.flightId,
								segmentId: flight.segmentId,
								flightBased: flight.flightBased
							};
							if (flight.passengers && flight.passengers.length) {
								flight.passengers.forEach((pax: any) => {
									details.paxId = pax.paxId;
									if (pax.ancillaryInfo && pax.ancillaryInfo.length) {
										pax.ancillaryInfo.forEach((info: any) => {
											// if (info.emdTicket) {
											ancillary = { ...ancillary, ...details, ...info };
											const index = ancillaries.findIndex(x => x.type === item.ancillaryType && x.flightId === flight.flightId);
											if (index === -1 || !ancillary.flightBased) {
												ancillaries.push({ type: item.ancillaryType, flightId: flight.flightId, segmentId: flight.segmentId, flightBased: flight.flightBased, items: [ancillary] });
											} else if (ancillaries[index].segmentId === ancillary.segmentId) {
												ancillaries[index].items.push(ancillary);
											}
											// }
										});
									}
								});
							}
						})
					}
				});
			});

			let totalPrice = 0;
			let totalPoints = 0;
			ancillaries.forEach(ancillary => {
				const boundAncillaries = [];
				const ancillaryType = ancillary.type;
				let price = 0;
				let points = 0;
				let totalQuantity = 0;
				for (const x in ancillary.items) {
					price = price + (ancillary.items[x].price ? (ancillary.items[x].price * ancillary.items[x].quantity) : 0);
					points = points + (ancillary.items[x].points ? (ancillary.items[x].points * ancillary.items[x].quantity) : 0);
					totalQuantity = totalQuantity + ancillary.items[x].quantity;

					const quantity = ancillary.items[x].quantity;
					for (let i = 0; i < quantity; i++) {
						const item = _.cloneDeep(ancillary.items[x]);
						item.quantity = 1;
						item.payWithMiles = item.points ? true : false;
						item.price = item.payWithMiles ? item.originalPrice : item.price;
						item.flightCardId = ancillary.segmentId;
						itemsAdded.push(item);
					}
				}

				totalPrice += price;
				totalPoints += points;

				boundAncillaries.push({
					flightId: ancillary.flightId,
					assignedFlightId: ancillary.segmentId,
					totalPrice: points ? `${points} M` : `${price} ${this.currencyUnit}`,
					totalQuantity: totalQuantity,
					destination: this.INDRA_getDupeDestination(ancillary.flightId, ancillary.segmentId, ancillary.flightBased),
					payWithMiles: points ? true : false,
					points: points,
					cost: price
				});

				const ancillaryDetail = this.ancillariesService.INDRA_getAncillaryConfig(ancillaryType);

				this.extrasAdded.push({
					ancillaryType: ancillaryType,
					icon: ancillaryDetail.icon,
					name: ancillaryDetail.name,
					journey: boundAncillaries,
				});
			});

			this.dupe_booked_trip.data.ancillaryBasket.totalPrice = totalPrice;
			this.dupe_booked_trip.data.ancillaryBasket.totalPoints = totalPoints;
		}

		this.dupeShoppingCart = { pnr: this.dupe_booked_trip.data.pnr, numItems: itemsAdded.length, itemsAdded: itemsAdded, currency: this.currency };
		this.dupe_booked_trip.data['extrasAdded'] = this.extrasAdded;
	}

	INDRA_getDupeFlighExternalAncillaries() {
		let total = 0;
		if (this.dupe_booked_trip.data.externalReservations.DANISH_FUND) total += this.dupe_booked_trip.data.externalReservations.DANISH_FUND[0].amount;
		if (this.dupe_booked_trip.data.externalReservations.CARBON_OFFSET) total += this.dupe_booked_trip.data.externalReservations.CARBON_OFFSET[0].amount;
		if (this.dupe_booked_trip.data.externalReservations.CHUBB) {
			total += this.dupe_booked_trip.data.externalReservations.CHUBB[0].amount;
			const data = this.dupe_booked_trip.data.externalReservations.CHUBB[0];
			this.dupe_booked_trip.data.externalReservations.CHUBB[0] = { amount: data.amount, insurancePlan: data.extraInfo.insuranceItems };
		}
		if (this.dupe_booked_trip.data.externalReservations.CARTRAWLER) this.dupe_booked_trip.data.externalReservations.CARTRAWLER.forEach(data => total += data.amount);
		if (this.dupe_booked_trip.data.externalReservations.SO_AIRPORT_TRANSFER) total += this.dupe_booked_trip.data.externalReservations.SO_AIRPORT_TRANSFER[0].stopOverInfo.SO_AIRPORT_TRANSFER.amount;
		if (this.dupe_booked_trip.data.externalReservations.SO_LISBON_DISCOUNT) total += this.dupe_booked_trip.data.externalReservations.SO_LISBON_DISCOUNT[0].stopOverInfo.SO_LISBON_DISCOUNT.amount;
		if (this.dupe_booked_trip.data.externalReservations.SO_SIGHTSEEING_TOUR) {
			const extraAncillary = this.dupe_booked_trip.data.externalReservations.SO_SIGHTSEEING_TOUR[0];
			for (const i in extraAncillary.stopOverInfo) {
				total += extraAncillary.stopOverInfo[i].amount;
			}
		}

		this.dupe_booked_trip.data['externalReservations'].totalPrice = total;
	}

	INDRA_getDupeFlightDiscounts() {
		if (this.dupe_booked_trip.discounts && this.dupe_booked_trip.discounts.length) {
			let total = 0;
			const discounts = this.dupe_booked_trip.discounts.map(discount => {
				total += discount.amount;
				return {
					...discount,
					code: discount.id,
					currencyCode: discount.currency,
					status: DISCOUNT_STATUS_ACTIVE,
					amountType: DISCOUNT_AMOUNT_TYPE_FIXED,
					applyTo: discount.appliesTo
				};
			});
			this.dupe_booked_trip.discounts = { total: total, list: discounts };
		}
	}

	INDRA_getDupePrice() {
		return this.bookAwardFlights ? this.dupe_booked_trip.data.fare.totalPoints : this.dupe_booked_trip.data.fare.totalPrice;
	}

	INDRA_getDupeDestination(flightId, segmentId, flightBased) {
		const outboundFlights = this.dupe_booked_trip.data.fare.listOutbound.filter(item => item.idFlight == flightId);
		if (outboundFlights.length) {
			const flight = outboundFlights.find(x => x.assignedFlightId == segmentId);
			const outboundFlight = flight ? flight : outboundFlights[0];
			const dept = outboundFlight.firstSegment.departureAirport;
			const arr = flightBased ? outboundFlights[outboundFlights.length - 1].lastSegment.arrivalAirport : outboundFlight.lastSegment.arrivalAirport;
			return `${this.dupe_booked_trip.translate.locations[dept].city}-${this.dupe_booked_trip.translate.locations[arr].city}`;
		} else {
			const inboundFlight = this.dupe_booked_trip.data.fare.listInbound.find(item => item.idFlight == flightId);
			if (inboundFlight) {
				return `${this.dupe_booked_trip.translate.locations[inboundFlight.firstSegment.departureAirport].city}-${this.dupe_booked_trip.translate.locations[inboundFlight.lastSegment.arrivalAirport].city}`;
			}
		}

		return null;
	}

	INDRA_initializePaypalScripts() {
		this.currency = this.currencyService.INDRA_getCurrencySymbol().name;
		const sdk_src = 'https://www.paypal.com/sdk/js?client-id=' + PAYPAL_CLIENT_ID + '&intent=capture&currency=' + this.currency + '&commit=true&vault=true&components=buttons,funding-eligibility&debug=false';
		const paypal_checkout_min_src = 'https://js.braintreegateway.com/web/3.60.0/js/paypal-checkout.min.js';
		const paypalScript = document.querySelector(`script[src="${paypal_checkout_min_src}"]`) ? true : false;
		const sdkScript = document.querySelector(`script[src="${sdk_src}"]`) ? true : false;
		if (!sdkScript) {
			// Paypal SDK
			var sdk = document.createElement('script');
			sdk.type = 'text/javascript';
			sdk.src = sdk_src;
			document.head.appendChild(sdk);
		}

		if (!paypalScript) {
			// Load the PayPal Checkout component.
			var paypalComponent = document.createElement('script');
			paypalComponent.setAttribute('async', '');
			paypalComponent.type = 'text/javascript';
			paypalComponent.src = paypal_checkout_min_src;
			document.head.appendChild(paypalComponent);
		}
	}

	INDRA_loadPaypalTrackindID() {
		const codeBlockUrl = PAYPAL_CODE_BLOCK_URL;
		const fnScript = document.querySelector(`script[src="${codeBlockUrl}"]`) ? true : false;

		if (this.trackindIDPaypal) {
			var paypalCodeblock = document.createElement('script');
			paypalCodeblock.type = 'application/json';
			paypalCodeblock.setAttribute('fncls', PAYPAL_FNS_PARAMS)
			paypalCodeblock.text = `
				{
					"f":"${this.trackindIDPaypal}",
					"s":"${PAYPAL_FLOW_ID}"
				}
			`;
			document.head.appendChild(paypalCodeblock);

		}
		if (!fnScript && this.trackindIDPaypal) {
			var fnComponent = document.createElement('script');
			fnComponent.type = 'text/javascript';
			fnComponent.src = codeBlockUrl;
			document.head.appendChild(fnComponent);
		}

	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}


	INDRA_getPaxTierList() {
		let tierList = [];
		this.passengers.forEach(data => {
			if (data.tierLevelFF == TAP_MILES_AND_GO_GOLD && tierList.indexOf('GOLD') < 0) {
				tierList.push('GOLD');
			} else if (data.tierLevelFF == TAP_MILES_AND_GO_SILVER && tierList.indexOf('SILVER') < 0) {
				tierList.push('SILVER');
			} else if (data.tierLevelFF == TAP_MILES_AND_GO_MILES && tierList.indexOf('MILES') < 0) {
				tierList.push('MILES');
			} else if (data.tierLevelFF == TAP_MILES_AND_GO_NAVIGATOR && tierList.indexOf('NAVIGATOR') < 0) {
				tierList.push('NAVIGATOR');
			}
		});

		if (tierList.length > 0) {
			if (tierList.length > 1) {
				tierList[tierList.length - 1] = this.INDRA_getTranslation('bookingPayment.text.and') + ' ' + tierList[tierList.length - 1];
			}
			return tierList.join(', ');
		}

		return '';
	}

	INDRA_repaymentTriesLimitErrorRedirect() {
		this.paymentLoading = true;
		this.indraPaymentService.INDRA_bookingPnrExtend();

		const request = {
			sessionId: this.storage.get('token'),
			pnr: this.trip_pnr,
			idOperation: this.paymentService.getPaymentOperationID(),
			typeError: PAYMENT_NOTIFICATION_ERROR_CODE_MAX_PAYMENT_ATTEMPT
		}
		this.indraPaymentService.INDRA_declinedValidation(request);

		this.observatory.setData('repaymentErrorLimitReached', true);
		if (!this.lastname) {
			this.lastname = this.storage.get('lastname');
		}
		setTimeout(() => {
			this.router.navigate(['/my-bookings/view', this.trip_pnr, this.lastname]);
		}, 500);

	}

	INDRA_hasMilesPayable() {
		if (this.milesSpent > 0 || this.bookAwardFlights) {
			return true;
		} else {
			return false;
		}
	}

	INDRA_checkPaymentTries() {
		if (this.countdownPaymentRefused < 0) {
			this.INDRA_repaymentTriesLimitErrorRedirect();
		}
	}

	INDRA_paymentAttempt() {
		this.countdownPaymentRefused--;
		this.storage.set('attempt', this.countdownPaymentRefused);
	}

	overlayLoaderEvent(value) {
		this.paymentLoading = value;
	}

	INDRA_countCombinedNames(passengers) {
		const exceedingNamesId = [];
		passengers.forEach(pax => {
			if (pax.typePax === PAX_TYPE_INFANT_CODE) {
				const infNameLength = pax.name.length + pax.surname.length;
				const adtIdAssociated = pax.infToAdt;

				if (adtIdAssociated) {
					// get name length of adt associated to this inf
					const adtOfInfant = passengers.find(passenger => passenger.idPax === adtIdAssociated);
					if (adtOfInfant) {
						const adtNameLength = adtOfInfant.name.length + adtOfInfant.surname.length;

						// get combined names of adt-inf
						const combinedNamesLength = infNameLength + adtNameLength;

						// if combined names exceeds 33 characters return idPax of adt and inf
						if (combinedNamesLength > 33) {
							exceedingNamesId.push(adtIdAssociated, pax.idPax);
						}
					}

				}
			}
		});

		return exceedingNamesId;
	}

	INDRA_checkForError(passengers) {
		this.passengerWarnings = [];
		if (this.adtInfExceedsCharLimit.length) {
			passengers.forEach((pax, i) => {
				if (this.adtInfExceedsCharLimit.includes(pax.idPax)) {
					this.passengerWarnings[i] = [this.INDRA_getTranslation('bookingPayment.text.reviewName')];
				} else {
					this.passengerWarnings[i] = ['hidden'];
				}
			});
		}
	}

	INDRA_printCreditCardSurchargeAmount() {
		return this.surchargeAmount ? this.surchargeAmount.toFixed(2) + ' ' + this.currencyUnit : '0 ' + this.currencyUnit;
	}

	async INDRA_retrieveAndApplySurchargeAmount(surcharge) {
		// execute only if the current surcharge value > 0 (meaning we are adding the surcharge to the backend session) OR
		// if the current surcharge value is zero while the current surcharge amount > 0 (meaning we are removing the surcharge amount on the backend session)
		if (this.isUpdateCCFeeAPIAllowed && (surcharge > 0 || (surcharge == 0 && this.surchargeAmount > 0))) {
			this.indraPaymentService.INDRA_applyCCFee(surcharge).subscribe((response: any) => {
				this.INDRA_checkPaymentMethodCount(); // surcharge and installment amount are set based on the response of the checkPaymentMethodCount
			}, err => {
				this.INDRA_checkPaymentMethodCount();
			});
		}
	}

	async INDRA_paybyrdCheckOut() {
		try {
			if(!this.acceptedTermsAndConditions) {
				this.INDRA_doScroll('payment-conditions');
				this.submitted = true;
				return
			}

			this.paymentLoading = true;
			this.hasPaybyrdError = false;

			const callback = async () => {
				this.paymentLoading = true;
				this.INDRA_registerGAPurchase(false);

				let totalFlightPrice: INDRATotalFlightPrice = this.totalFlightPrice
				try {
					const checkPaymentMethodsResponse = await this.awaitableObservable(this.indraPaymentService.INDRA_checkPaymentMethods());
					if (checkPaymentMethodsResponse && checkPaymentMethodsResponse.bookingTotal) {
						totalFlightPrice = {
							cash: checkPaymentMethodsResponse.bookingTotal.amount,
							miles: checkPaymentMethodsResponse.bookingTotal.miles,
							currency: checkPaymentMethodsResponse.bookingTotal.currency
						}
					}
				} catch (err) {
				}

				const cashAmountToPay = this.flightPriceService.INDRA_convertToCorrectDecimalPlace(totalFlightPrice.cash.toString());
				const currency = totalFlightPrice.currency;
				const paymentBaseURL = this.isBookingPaymentPage ? 'booking/payment' : 'booking/time-to-think/payment';
				this.lastname = this.storage.get('lastname');

				const dataPay = {
					browserInfo: new BrowserInfo(),
					deviceChannel: 'browser',
					sessionId: this.storage.get('token'),
					currency: currency,
					amount: cashAmountToPay,
					pnr: this.trip_pnr,
					urlNavegationOk: `my-bookings/view/${this.trip_pnr}/${this.lastname}?issue=`,
					urlNavegationKo: `my-bookings/view/${this.trip_pnr}/${this.lastname}?issue=KO`,
					paybyrdHppRedFlag: this.isHPPRedFlagEnabled
				};
				// urlNavegationKo: `${paymentBaseURL}/redirect/${this.trip_pnr}?issue=`
				console.log('checkout: ', dataPay.urlNavegationOk);
				if(this.userInfo){
					dataPay['flyTapId'] = this.userInfo.airlineID;
					if(this.isBookingPaymentPage){
						dataPay['points'] = totalFlightPrice.miles ? totalFlightPrice.miles.toString() : '';
						dataPay['amount'] = totalFlightPrice.cash ? totalFlightPrice.cash.toString() : '';
					}
				}

				let response = null
				try {
					response = await this.awaitableObservable(this.indraPaymentService.INDRA_paybyrdCheckOut(dataPay));
					console.log('checkout: ', response.data.checkoutUrl);
				} catch (err) {
					this.paymentLoading = false;
					this.paymentService.setGenericPaymentResult(PAYMENT_RESULT.ERROR);
				}

				if(response){
					this.checkoutUrl = response.data.checkoutUrl;
					if(response.status === '200' && response.errors.length != 1) {  
						this.modalService.assignComponent(INDRAPaymentPaybyrdModalComponent, {...response, component:"paybyrdModalComponent"});
						this.modalService.open();
						const paymentMethod = this.bfmStorage.INDRA_getPaymentMethod();
						if (dataPay['points'] || this.promoCodesAndVoucher.length > 0){
							this.isHPPRedFlagEnabled = paymentMethod.data.paybyrdHppRedFlag;
							this.indraPaymentService.INDRA_setTriggerHppRedFlag(this.isHPPRedFlagEnabled);
						}
					} else {
						this.hasPaybyrdError = true;
						this.paybyrdErrorMsg = response.errors[0].desc;
					}
					this.paymentLoading = false;
				}
			}

			if (this.promoCodesAndVoucher && this.promoCodesAndVoucher.length > 0) {
				await this.INDRA_redeemVoucher(callback);
			} else {
				await callback()
			}
		} catch(error) {
			const errorString = error instanceof Error ? error.message : String(error);
			this.INDRA_reportToKibana(errorString);
		}
	}

	async INDRA_adyenCheckOut() {
		try {
			if(!this.formIsValid) {
				this.INDRA_doScroll('payment-option__conditions');
				return
			}

			const data = {
				availablePaymentMethods: this.marketPaymentMethods,
				disabledPaymentMethods: this.disabledPaymentMethods,
				disabledTooltipMessage: this.disabledTooltipMessage,
				hasMilesPayable: this.INDRA_hasMilesPayable(),
				displayCovidTermsAndCondition: this.isCanadaFlight,
				paymentMethods: this.bfmStorage.INDRA_getPaymentMethod(),
				paymentInfo: {
					isBookingPaymentPage: this.isBookingPaymentPage,
					isTTTPaymentPage: this.isTTTPaymentPage,
					totalFlightPrice: this.totalFlightPrice,
					INDRA_printTotalPrice: this.INDRA_printTotalPrice(),
					storedOCPPaypal: this.storedOCPPaypal,
					market: this.market,
					promoCodesAndVoucher: this.promoCodesAndVoucher,
					lastname: this.lastname ? this.lastname : this.storage.get('lastname'),
					trip_pnr: this.trip_pnr,
					hasCreateAncillariesError: this.hasCreateAncillariesError,
					paymentSessionID: this.paymentSessionID,
					urlSafe: this.urlSafe,
					bookingPnr: this.storage.get('bookingPnr'),
					trackindIDPaypal: this.trackindIDPaypal
				}
			}
			this.hasAdyenError = false;

			const callback = async () => {
				this.INDRA_registerGAPurchase(false);
				this.modalService.assignComponent(INDRAPaymentAdyenModalComponent, {...data, component:"adyenModalComponent"});
				this.modalService.open();
			}

			if (this.promoCodesAndVoucher && this.promoCodesAndVoucher.length > 0) {
				await this.INDRA_redeemVoucher(callback);
			} else {
				await callback();
			}
		} catch(error) {
			const errorString = error instanceof Error ? error.message : String(error);
			this.INDRA_reportToKibana(errorString);
		}
	}

	INDRA_callCheckPaymentMethod(hasAncillariesHubError) {
		if (hasAncillariesHubError) this.INDRA_checkPaymentMethodCount();
	}

	INDRA_repaymentErrorRedirect() {
		this.paymentLoading = true;
		this.indraPaymentService.INDRA_bookingPnrExtend();

		this.observatory.setData('repaymentErrorLimitReached', true);
		if (!this.lastname) {
			this.lastname = this.storage.get('lastname');
		}
		setTimeout(() => {
			this.router.navigate(['/my-bookings/view', this.trip_pnr, this.lastname]);
		}, 500);
	}

	INDRA_changeStepURL(step: number) {
		// Original change by TAP UX:
		// this.location.replaceState('booking/payment#step'+ step.toString());

		if (this.router.url.includes('/booking/payment')) {
			let paymentUrl;
			switch (step) {
				case 1:
					if (!this.userInfo) paymentUrl = "login";
					break;
				case 2:
					paymentUrl = "passengers";
					break;
				case 3:
					paymentUrl = "contacts";
					break;
				case 4:
					paymentUrl = "payment";
					break;
			};

			if (paymentUrl) this.location.replaceState('booking/' + paymentUrl);
		}
	}

	INDRA_checkCurrency() {
		let currency;
		let bookingCurrency;
		if (this.bookedTrip) {
			bookingCurrency = this.booked_trip.data.fare.currency;
		}

		const sessionCurrency = sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY);
		currency = bookingCurrency && bookingCurrency != sessionCurrency ? bookingCurrency : sessionCurrency;
		return currency;
	}

	/**
	 * Get list of beneficiaries
	 */
	INDRA_retrieveCompanionList(): void {
		const filePromise = this.frequentFlyerIndraService.getCompanionList().toPromise();
		filePromise.then(result => {
			this.numberOfBeneficiaries = result.data.companionList.beneficiaryList.numberOfBeneficiaries;
			this.paxSalutations = this.beneficiaryService.INDRA_formatPaxSalutations(result.data.paxSalutations);

			this.beneficiaryNames.push({
				label: this.beneficiaryService.INDRA_formatCapitalization(this.userData.title) + EMPTY_SPACE
					+ this.userData.firstName + EMPTY_SPACE
					+ this.userData.lastName + EMPTY_SPACE
					+ "(" + this.userData.contactEmail + ")",
				value: PAX_TYPE_SPONSOR,
				disabled: false,
				prefix: this.beneficiaryService.INDRA_formatCapitalization(this.userData.title),
				name: this.userData.firstName,
				surname: this.userData.lastName,
				email: this.userData.contactEmail,
				type: this.beneficiaryService.INDRA_getTypePaxFromSalutation(this.paxSalutations, this.userData.title)
			});

			if (result.data.companionList.beneficiaryList != null || result.data.companionList.beneficiaryList.beneficiary.length > 0) {
				this.beneficiaryList = result.data.companionList.beneficiaryList.beneficiary;
				this.beneficiaryList.forEach((beneficiary, index) => {
					if (beneficiary.personName[0].namePrefix[0] != null) {
						let email = beneficiary.email[0] != null ? EMPTY_SPACE + "(" + beneficiary.email[0] + ")" : "";
						let prefix = this.beneficiaryService.INDRA_formatCapitalization(beneficiary.personName[0].namePrefix[0]);
						let typePax = this.beneficiaryService.INDRA_getTypePaxFromSalutation(this.paxSalutations, prefix);
						this.beneficiaryNames.push({
							label: prefix + EMPTY_SPACE
								+ beneficiary.personName[0].givenName[0] + EMPTY_SPACE
								+ beneficiary.personName[0].surname + email,
							value: index,
							disabled: false,
							prefix: prefix,
							name: beneficiary.personName[0].givenName[0],
							surname: beneficiary.personName[0].surname,
							email: email,
							type: typePax
						});
					}
				});
			} else {
				this.beneficiaryNames = [];
				this.beneficiaryList = [];
			}
			this.beneficiaryService.setBeneficiaryNames(this.beneficiaryNames);
			this.beneficiaryService.setBeneficiaryList(this.beneficiaryList);
			this.beneficiaryService.setNumberOfBeneficiaries(this.numberOfBeneficiaries);
			this.beneficiaryService.setPaxSalutations(this.paxSalutations);
			this.beneficiaryFlag = true;
		});
	}

	INDRA_getAnyManualPassengerEntries() {
		this.beneficiaryService.setPassengers(this.passengers);
		this.benListNewNames = this.passengers.filter(passenger => {
			return (passenger.isNew && passenger.typePax != PAX_TYPE_INFANT_CODE);
		});
		if (this.benListNewNames.length > 0) {
			this.benListNewItems = true;
		}
		return this.benListNewItems;
	}

	// Build Beneficiary List String
	INDRA_buildBenListLabel(): string {
		let newNames: string[] = []
		this.benListNewNames.forEach(newPax => {
			newNames.push(newPax.name.toUpperCase() + " " + newPax.surname.toUpperCase());
		});
		const last2 = newNames.slice(-2);
		const others = newNames.slice(0, newNames.length - 2);
		return others.concat(last2.join(' ' + this.INDRA_getTranslation("bookingPayment.text.and").toUpperCase() + ' ')).join(', ');
	}

	INDRA_isAwardBooking() {
		let awardFlag = this.bfmStorage.INDRA_getActiveBookedTrip().data.award;
		return this.bookAwardFlights ? this.bookAwardFlights : (awardFlag ? awardFlag : false);
	}

	INDRA_redirectTo2() {
	    // if(!(typeof this.checkoutUrl === "string" && this.checkoutUrl.trim().length == 0)){
	    //     window.open(this.checkoutUrl, '_parent')
	    // }
	 }

	 INDRA_redirectTo3() {
	    if(!(typeof this.checkoutUrl === "string" && this.checkoutUrl.trim().length == 0)){
            this.paymentLoadingPaybyrd = true;
            window.open(this.checkoutUrl,"", "width=900,height=700");
        }
    }
    INDRA_onCancelPaybyrd(){
        this.paymentLoadingPaybyrd = false;
    }

	INDRA_acceptTermsAndConditionsChange(event){
		this.acceptedTermsAndConditions = event.target.checked ? true : false;
	}

	INDRA_handleBookingTicketConditions(){
		this.sidebarService.openSidebar(['booking-ticket-conditions']);
	}

	INDRA_close(event) {
		if (event) {
			this.showError = false;
		}
	}

	public INDRA_formReset() {
		this.formAdd.reset();
		this.inputCode = null;
		this.isVoucher = false;
	}

	INDRA_addVoucher() {
		const isPromoEmail = this.formAdd.get('promocode').value && this.formAdd.get('promocodeemail').value;
		const hasPin = this.formAdd.get('promocodepin').value;
		if ( this.formAdd.valid || isPromoEmail ) {
			if (hasPin) {
				this.validatingVoucherPromocode = true;
				this.INDRA_hasPinErrors = false;
				this.INDRA_validateVoucherPin();
			} else {
				if (this.showVoucherPin) {
					this.INDRA_hasPinErrors = this.INDRA_getTranslation('voucherPromocodeSidebar.errorMessage.couldNotValidate');
				} else {
					const value = this.formAdd.get('promocode').value.trim();
					if (this.formAdd.get('promocodeemail')) {
						this.inputEmail = this.formAdd.get('promocodeemail').value.trim();
					}
					
					this.INDRA_hasErrors = false;
					this.validatingVoucherPromocode = true;
					this.INDRA_validateDiscounts(value);
				}
			}
		} else {
			if (this.inputCode && !this.isVoucher) {
				const value = this.formAdd.get('promocode').value.trim();
				this.INDRA_hasErrors = false;
				this.validatingVoucherPromocode = true;
				this.INDRA_validateDiscounts(value);
			} else {
				this.validatingVoucherPromocode = false;
				// this.INDRA_hasErrors = this.bookAwardFlights ? this.INDRA_getTextTranslation('bookingSearch.errorMessage.promocodeRequired') : this.INDRA_getTextTranslation('bookingSearch.errorMessage.discountRequired');
				this.INDRA_hasErrors = this.INDRA_getTranslation('bookingSearch.errorMessage.discountRequired');
			}
		}
		this.isQuantityStage = false;
		this.isTotalAmountSelected = false;
		this.isPartialSelected = false;
	}

	INDRA_validateDiscounts(value) {
		this.showSuccessMessage = false;
		if (this.discounts.length > 1) {
			const voucherFilter = this.discounts.filter(cur => cur.type === DISCOUNT_TYPE_VOUCHER);
			const promoCodeFilter = this.discounts.filter(cur => cur.type === DISCOUNT_TYPE_PROMOCODE);
			if ((voucherFilter.length === 3 && promoCodeFilter.length === 0) ||
				(voucherFilter.length === 2 && promoCodeFilter.length === 1)) {
				this.INDRA_hasErrors = this.INDRA_getTranslation('bookingSearch.errorMessage.discountLimit');
				this.validatingVoucherPromocode = false;
				this.INDRA_formReset();
				return;
			}
		}
		const discountsIdx = this.discounts.findIndex(cur => cur.code == value);
		if (discountsIdx === -1) {
			this.INDRA_validatePromoCode(value);
		} else {
			this.INDRA_hasErrors = this.INDRA_getTranslation('voucherPromocodeSidebar.errorMessage.promoVoucherExists');
			this.validatingVoucherPromocode = false;
		}
	}

	public INDRA_valuechange(event) {
		this.inputCode = event;
		if((this.inputCode.toUpperCase()).includes('VCHDB')){
		    this.isVoucher = false;
			this.showVoucherPin = false;
			this.formAdd.controls['promocodeemail'].setValue(null);
		    this.formAdd.controls['promocodepin'].setValue(null);
		}else{
		    if (this.inputCode.length >= 19 && this.inputCode.length <= 20) {
                this.isVoucher = true;
        	} else {
                this.isVoucher = false;
				this.showVoucherPin = false;
                this.formAdd.controls['promocodeemail'].setValue(null);
				this.formAdd.controls['promocodepin'].setValue(null);
            }
		}
	}

	INDRA_validatePromoCode(value) {
		this.isQuantityStage = false;
		this.promocodeSubscription =
			this.discountService.validateVoucherPromoCode(value, DISCOUNT_TYPE_PROMOCODE, this.bookAwardFlights).subscribe((promo: any) => {

				if (promo.status === '200') {

					const currency = this.currencyService.INDRA_getCurrencySymbol();

					if (!promo.data.basicInfo || !promo.data.basicInfo.currency || !(promo.data.basicInfo.discounts && promo.data.basicInfo.discounts.length)) {
						this.INDRA_hasErrors = this.INDRA_getTranslation('voucherPromocodeSidebar.errorMessage.invalidPromocode');
						this.validatingVoucherPromocode = false;

					} else if (promo.data.basicInfo.currency !== 'FFP' && promo.data.basicInfo.currency !== currency.name) {
						this.INDRA_hasErrors = this.INDRA_getTranslation('bookingSearch.errorMessage.promocodeInvalidCurrency');
						this.validatingVoucherPromocode = false;
						this.discountService.INDRA_removePromoCodeInSession(value); // added because backend api is not validating promocode currency

					} else if (promo.data.basicInfo.currency === 'FFP' && !this.bookAwardFlights) {
						this.INDRA_hasErrors = this.INDRA_getTranslation('voucherPromocodeSidebar.errorMessage.milesPromocode');
						this.validatingVoucherPromocode = false;

					} else {
						const promoCodesIndex = this.discounts.findIndex(cur => cur.type.toLowerCase().trim() == DISCOUNT_TYPE_PROMOCODE);
						if (promoCodesIndex === -1) {
							this.newDiscountList = this.completePromocodeAndVoucherList.filter(x => x.code !== value);
							this.newDiscountList.push({
								code: value,
								type: DISCOUNT_TYPE_PROMOCODE,
								amount: promo.data.basicInfo.discounts[0].discount,
								currencyCode: promo.data.basicInfo.currency !== 'FFP' ? promo.data.basicInfo.currency : 'M',
								status: DISCOUNT_STATUS_ACTIVE,
								amountType: promo.data.basicInfo.discounts[0].amountType === 2 ? DISCOUNT_AMOUNT_TYPE_FIXED : DISCOUNT_AMOUNT_TYPE_PERCENTAGE,
								applyTo: promo.data.extraInfo && promo.data.extraInfo.discounts ? promo.data.extraInfo.discounts[0].applyTo : null,
								actualValue: promo.data.basicInfo.discounts[0].amountType === 2 ? promo.data.basicInfo.discounts[0].discount : 0
							});
							this.store.dispatch(new PromoVouchersActions.PutPromoVouchersAction(this.newDiscountList));
							this.showSuccessMessage = true;
							this.showFormAdd = false;
							this.INDRA_formReset();
						} else {
							this.INDRA_hasErrors = this.INDRA_getTranslation('bookingSearch.errorMessage.promocodeLimit');
						}
						this.validatingVoucherPromocode = false;
					}
				} else {
					const fieldErrors = promo.errors && promo.errors.fieldErrors && promo.errors.fieldErrors.length > 0 ? promo.errors.fieldErrors : [];

					if (promo.status === '400' && fieldErrors.filter(error => error.code === '1083').length > 0) {
						this.INDRA_hasErrors = this.INDRA_getTranslation('voucherPromocodeSidebar.errorMessage.milesPromocode');
						this.validatingVoucherPromocode = false;
					} else {
						this.INDRA_validateVoucher(value);
					}
				}
				
			},
				error => {
					// if promocode validation fails, proceed to validate if the discount is a voucher
					this.INDRA_validateVoucher(value);
				});

		this.allSubs.push(this.promocodeSubscription);
	}

	INDRA_validateVoucher(value) {
		const voucherRequest = {
			'voucher': value,
			'email': this.inputEmail
		};

		this.voucherSubscription =
			this.discountService.validateVoucherPromoCode(voucherRequest, DISCOUNT_TYPE_VOUCHER).subscribe((voucher: any) => {
			if (voucher.status === '200') {
				if (voucher.data === null) {
					// MFA is active for vouchers
					this.showVoucherPin = true;
					this.INDRA_hasPinErrors = false;
					this.validatingVoucherPromocode = false;
				} else {
					this.INDRA_applyVoucherDiscount(value, voucher);
				}
			} else {
				if (voucher.errors && voucher.errors.desc) {
					this.INDRA_hasErrors = this.INDRA_getTranslation('voucherPromocodeSidebar.errorMessage.invalidVoucherNumber');
				} else {
					this.INDRA_hasErrors = this.INDRA_getTranslation('voucherPromocodeSidebar.errorMessage.couldNotValidate');
				}
				this.validatingVoucherPromocode = false;
			}
		},
		err => {
			if (err) {
				this.INDRA_hasErrors = this.INDRA_getTranslation('bookingSearch.errorMessage.couldNotValidate');
				this.validatingVoucherPromocode = false;
			}

		});

    	this.allSubs.push(this.voucherSubscription);
  	}

	INDRA_validateVoucherPin() {
		const value = this.formAdd.get('promocode').value.trim();
		const email = this.formAdd.get('promocodeemail').value.trim();
		const mfaCode = this.formAdd.get('promocodepin').value.trim();

		this.voucherCodeSubscription = 
			this.discountService.INDRA_validateVoucherPin(value, email, mfaCode).subscribe((voucher: any) => {
			if (voucher.status === '200') {
				this.INDRA_applyVoucherDiscount(value, voucher)
			} else {
				if (voucher.status === '403' && voucher.errors.desc) {
					this.INDRA_hasPinErrors = voucher.errors.desc;
				} else {
					this.INDRA_hasPinErrors = this.INDRA_getTranslation('voucherPromocodeSidebar.errorMessage.couldNotValidate');
				}
				this.validatingVoucherPromocode = false;
			}
		}, 
		err => {
			if (err) {
				if (err.status )
				this.INDRA_hasPinErrors = this.INDRA_getTranslation('bookingSearch.errorMessage.couldNotValidate');
				this.validatingVoucherPromocode = false;
			}
		});

		this.allSubs.push(this.voucherCodeSubscription);
		
	}

	INDRA_applyVoucherDiscount(value, voucher) {
		const voucherFilter = this.discounts.filter(cur => cur.type === DISCOUNT_TYPE_VOUCHER);
		if (voucherFilter.length <= 2) {
			this.newDiscountList = this.completePromocodeAndVoucherList.filter(x => x.code !== value);
			this.isQuantityStage = true;
			this.currentVoucherValue = voucher.data.voucher.balance;
			this.currentVoucherCurrency = voucher.data.voucher.currency;
			this.allowPartialBalance = voucher.data.voucher.allowPartialBalance;
			let voucherDiscountObject = {
				code: value,
				type: DISCOUNT_TYPE_VOUCHER,
				amount: voucher.data.voucher.balance,
				currencyCode: voucher.data.voucher.currency,
				status: DISCOUNT_STATUS_ACTIVE,
				amountType: DISCOUNT_AMOUNT_TYPE_FIXED,
				applyTo: DISCOUNT_APPLY_TO_TOTAL,
				actualValue: voucher.data.voucher.balance,
				email: this.inputEmail
			}
			let completePromocodeAndVoucherListTemp = Object.assign([], this.completePromocodeAndVoucherList);
			completePromocodeAndVoucherListTemp.push(voucherDiscountObject);
			this.completePromocodeAndVoucherList = completePromocodeAndVoucherListTemp;
			this.newDiscountList.push(voucherDiscountObject);
			this.discounts.length === 0 ? this.discounts = [voucherDiscountObject] : this.discounts.push(voucherDiscountObject);
			this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(this.newDiscountList));
		} else {
			this.INDRA_hasErrors = this.INDRA_getTranslation('bookingSearch.errorMessage.voucherLimit');
		}
		this.validatingVoucherPromocode = false;
		if (!this.allowPartialBalance) {
			this.showFormAdd = false;
			this.INDRA_checkPaymentMethodCount();
		}
	}

	INDRA_selectVoucher(param: string) {
		if(param) {
			this.showDiscountButton = true;
		}
		this.formAdd.controls['quantity'].setValue(null);
		this.isTotalAmountSelected = 'total' == param;
		this.isPartialSelected = 'partial' == param;
	}

	INDRA_getValue(value){
		this.INDRA_hasQErrors = parseFloat(this.currentVoucherValue)  < parseFloat(value) ? 'Enter an amount lower than the available value or select total amount instead': '';
	}

	INDRA_useDiscount(e: Event){
		e.preventDefault();
		let discountAmount;
		if (this.isHPPRedFlagEnabled) {
			return;
		}

		if(this.INDRA_hasQErrors) return;
		if(this.isPartialSelected && !this.formAdd.get('quantity').value) {
			this.INDRA_hasQErrors = this.INDRA_getTranslation('bookingSearch.errorMessage.discountRequired');
			return;
		}

		const promoItem = this.newDiscountList.find(item => item.code == this.formAdd.get('promocode').value.trim());
		discountAmount = promoItem.amount;
		if(this.isPartialSelected && this.formAdd.get('quantity').value){
			if (promoItem) {
				discountAmount = this.formAdd.get('quantity').value;
				//promoItem.actualValue = this.formAdd.get('quantity').value; // Change the amount to the desired value
			}
			
		}			
		const payload = { voucherCode: promoItem.code, quantity: discountAmount };
		this.partialVoucherSubscription = this.discountService.INDRA_sendVoucherAmount(payload).subscribe(voucher => {
			if(voucher.status === "OK"){
				this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(this.newDiscountList));
				this.INDRA_resetVoucher();
				this.INDRA_formReset();
			} else {
				this.INDRA_removeDiscount({code: promoItem.code});
			}
		});
		this.allSubs.push(this.partialVoucherSubscription);
	}

	setErrorWidth(): string{
		this.error_width = document.getElementById('quantity_partial_actions').clientWidth;
		return this.error_width.toString() + 'px';
	}

	INDRA_resetVoucher(){
		this.currentVoucherValue = '';
		this.currentVoucherCurrency = '';
		this.showDiscountButton = false;
		this.isQuantityStage = false;
		this.isPartialSelected = false;
		this.showSuccessMessage = true;
		this.showFormAdd = false;
	}

	INDRA_addAnotherVoucher() {
		if (this.isHPPRedFlagEnabled) {
			return;
		}

		this.showFormAdd = true;
		this.isQuantityStage = false;
		this.showSuccessMessage = false;
	}

	INDRA_removeDiscount(discount) {
		if (this.isHPPRedFlagEnabled) {
			return;
		}

		this.loading = true;
		this.removeVoucherSubscription = this.discountService.INDRA_removeVoucherInSession(discount.code).subscribe(voucher => {
			if (voucher.status === '200') {
				const currDiscountList = this.completePromocodeAndVoucherList.filter(x => x.code !== discount.code);
				this.newDiscountList = currDiscountList;
				this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(currDiscountList));
				// this.discounts = currDiscountList;
				this.loading = false;
			} else {
				this.removePromocodeSubscription = this.discountService.INDRA_removePromoCodeInSession(discount.code).subscribe(promo => {
					if ((promo.data || promo.status === '406') || promo.errors === null) {
						const currDiscountList = this.completePromocodeAndVoucherList.filter(x => x.code !== discount.code);
						this.newDiscountList = currDiscountList;			
						this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(currDiscountList));
						// this.discounts = currDiscountList;
						this.loading = false;
					} else {
						this.showError = true;
						this.loading = false;
					}
				}, err => {
					if (err) {
						this.showError = true;
						this.loading = false;
					}
				});
			}
		}, error => {
			if (error) {
				this.removePromocodeSubscription = this.discountService.INDRA_removePromoCodeInSession(discount.code).subscribe(promo => {
					if (promo.status === '200' || promo.status === '406' || promo.errors === null) {
						const currDiscountList = this.completePromocodeAndVoucherList.filter(x => x.code !== discount.code);
						this.newDiscountList = currDiscountList;
						this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(currDiscountList));
						// this.discounts = currDiscountList;
						this.loading = false;
					} else {
						this.showError = true;
						this.loading = false;
					}
				}, err => {
					if (err) {
						this.showError = true;
						this.loading = false;
					}
				});
			}
		});

		this.showFormAdd = true;
		this.isQuantityStage = false;
		this.isPartialSelected = false;
		this.isTotalAmountSelected = false;
		this.allSubs.push(this.removeVoucherSubscription);
		this.allSubs.push(this.removePromocodeSubscription);
	}

	private async awaitableObservable(observable): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			observable.pipe(take(1)).subscribe(
				(result) => {
					resolve(result);
				},
				(error) => {
					reject(error);
				},
			);
		});
	}

	getAncillaryLabelTranslation(type) {
		const ancillaryDetail = this.ancillariesService.INDRA_getAncillaryConfig(type)
		if (ancillaryDetail) {
			return 'bookingView.totalSummary.label.' + ancillaryDetail.id
		}

		return '';
	}

	INDRA_isNonZeroPaymentMethod() {
		return this.INDRA_getStatusStep(3).status && !this.INDRA_isDUPE() && !this.INDRA_haveFlighPricesChanged() && this.arePaymentMethodsLoaded && !this.hasPaymentStepError 
			&& !this.INDRA_isZeroCashPayment() && !this.isPaybyrdEnabled && !this.adyenPopUpEnabled;
	}

	INDRA_isAdyenMethod() {
		return this.INDRA_getStatusStep(3).status && !this.INDRA_isDUPE() && !this.INDRA_haveFlighPricesChanged() && this.arePaymentMethodsLoaded && !this.hasPaymentStepError && 
			!this.INDRA_isZeroCashPayment() && !this.isPaybyrdEnabled && this.adyenPopUpEnabled;
	}

	INDRA_isPaybyrdMethod() {
		return this.INDRA_getStatusStep(3).status && !this.INDRA_isDUPE() && !this.INDRA_haveFlighPricesChanged() && this.arePaymentMethodsLoaded && !this.hasPaymentStepError && !this.INDRA_isZeroCashPayment()
			&& this.isPaybyrdEnabled;
	}

	INDRA_isZeroPaymentMethod() {
		return this.INDRA_getStatusStep(3).status && !this.INDRA_isDUPE() && !this.INDRA_haveFlighPricesChanged() && this.arePaymentMethodsLoaded && !this.hasPaymentStepError && this.INDRA_isZeroCashPayment();
	}

	INDRA_resetSelectedFlights() {
		// reset flights for flights-page when going back
		this.INDRA_handleRemoveInsurance();
		const auxArray: Array<BookingStep> = [];
		this.bookingSteps.forEach(step => { auxArray.push(Object.assign(new BookingStep(null, null), step, { flight_selected: false })); });

		const booked_trip = Object.assign(new BookedTrip([], this.bookedTrip.pnr, this.bookedTrip.booking_type), this.bookedTrip);
		booked_trip.emptyFlights();

		this.store.dispatch(new BookedTripActions.PutBookedTripAction(booked_trip));
		this.store.dispatch(new BookingStepsActions.PutStepsAction(auxArray));
		this.store.dispatch(new BookingStepsActions.PutCurrentStepAction(0));
		this.bfmStorage.INDRA_setActiveBookedTrip(null);
	}

	INDRA_handleRemoveInsurance() {
		if (this.bookedTrip.insurance && this.bookedTrip.insurance.length) {
			this.ancillariesService.INDRA_removeExternalReservation('CHUBB');

			const booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
			booked_trip['insurance'] = null;
			this.bfmStorage.INDRA_setActiveBookedTrip(booked_trip);

			const bookTrip = Object.assign(new BookedTrip(null, null, null), this.bookedTrip, { insurance: [] });
			this.store.dispatch(new BookedTripActions.PutBookedTripAction(bookTrip));
		}
	}

	INDRA_clearThirdPartyExtras() {
		const bookTrip = Object.assign(new BookedTrip(null, null, null), this.bookedTrip, { insurance: null });
		this.store.dispatch(new BookedTripActions.PutBookedTripAction(bookTrip));

		if (this.extras.length) {
			this.extras.forEach(extra => {
				this.store.dispatch(new BookedTripActions.RemoveBookedTripExtraAction(extra.type));
			});
		}

		this.ancillariesService.INDRA_removeAllExternalReservation();
		this.INDRA_clearShoppingCart();
		this.store.dispatch(new AncillariesWithMilesActions.ResetAction());
	}

	INDRA_clearShoppingCart() {
		this.storage.set('INDRAAncillariesShoppingCartService.shoppingCart', null);
	}

	INDRA_setFlightTicketsAndFlights() {
		if (this.booked_trip && this.booked_trip.data && this.booked_trip.data.fare.listOutbound) {
			this.booked_trip.data.fare.listOutbound.forEach(outbound => {
				this.outboundCarriers = outbound.listSegment.every(segment => {
					return segment.carrier === 'TP';
				});
			})
		}

		if (this.booked_trip && this.booked_trip.data && this.booked_trip.data.fare.listInbound) {
			this.booked_trip.data.fare.listInbound.forEach(inbound => {
				this.inboundCarriers = inbound.listSegment.every(segment => {
					return segment.carrier === 'TP';
				});
			})
		}
	}

	INDRA_showCarbon() {
		let returnValue = false;
		if (this.booked_trip) {
			if (this.booked_trip.data.fare.tripType === 'R') {
				if (this.inboundCarriers && this.carbonBundle && this.carbonBundle.carbonOffsetProperties && this.outboundCarriers) {
					this.carbonBundlecurrency = this.currencyService.INDRA_getCurrencySymbol(this.carbonBundle.carbonOffsetProperties.currency).unit;
					returnValue = true;
				}
			} else {
				if (this.outboundCarriers && this.carbonBundle && this.carbonBundle.carbonOffsetProperties) {
					this.carbonBundlecurrency = this.currencyService.INDRA_getCurrencySymbol(this.carbonBundle.carbonOffsetProperties.currency).unit;
					returnValue = true;
				}
			}

			return returnValue;
		}

	}

	INDRA_formatCashPrice(price) {
		return this.currencyService.INDRA_formatCash(price);
	}

	INDRA_setThirdPartyAncillaries(thirdPartyCatalog) {
		if (thirdPartyCatalog && thirdPartyCatalog.length > 0) {
			this.carbonBundle = thirdPartyCatalog.find(bundle =>
				bundle.ancillaryList[0].type == EXTRAS_ANCILLARY_CARBON_OFFSET
			);
		}
	}

	INDRA_showError(event) {
		this.showError = event;
	}

	INDRA_reportToKibana(description: string): void {
		const request = {
			transactionType: "PaymentError",
			description
		}
		this.indraPaymentService.INDRA_bookingPnrReportToKibana(request);
	}
}
